(function() {
  "use strict";
  function getDefaultExportFromCjs(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
  }
  var jsxRuntime = { exports: {} };
  var reactJsxRuntime_production_min = {};
  var react = { exports: {} };
  var react_production_min = {};
  /**
   * @license React
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var l$1 = Symbol.for("react.element"), n$1 = Symbol.for("react.portal"), p$2 = Symbol.for("react.fragment"), q$1 = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t$2 = Symbol.for("react.provider"), u = Symbol.for("react.context"), v$1 = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z$1 = Symbol.iterator;
  function A$1(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z$1 && a[z$1] || a["@@iterator"];
    return "function" === typeof a ? a : null;
  }
  var B$1 = { isMounted: function() {
    return false;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, C$1 = Object.assign, D$1 = {};
  function E$1(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D$1;
    this.updater = e || B$1;
  }
  E$1.prototype.isReactComponent = {};
  E$1.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
  };
  E$1.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
  };
  function F() {
  }
  F.prototype = E$1.prototype;
  function G$1(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D$1;
    this.updater = e || B$1;
  }
  var H$1 = G$1.prototype = new F();
  H$1.constructor = G$1;
  C$1(H$1, E$1.prototype);
  H$1.isPureReactComponent = true;
  var I$1 = Array.isArray, J = Object.prototype.hasOwnProperty, K$1 = { current: null }, L$1 = { key: true, ref: true, __self: true, __source: true };
  function M$1(a, b, e) {
    var d, c = {}, k2 = null, h = null;
    if (null != b) for (d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k2 = "" + b.key), b) J.call(b, d) && !L$1.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
      for (var f2 = Array(g), m2 = 0; m2 < g; m2++) f2[m2] = arguments[m2 + 2];
      c.children = f2;
    }
    if (a && a.defaultProps) for (d in g = a.defaultProps, g) void 0 === c[d] && (c[d] = g[d]);
    return { $$typeof: l$1, type: a, key: k2, ref: h, props: c, _owner: K$1.current };
  }
  function N$1(a, b) {
    return { $$typeof: l$1, type: a.type, key: b, ref: a.ref, props: a.props, _owner: a._owner };
  }
  function O$1(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l$1;
  }
  function escape(a) {
    var b = { "=": "=0", ":": "=2" };
    return "$" + a.replace(/[=:]/g, function(a2) {
      return b[a2];
    });
  }
  var P$1 = /\/+/g;
  function Q$1(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
  }
  function R$1(a, b, e, d, c) {
    var k2 = typeof a;
    if ("undefined" === k2 || "boolean" === k2) a = null;
    var h = false;
    if (null === a) h = true;
    else switch (k2) {
      case "string":
      case "number":
        h = true;
        break;
      case "object":
        switch (a.$$typeof) {
          case l$1:
          case n$1:
            h = true;
        }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q$1(h, 0) : d, I$1(c) ? (e = "", null != a && (e = a.replace(P$1, "$&/") + "/"), R$1(c, b, e, "", function(a2) {
      return a2;
    })) : null != c && (O$1(c) && (c = N$1(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P$1, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I$1(a)) for (var g = 0; g < a.length; g++) {
      k2 = a[g];
      var f2 = d + Q$1(k2, g);
      h += R$1(k2, b, e, f2, c);
    }
    else if (f2 = A$1(a), "function" === typeof f2) for (a = f2.call(a), g = 0; !(k2 = a.next()).done; ) k2 = k2.value, f2 = d + Q$1(k2, g++), h += R$1(k2, b, e, f2, c);
    else if ("object" === k2) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
  }
  function S$1(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R$1(a, d, "", "", function(a2) {
      return b.call(e, a2, c++);
    });
    return d;
  }
  function T$1(a) {
    if (-1 === a._status) {
      var b = a._result;
      b = b();
      b.then(function(b2) {
        if (0 === a._status || -1 === a._status) a._status = 1, a._result = b2;
      }, function(b2) {
        if (0 === a._status || -1 === a._status) a._status = 2, a._result = b2;
      });
      -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
  }
  var U$1 = { current: null }, V$1 = { transition: null }, W$1 = { ReactCurrentDispatcher: U$1, ReactCurrentBatchConfig: V$1, ReactCurrentOwner: K$1 };
  function X$1() {
    throw Error("act(...) is not supported in production builds of React.");
  }
  react_production_min.Children = { map: S$1, forEach: function(a, b, e) {
    S$1(a, function() {
      b.apply(this, arguments);
    }, e);
  }, count: function(a) {
    var b = 0;
    S$1(a, function() {
      b++;
    });
    return b;
  }, toArray: function(a) {
    return S$1(a, function(a2) {
      return a2;
    }) || [];
  }, only: function(a) {
    if (!O$1(a)) throw Error("React.Children.only expected to receive a single React element child.");
    return a;
  } };
  react_production_min.Component = E$1;
  react_production_min.Fragment = p$2;
  react_production_min.Profiler = r;
  react_production_min.PureComponent = G$1;
  react_production_min.StrictMode = q$1;
  react_production_min.Suspense = w;
  react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W$1;
  react_production_min.act = X$1;
  react_production_min.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C$1({}, a.props), c = a.key, k2 = a.ref, h = a._owner;
    if (null != b) {
      void 0 !== b.ref && (k2 = b.ref, h = K$1.current);
      void 0 !== b.key && (c = "" + b.key);
      if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
      for (f2 in b) J.call(b, f2) && !L$1.hasOwnProperty(f2) && (d[f2] = void 0 === b[f2] && void 0 !== g ? g[f2] : b[f2]);
    }
    var f2 = arguments.length - 2;
    if (1 === f2) d.children = e;
    else if (1 < f2) {
      g = Array(f2);
      for (var m2 = 0; m2 < f2; m2++) g[m2] = arguments[m2 + 2];
      d.children = g;
    }
    return { $$typeof: l$1, type: a.type, key: c, ref: k2, props: d, _owner: h };
  };
  react_production_min.createContext = function(a) {
    a = { $$typeof: u, _currentValue: a, _currentValue2: a, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null };
    a.Provider = { $$typeof: t$2, _context: a };
    return a.Consumer = a;
  };
  react_production_min.createElement = M$1;
  react_production_min.createFactory = function(a) {
    var b = M$1.bind(null, a);
    b.type = a;
    return b;
  };
  react_production_min.createRef = function() {
    return { current: null };
  };
  react_production_min.forwardRef = function(a) {
    return { $$typeof: v$1, render: a };
  };
  react_production_min.isValidElement = O$1;
  react_production_min.lazy = function(a) {
    return { $$typeof: y, _payload: { _status: -1, _result: a }, _init: T$1 };
  };
  react_production_min.memo = function(a, b) {
    return { $$typeof: x, type: a, compare: void 0 === b ? null : b };
  };
  react_production_min.startTransition = function(a) {
    var b = V$1.transition;
    V$1.transition = {};
    try {
      a();
    } finally {
      V$1.transition = b;
    }
  };
  react_production_min.unstable_act = X$1;
  react_production_min.useCallback = function(a, b) {
    return U$1.current.useCallback(a, b);
  };
  react_production_min.useContext = function(a) {
    return U$1.current.useContext(a);
  };
  react_production_min.useDebugValue = function() {
  };
  react_production_min.useDeferredValue = function(a) {
    return U$1.current.useDeferredValue(a);
  };
  react_production_min.useEffect = function(a, b) {
    return U$1.current.useEffect(a, b);
  };
  react_production_min.useId = function() {
    return U$1.current.useId();
  };
  react_production_min.useImperativeHandle = function(a, b, e) {
    return U$1.current.useImperativeHandle(a, b, e);
  };
  react_production_min.useInsertionEffect = function(a, b) {
    return U$1.current.useInsertionEffect(a, b);
  };
  react_production_min.useLayoutEffect = function(a, b) {
    return U$1.current.useLayoutEffect(a, b);
  };
  react_production_min.useMemo = function(a, b) {
    return U$1.current.useMemo(a, b);
  };
  react_production_min.useReducer = function(a, b, e) {
    return U$1.current.useReducer(a, b, e);
  };
  react_production_min.useRef = function(a) {
    return U$1.current.useRef(a);
  };
  react_production_min.useState = function(a) {
    return U$1.current.useState(a);
  };
  react_production_min.useSyncExternalStore = function(a, b, e) {
    return U$1.current.useSyncExternalStore(a, b, e);
  };
  react_production_min.useTransition = function() {
    return U$1.current.useTransition();
  };
  react_production_min.version = "18.3.1";
  {
    react.exports = react_production_min;
  }
  var reactExports = react.exports;
  const React = /* @__PURE__ */ getDefaultExportFromCjs(reactExports);
  /**
   * @license React
   * react-jsx-runtime.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var f = reactExports, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m$1 = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p$1 = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for (b in a) m$1.call(a, b) && !p$1.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
  }
  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  {
    jsxRuntime.exports = reactJsxRuntime_production_min;
  }
  var jsxRuntimeExports = jsxRuntime.exports;
  var client = {};
  var reactDom = { exports: {} };
  var reactDom_production_min = {};
  var scheduler = { exports: {} };
  var scheduler_production_min = {};
  /**
   * @license React
   * scheduler.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  (function(exports) {
    function f2(a, b) {
      var c = a.length;
      a.push(b);
      a: for (; 0 < c; ) {
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
      }
    }
    function h(a) {
      return 0 === a.length ? null : a[0];
    }
    function k2(a) {
      if (0 === a.length) return null;
      var b = a[0], c = a.pop();
      if (c !== b) {
        a[0] = c;
        a: for (var d = 0, e = a.length, w2 = e >>> 1; d < w2; ) {
          var m2 = 2 * (d + 1) - 1, C2 = a[m2], n2 = m2 + 1, x2 = a[n2];
          if (0 > g(C2, c)) n2 < e && 0 > g(x2, C2) ? (a[d] = x2, a[n2] = c, d = n2) : (a[d] = C2, a[m2] = c, d = m2);
          else if (n2 < e && 0 > g(x2, c)) a[d] = x2, a[n2] = c, d = n2;
          else break a;
        }
      }
      return b;
    }
    function g(a, b) {
      var c = a.sortIndex - b.sortIndex;
      return 0 !== c ? c : a.id - b.id;
    }
    if ("object" === typeof performance && "function" === typeof performance.now) {
      var l2 = performance;
      exports.unstable_now = function() {
        return l2.now();
      };
    } else {
      var p2 = Date, q2 = p2.now();
      exports.unstable_now = function() {
        return p2.now() - q2;
      };
    }
    var r2 = [], t2 = [], u2 = 1, v2 = null, y2 = 3, z2 = false, A2 = false, B2 = false, D2 = "function" === typeof setTimeout ? setTimeout : null, E2 = "function" === typeof clearTimeout ? clearTimeout : null, F2 = "undefined" !== typeof setImmediate ? setImmediate : null;
    "undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function G2(a) {
      for (var b = h(t2); null !== b; ) {
        if (null === b.callback) k2(t2);
        else if (b.startTime <= a) k2(t2), b.sortIndex = b.expirationTime, f2(r2, b);
        else break;
        b = h(t2);
      }
    }
    function H2(a) {
      B2 = false;
      G2(a);
      if (!A2) if (null !== h(r2)) A2 = true, I2(J2);
      else {
        var b = h(t2);
        null !== b && K2(H2, b.startTime - a);
      }
    }
    function J2(a, b) {
      A2 = false;
      B2 && (B2 = false, E2(L2), L2 = -1);
      z2 = true;
      var c = y2;
      try {
        G2(b);
        for (v2 = h(r2); null !== v2 && (!(v2.expirationTime > b) || a && !M2()); ) {
          var d = v2.callback;
          if ("function" === typeof d) {
            v2.callback = null;
            y2 = v2.priorityLevel;
            var e = d(v2.expirationTime <= b);
            b = exports.unstable_now();
            "function" === typeof e ? v2.callback = e : v2 === h(r2) && k2(r2);
            G2(b);
          } else k2(r2);
          v2 = h(r2);
        }
        if (null !== v2) var w2 = true;
        else {
          var m2 = h(t2);
          null !== m2 && K2(H2, m2.startTime - b);
          w2 = false;
        }
        return w2;
      } finally {
        v2 = null, y2 = c, z2 = false;
      }
    }
    var N2 = false, O2 = null, L2 = -1, P2 = 5, Q2 = -1;
    function M2() {
      return exports.unstable_now() - Q2 < P2 ? false : true;
    }
    function R2() {
      if (null !== O2) {
        var a = exports.unstable_now();
        Q2 = a;
        var b = true;
        try {
          b = O2(true, a);
        } finally {
          b ? S2() : (N2 = false, O2 = null);
        }
      } else N2 = false;
    }
    var S2;
    if ("function" === typeof F2) S2 = function() {
      F2(R2);
    };
    else if ("undefined" !== typeof MessageChannel) {
      var T2 = new MessageChannel(), U2 = T2.port2;
      T2.port1.onmessage = R2;
      S2 = function() {
        U2.postMessage(null);
      };
    } else S2 = function() {
      D2(R2, 0);
    };
    function I2(a) {
      O2 = a;
      N2 || (N2 = true, S2());
    }
    function K2(a, b) {
      L2 = D2(function() {
        a(exports.unstable_now());
      }, b);
    }
    exports.unstable_IdlePriority = 5;
    exports.unstable_ImmediatePriority = 1;
    exports.unstable_LowPriority = 4;
    exports.unstable_NormalPriority = 3;
    exports.unstable_Profiling = null;
    exports.unstable_UserBlockingPriority = 2;
    exports.unstable_cancelCallback = function(a) {
      a.callback = null;
    };
    exports.unstable_continueExecution = function() {
      A2 || z2 || (A2 = true, I2(J2));
    };
    exports.unstable_forceFrameRate = function(a) {
      0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P2 = 0 < a ? Math.floor(1e3 / a) : 5;
    };
    exports.unstable_getCurrentPriorityLevel = function() {
      return y2;
    };
    exports.unstable_getFirstCallbackNode = function() {
      return h(r2);
    };
    exports.unstable_next = function(a) {
      switch (y2) {
        case 1:
        case 2:
        case 3:
          var b = 3;
          break;
        default:
          b = y2;
      }
      var c = y2;
      y2 = b;
      try {
        return a();
      } finally {
        y2 = c;
      }
    };
    exports.unstable_pauseExecution = function() {
    };
    exports.unstable_requestPaint = function() {
    };
    exports.unstable_runWithPriority = function(a, b) {
      switch (a) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          a = 3;
      }
      var c = y2;
      y2 = a;
      try {
        return b();
      } finally {
        y2 = c;
      }
    };
    exports.unstable_scheduleCallback = function(a, b, c) {
      var d = exports.unstable_now();
      "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
      switch (a) {
        case 1:
          var e = -1;
          break;
        case 2:
          e = 250;
          break;
        case 5:
          e = 1073741823;
          break;
        case 4:
          e = 1e4;
          break;
        default:
          e = 5e3;
      }
      e = c + e;
      a = { id: u2++, callback: b, priorityLevel: a, startTime: c, expirationTime: e, sortIndex: -1 };
      c > d ? (a.sortIndex = c, f2(t2, a), null === h(r2) && a === h(t2) && (B2 ? (E2(L2), L2 = -1) : B2 = true, K2(H2, c - d))) : (a.sortIndex = e, f2(r2, a), A2 || z2 || (A2 = true, I2(J2)));
      return a;
    };
    exports.unstable_shouldYield = M2;
    exports.unstable_wrapCallback = function(a) {
      var b = y2;
      return function() {
        var c = y2;
        y2 = b;
        try {
          return a.apply(this, arguments);
        } finally {
          y2 = c;
        }
      };
    };
  })(scheduler_production_min);
  {
    scheduler.exports = scheduler_production_min;
  }
  var schedulerExports = scheduler.exports;
  /**
   * @license React
   * react-dom.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var aa = reactExports, ca = schedulerExports;
  function p(a) {
    for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var da = /* @__PURE__ */ new Set(), ea = {};
  function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
  }
  function ha(a, b) {
    ea[a] = b;
    for (a = 0; a < b.length; a++) da.add(b[a]);
  }
  var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
  function oa(a) {
    if (ja.call(ma, a)) return true;
    if (ja.call(la, a)) return false;
    if (ka.test(a)) return ma[a] = true;
    la[a] = true;
    return false;
  }
  function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return false;
    switch (typeof b) {
      case "function":
      case "symbol":
        return true;
      case "boolean":
        if (d) return false;
        if (null !== c) return !c.acceptsBooleans;
        a = a.toLowerCase().slice(0, 5);
        return "data-" !== a && "aria-" !== a;
      default:
        return false;
    }
  }
  function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return true;
    if (d) return false;
    if (null !== c) switch (c.type) {
      case 3:
        return !b;
      case 4:
        return false === b;
      case 5:
        return isNaN(b);
      case 6:
        return isNaN(b) || 1 > b;
    }
    return false;
  }
  function v(a, b, c, d, e, f2, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f2;
    this.removeEmptyString = g;
  }
  var z = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, false, a, null, false, false);
  });
  [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, false, a[1], null, false, false);
  });
  ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a) {
    z[a] = new v(a, 2, false, a.toLowerCase(), null, false, false);
  });
  ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a) {
    z[a] = new v(a, 2, false, a, null, false, false);
  });
  "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, false, a.toLowerCase(), null, false, false);
  });
  ["checked", "multiple", "muted", "selected"].forEach(function(a) {
    z[a] = new v(a, 3, true, a, null, false, false);
  });
  ["capture", "download"].forEach(function(a) {
    z[a] = new v(a, 4, false, a, null, false, false);
  });
  ["cols", "rows", "size", "span"].forEach(function(a) {
    z[a] = new v(a, 6, false, a, null, false, false);
  });
  ["rowSpan", "start"].forEach(function(a) {
    z[a] = new v(a, 5, false, a.toLowerCase(), null, false, false);
  });
  var ra = /[\-:]([a-z])/g;
  function sa(a) {
    return a[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(
      ra,
      sa
    );
    z[b] = new v(b, 1, false, a, null, false, false);
  });
  "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, false, a, "http://www.w3.org/1999/xlink", false, false);
  });
  ["xml:base", "xml:lang", "xml:space"].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, false, a, "http://www.w3.org/XML/1998/namespace", false, false);
  });
  ["tabIndex", "crossOrigin"].forEach(function(a) {
    z[a] = new v(a, 1, false, a.toLowerCase(), null, false, false);
  });
  z.xlinkHref = new v("xlinkHref", 1, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
  ["src", "href", "action", "formAction"].forEach(function(a) {
    z[a] = new v(a, 1, false, a.toLowerCase(), null, true, true);
  });
  function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? false : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && true === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
  }
  var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
  var Ia = Symbol.for("react.offscreen");
  var Ja = Symbol.iterator;
  function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
  }
  var A = Object.assign, La;
  function Ma(a) {
    if (void 0 === La) try {
      throw Error();
    } catch (c) {
      var b = c.stack.trim().match(/\n( *(at )?)/);
      La = b && b[1] || "";
    }
    return "\n" + La + a;
  }
  var Na = false;
  function Oa(a, b) {
    if (!a || Na) return "";
    Na = true;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (b) if (b = function() {
        throw Error();
      }, Object.defineProperty(b.prototype, "props", { set: function() {
        throw Error();
      } }), "object" === typeof Reflect && Reflect.construct) {
        try {
          Reflect.construct(b, []);
        } catch (l2) {
          var d = l2;
        }
        Reflect.construct(a, [], b);
      } else {
        try {
          b.call();
        } catch (l2) {
          d = l2;
        }
        a.call(b.prototype);
      }
      else {
        try {
          throw Error();
        } catch (l2) {
          d = l2;
        }
        a();
      }
    } catch (l2) {
      if (l2 && d && "string" === typeof l2.stack) {
        for (var e = l2.stack.split("\n"), f2 = d.stack.split("\n"), g = e.length - 1, h = f2.length - 1; 1 <= g && 0 <= h && e[g] !== f2[h]; ) h--;
        for (; 1 <= g && 0 <= h; g--, h--) if (e[g] !== f2[h]) {
          if (1 !== g || 1 !== h) {
            do
              if (g--, h--, 0 > h || e[g] !== f2[h]) {
                var k2 = "\n" + e[g].replace(" at new ", " at ");
                a.displayName && k2.includes("<anonymous>") && (k2 = k2.replace("<anonymous>", a.displayName));
                return k2;
              }
            while (1 <= g && 0 <= h);
          }
          break;
        }
      }
    } finally {
      Na = false, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
  }
  function Pa(a) {
    switch (a.tag) {
      case 5:
        return Ma(a.type);
      case 16:
        return Ma("Lazy");
      case 13:
        return Ma("Suspense");
      case 19:
        return Ma("SuspenseList");
      case 0:
      case 2:
      case 15:
        return a = Oa(a.type, false), a;
      case 11:
        return a = Oa(a.type.render, false), a;
      case 1:
        return a = Oa(a.type, true), a;
      default:
        return "";
    }
  }
  function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch (a) {
      case ya:
        return "Fragment";
      case wa:
        return "Portal";
      case Aa:
        return "Profiler";
      case za:
        return "StrictMode";
      case Ea:
        return "Suspense";
      case Fa:
        return "SuspenseList";
    }
    if ("object" === typeof a) switch (a.$$typeof) {
      case Ca:
        return (a.displayName || "Context") + ".Consumer";
      case Ba:
        return (a._context.displayName || "Context") + ".Provider";
      case Da:
        var b = a.render;
        a = a.displayName;
        a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        return a;
      case Ga:
        return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
      case Ha:
        b = a._payload;
        a = a._init;
        try {
          return Qa(a(b));
        } catch (c) {
        }
    }
    return null;
  }
  function Ra(a) {
    var b = a.type;
    switch (a.tag) {
      case 24:
        return "Cache";
      case 9:
        return (b.displayName || "Context") + ".Consumer";
      case 10:
        return (b._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return b;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return Qa(b);
      case 8:
        return b === za ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if ("function" === typeof b) return b.displayName || b.name || null;
        if ("string" === typeof b) return b;
    }
    return null;
  }
  function Sa(a) {
    switch (typeof a) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return a;
      case "object":
        return a;
      default:
        return "";
    }
  }
  function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
  }
  function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
      var e = c.get, f2 = c.set;
      Object.defineProperty(a, b, { configurable: true, get: function() {
        return e.call(this);
      }, set: function(a2) {
        d = "" + a2;
        f2.call(this, a2);
      } });
      Object.defineProperty(a, b, { enumerable: c.enumerable });
      return { getValue: function() {
        return d;
      }, setValue: function(a2) {
        d = "" + a2;
      }, stopTracking: function() {
        a._valueTracker = null;
        delete a[b];
      } };
    }
  }
  function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
  }
  function Wa(a) {
    if (!a) return false;
    var b = a._valueTracker;
    if (!b) return true;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), true) : false;
  }
  function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
      return a.activeElement || a.body;
    } catch (b) {
      return a.body;
    }
  }
  function Ya(a, b) {
    var c = b.checked;
    return A({}, b, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: null != c ? c : a._wrapperState.initialChecked });
  }
  function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = { initialChecked: d, initialValue: c, controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value };
  }
  function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, false);
  }
  function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) if ("number" === d) {
      if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
    } else a.value !== "" + c && (a.value = "" + c);
    else if ("submit" === d || "reset" === d) {
      a.removeAttribute("value");
      return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
  }
  function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
      var d = b.type;
      if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
      b = "" + a._wrapperState.initialValue;
      c || b === a.value || (a.value = b);
      a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
  }
  function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
  }
  var eb = Array.isArray;
  function fb(a, b, c, d) {
    a = a.options;
    if (b) {
      b = {};
      for (var e = 0; e < c.length; e++) b["$" + c[e]] = true;
      for (c = 0; c < a.length; c++) e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = true);
    } else {
      c = "" + Sa(c);
      b = null;
      for (e = 0; e < a.length; e++) {
        if (a[e].value === c) {
          a[e].selected = true;
          d && (a[e].defaultSelected = true);
          return;
        }
        null !== b || a[e].disabled || (b = a[e]);
      }
      null !== b && (b.selected = true);
    }
  }
  function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, { value: void 0, defaultValue: void 0, children: "" + a._wrapperState.initialValue });
  }
  function hb(a, b) {
    var c = b.value;
    if (null == c) {
      c = b.children;
      b = b.defaultValue;
      if (null != c) {
        if (null != b) throw Error(p(92));
        if (eb(c)) {
          if (1 < c.length) throw Error(p(93));
          c = c[0];
        }
        b = c;
      }
      null == b && (b = "");
      c = b;
    }
    a._wrapperState = { initialValue: Sa(c) };
  }
  function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
  }
  function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
  }
  function kb(a) {
    switch (a) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
  }
  var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
      MSApp.execUnsafeLocalFunction(function() {
        return a(b, c, d, e);
      });
    } : a;
  }(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
      mb = mb || document.createElement("div");
      mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
      for (b = mb.firstChild; a.firstChild; ) a.removeChild(a.firstChild);
      for (; b.firstChild; ) a.appendChild(b.firstChild);
    }
  });
  function ob(a, b) {
    if (b) {
      var c = a.firstChild;
      if (c && c === a.lastChild && 3 === c.nodeType) {
        c.nodeValue = b;
        return;
      }
    }
    a.textContent = b;
  }
  var pb = {
    animationIterationCount: true,
    aspectRatio: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridArea: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
  }, qb = ["Webkit", "ms", "Moz", "O"];
  Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
      b = b + a.charAt(0).toUpperCase() + a.substring(1);
      pb[b] = pb[a];
    });
  });
  function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
  }
  function sb(a, b) {
    a = a.style;
    for (var c in b) if (b.hasOwnProperty(c)) {
      var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
      "float" === c && (c = "cssFloat");
      d ? a.setProperty(c, e) : a[c] = e;
    }
  }
  var tb = A({ menuitem: true }, { area: true, base: true, br: true, col: true, embed: true, hr: true, img: true, input: true, keygen: true, link: true, meta: true, param: true, source: true, track: true, wbr: true });
  function ub(a, b) {
    if (b) {
      if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
      if (null != b.dangerouslySetInnerHTML) {
        if (null != b.children) throw Error(p(60));
        if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
      }
      if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
  }
  function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch (a) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return false;
      default:
        return true;
    }
  }
  var wb = null;
  function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
  }
  var yb = null, zb = null, Ab = null;
  function Bb(a) {
    if (a = Cb(a)) {
      if ("function" !== typeof yb) throw Error(p(280));
      var b = a.stateNode;
      b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
  }
  function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [a] : zb = a;
  }
  function Fb() {
    if (zb) {
      var a = zb, b = Ab;
      Ab = zb = null;
      Bb(a);
      if (b) for (a = 0; a < b.length; a++) Bb(b[a]);
    }
  }
  function Gb(a, b) {
    return a(b);
  }
  function Hb() {
  }
  var Ib = false;
  function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = true;
    try {
      return Gb(a, b, c);
    } finally {
      if (Ib = false, null !== zb || null !== Ab) Hb(), Fb();
    }
  }
  function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch (b) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
        a = !d;
        break a;
      default:
        a = false;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
  }
  var Lb = false;
  if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", { get: function() {
      Lb = true;
    } });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
  } catch (a) {
    Lb = false;
  }
  function Nb(a, b, c, d, e, f2, g, h, k2) {
    var l2 = Array.prototype.slice.call(arguments, 3);
    try {
      b.apply(c, l2);
    } catch (m2) {
      this.onError(m2);
    }
  }
  var Ob = false, Pb = null, Qb = false, Rb = null, Sb = { onError: function(a) {
    Ob = true;
    Pb = a;
  } };
  function Tb(a, b, c, d, e, f2, g, h, k2) {
    Ob = false;
    Pb = null;
    Nb.apply(Sb, arguments);
  }
  function Ub(a, b, c, d, e, f2, g, h, k2) {
    Tb.apply(this, arguments);
    if (Ob) {
      if (Ob) {
        var l2 = Pb;
        Ob = false;
        Pb = null;
      } else throw Error(p(198));
      Qb || (Qb = true, Rb = l2);
    }
  }
  function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for (; b.return; ) b = b.return;
    else {
      a = b;
      do
        b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
      while (a);
    }
    return 3 === b.tag ? c : null;
  }
  function Wb(a) {
    if (13 === a.tag) {
      var b = a.memoizedState;
      null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
      if (null !== b) return b.dehydrated;
    }
    return null;
  }
  function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
  }
  function Yb(a) {
    var b = a.alternate;
    if (!b) {
      b = Vb(a);
      if (null === b) throw Error(p(188));
      return b !== a ? null : a;
    }
    for (var c = a, d = b; ; ) {
      var e = c.return;
      if (null === e) break;
      var f2 = e.alternate;
      if (null === f2) {
        d = e.return;
        if (null !== d) {
          c = d;
          continue;
        }
        break;
      }
      if (e.child === f2.child) {
        for (f2 = e.child; f2; ) {
          if (f2 === c) return Xb(e), a;
          if (f2 === d) return Xb(e), b;
          f2 = f2.sibling;
        }
        throw Error(p(188));
      }
      if (c.return !== d.return) c = e, d = f2;
      else {
        for (var g = false, h = e.child; h; ) {
          if (h === c) {
            g = true;
            c = e;
            d = f2;
            break;
          }
          if (h === d) {
            g = true;
            d = e;
            c = f2;
            break;
          }
          h = h.sibling;
        }
        if (!g) {
          for (h = f2.child; h; ) {
            if (h === c) {
              g = true;
              c = f2;
              d = e;
              break;
            }
            if (h === d) {
              g = true;
              d = f2;
              c = e;
              break;
            }
            h = h.sibling;
          }
          if (!g) throw Error(p(189));
        }
      }
      if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
  }
  function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
  }
  function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for (a = a.child; null !== a; ) {
      var b = $b(a);
      if (null !== b) return b;
      a = a.sibling;
    }
    return null;
  }
  var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
  function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
      lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {
    }
  }
  var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
  function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
  }
  var rc = 64, sc = 4194304;
  function tc(a) {
    switch (a & -a) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return a & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return a & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return a;
    }
  }
  function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f2 = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
      var h = g & ~e;
      0 !== h ? d = tc(h) : (f2 &= g, 0 !== f2 && (d = tc(f2)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f2 && (d = tc(f2));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f2 = b & -b, e >= f2 || 16 === e && 0 !== (f2 & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for (a = a.entanglements, b &= d; 0 < b; ) c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
  }
  function vc(a, b) {
    switch (a) {
      case 1:
      case 2:
      case 4:
        return b + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return b + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function wc(a, b) {
    for (var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f2 = a.pendingLanes; 0 < f2; ) {
      var g = 31 - oc(f2), h = 1 << g, k2 = e[g];
      if (-1 === k2) {
        if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
      } else k2 <= b && (a.expiredLanes |= h);
      f2 &= ~h;
    }
  }
  function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
  }
  function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
  }
  function zc(a) {
    for (var b = [], c = 0; 31 > c; c++) b.push(a);
    return b;
  }
  function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
  }
  function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for (a = a.expirationTimes; 0 < c; ) {
      var e = 31 - oc(c), f2 = 1 << e;
      b[e] = 0;
      d[e] = -1;
      a[e] = -1;
      c &= ~f2;
    }
  }
  function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for (a = a.entanglements; c; ) {
      var d = 31 - oc(c), e = 1 << d;
      e & b | a[d] & b && (a[d] |= b);
      c &= ~e;
    }
  }
  var C = 0;
  function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
  }
  var Ec, Fc, Gc, Hc, Ic, Jc = false, Kc = [], Lc = null, Mc = null, Nc = null, Oc = /* @__PURE__ */ new Map(), Pc = /* @__PURE__ */ new Map(), Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function Sc(a, b) {
    switch (a) {
      case "focusin":
      case "focusout":
        Lc = null;
        break;
      case "dragenter":
      case "dragleave":
        Mc = null;
        break;
      case "mouseover":
      case "mouseout":
        Nc = null;
        break;
      case "pointerover":
      case "pointerout":
        Oc.delete(b.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Pc.delete(b.pointerId);
    }
  }
  function Tc(a, b, c, d, e, f2) {
    if (null === a || a.nativeEvent !== f2) return a = { blockedOn: b, domEventName: c, eventSystemFlags: d, nativeEvent: f2, targetContainers: [e] }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
  }
  function Uc(a, b, c, d, e) {
    switch (b) {
      case "focusin":
        return Lc = Tc(Lc, a, b, c, d, e), true;
      case "dragenter":
        return Mc = Tc(Mc, a, b, c, d, e), true;
      case "mouseover":
        return Nc = Tc(Nc, a, b, c, d, e), true;
      case "pointerover":
        var f2 = e.pointerId;
        Oc.set(f2, Tc(Oc.get(f2) || null, a, b, c, d, e));
        return true;
      case "gotpointercapture":
        return f2 = e.pointerId, Pc.set(f2, Tc(Pc.get(f2) || null, a, b, c, d, e)), true;
    }
    return false;
  }
  function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
      var c = Vb(b);
      if (null !== c) {
        if (b = c.tag, 13 === b) {
          if (b = Wb(c), null !== b) {
            a.blockedOn = b;
            Ic(a.priority, function() {
              Gc(c);
            });
            return;
          }
        } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
          a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
          return;
        }
      }
    }
    a.blockedOn = null;
  }
  function Xc(a) {
    if (null !== a.blockedOn) return false;
    for (var b = a.targetContainers; 0 < b.length; ) {
      var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
      if (null === c) {
        c = a.nativeEvent;
        var d = new c.constructor(c.type, c);
        wb = d;
        c.target.dispatchEvent(d);
        wb = null;
      } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, false;
      b.shift();
    }
    return true;
  }
  function Zc(a, b, c) {
    Xc(a) && c.delete(b);
  }
  function $c() {
    Jc = false;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
  }
  function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = true, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
  }
  function bd(a) {
    function b(b2) {
      return ad(b2, a);
    }
    if (0 < Kc.length) {
      ad(Kc[0], a);
      for (var c = 1; c < Kc.length; c++) {
        var d = Kc[c];
        d.blockedOn === a && (d.blockedOn = null);
      }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for (c = 0; c < Qc.length; c++) d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for (; 0 < Qc.length && (c = Qc[0], null === c.blockedOn); ) Vc(c), null === c.blockedOn && Qc.shift();
  }
  var cd = ua.ReactCurrentBatchConfig, dd = true;
  function ed(a, b, c, d) {
    var e = C, f2 = cd.transition;
    cd.transition = null;
    try {
      C = 1, fd(a, b, c, d);
    } finally {
      C = e, cd.transition = f2;
    }
  }
  function gd(a, b, c, d) {
    var e = C, f2 = cd.transition;
    cd.transition = null;
    try {
      C = 4, fd(a, b, c, d);
    } finally {
      C = e, cd.transition = f2;
    }
  }
  function fd(a, b, c, d) {
    if (dd) {
      var e = Yc(a, b, c, d);
      if (null === e) hd(a, b, d, id, c), Sc(a, d);
      else if (Uc(e, a, b, c, d)) d.stopPropagation();
      else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
        for (; null !== e; ) {
          var f2 = Cb(e);
          null !== f2 && Ec(f2);
          f2 = Yc(a, b, c, d);
          null === f2 && hd(a, b, d, id, c);
          if (f2 === e) break;
          e = f2;
        }
        null !== e && d.stopPropagation();
      } else hd(a, b, d, null, c);
    }
  }
  var id = null;
  function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) if (b = Vb(a), null === b) a = null;
    else if (c = b.tag, 13 === c) {
      a = Wb(b);
      if (null !== a) return a;
      a = null;
    } else if (3 === c) {
      if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
      a = null;
    } else b !== a && (a = null);
    id = a;
    return null;
  }
  function jd(a) {
    switch (a) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (ec()) {
          case fc:
            return 1;
          case gc:
            return 4;
          case hc:
          case ic:
            return 16;
          case jc:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var kd = null, ld = null, md = null;
  function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f2 = e.length;
    for (a = 0; a < c && b[a] === e[a]; a++) ;
    var g = c - a;
    for (d = 1; d <= g && b[c - d] === e[f2 - d]; d++) ;
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
  }
  function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
  }
  function pd() {
    return true;
  }
  function qd() {
    return false;
  }
  function rd(a) {
    function b(b2, d, e, f2, g) {
      this._reactName = b2;
      this._targetInst = e;
      this.type = d;
      this.nativeEvent = f2;
      this.target = g;
      this.currentTarget = null;
      for (var c in a) a.hasOwnProperty(c) && (b2 = a[c], this[c] = b2 ? b2(f2) : f2[c]);
      this.isDefaultPrevented = (null != f2.defaultPrevented ? f2.defaultPrevented : false === f2.returnValue) ? pd : qd;
      this.isPropagationStopped = qd;
      return this;
    }
    A(b.prototype, { preventDefault: function() {
      this.defaultPrevented = true;
      var a2 = this.nativeEvent;
      a2 && (a2.preventDefault ? a2.preventDefault() : "unknown" !== typeof a2.returnValue && (a2.returnValue = false), this.isDefaultPrevented = pd);
    }, stopPropagation: function() {
      var a2 = this.nativeEvent;
      a2 && (a2.stopPropagation ? a2.stopPropagation() : "unknown" !== typeof a2.cancelBubble && (a2.cancelBubble = true), this.isPropagationStopped = pd);
    }, persist: function() {
    }, isPersistent: pd });
    return b;
  }
  var sd = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(a) {
    return a.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, td = rd(sd), ud = A({}, sd, { view: 0, detail: 0 }), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: zd, button: 0, buttons: 0, relatedTarget: function(a) {
    return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
  }, movementX: function(a) {
    if ("movementX" in a) return a.movementX;
    a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
    return wd;
  }, movementY: function(a) {
    return "movementY" in a ? a.movementY : xd;
  } }), Bd = rd(Ad), Cd = A({}, Ad, { dataTransfer: 0 }), Dd = rd(Cd), Ed = A({}, ud, { relatedTarget: 0 }), Fd = rd(Ed), Gd = A({}, sd, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Hd = rd(Gd), Id = A({}, sd, { clipboardData: function(a) {
    return "clipboardData" in a ? a.clipboardData : window.clipboardData;
  } }), Jd = rd(Id), Kd = A({}, sd, { data: 0 }), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Od = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : false;
  }
  function zd() {
    return Pd;
  }
  var Qd = A({}, ud, { key: function(a) {
    if (a.key) {
      var b = Md[a.key] || a.key;
      if ("Unidentified" !== b) return b;
    }
    return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: zd, charCode: function(a) {
    return "keypress" === a.type ? od(a) : 0;
  }, keyCode: function(a) {
    return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  }, which: function(a) {
    return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  } }), Rd = rd(Qd), Sd = A({}, Ad, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Td = rd(Sd), Ud = A({}, ud, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: zd }), Vd = rd(Ud), Wd = A({}, sd, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
      return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
      return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Zd = rd(Yd), $d = [9, 13, 27, 32], ae = ia && "CompositionEvent" in window, be = null;
  ia && "documentMode" in document && (be = document.documentMode);
  var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = false;
  function ge(a, b) {
    switch (a) {
      case "keyup":
        return -1 !== $d.indexOf(b.keyCode);
      case "keydown":
        return 229 !== b.keyCode;
      case "keypress":
      case "mousedown":
      case "focusout":
        return true;
      default:
        return false;
    }
  }
  function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
  }
  var ie = false;
  function je(a, b) {
    switch (a) {
      case "compositionend":
        return he(b);
      case "keypress":
        if (32 !== b.which) return null;
        fe = true;
        return ee;
      case "textInput":
        return a = b.data, a === ee && fe ? null : a;
      default:
        return null;
    }
  }
  function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = false, a) : null;
    switch (a) {
      case "paste":
        return null;
      case "keypress":
        if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
          if (b.char && 1 < b.char.length) return b.char;
          if (b.which) return String.fromCharCode(b.which);
        }
        return null;
      case "compositionend":
        return de && "ko" !== b.locale ? null : b.data;
      default:
        return null;
    }
  }
  var le = { color: true, date: true, datetime: true, "datetime-local": true, email: true, month: true, number: true, password: true, range: true, search: true, tel: true, text: true, time: true, url: true, week: true };
  function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? true : false;
  }
  function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({ event: c, listeners: b }));
  }
  var pe = null, qe = null;
  function re(a) {
    se(a, 0);
  }
  function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
  }
  function ve(a, b) {
    if ("change" === a) return b;
  }
  var we = false;
  if (ia) {
    var xe;
    if (ia) {
      var ye = "oninput" in document;
      if (!ye) {
        var ze = document.createElement("div");
        ze.setAttribute("oninput", "return;");
        ye = "function" === typeof ze.oninput;
      }
      xe = ye;
    } else xe = false;
    we = xe && (!document.documentMode || 9 < document.documentMode);
  }
  function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
  }
  function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
      var b = [];
      ne(b, qe, a, xb(a));
      Jb(re, b);
    }
  }
  function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
  }
  function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
  }
  function Ee(a, b) {
    if ("click" === a) return te(b);
  }
  function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
  }
  function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
  }
  var He = "function" === typeof Object.is ? Object.is : Ge;
  function Ie(a, b) {
    if (He(a, b)) return true;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return false;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return false;
    for (d = 0; d < c.length; d++) {
      var e = c[d];
      if (!ja.call(b, e) || !He(a[e], b[e])) return false;
    }
    return true;
  }
  function Je(a) {
    for (; a && a.firstChild; ) a = a.firstChild;
    return a;
  }
  function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for (var d; c; ) {
      if (3 === c.nodeType) {
        d = a + c.textContent.length;
        if (a <= b && d >= b) return { node: c, offset: b - a };
        a = d;
      }
      a: {
        for (; c; ) {
          if (c.nextSibling) {
            c = c.nextSibling;
            break a;
          }
          c = c.parentNode;
        }
        c = void 0;
      }
      c = Je(c);
    }
  }
  function Le(a, b) {
    return a && b ? a === b ? true : a && 3 === a.nodeType ? false : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : false : false;
  }
  function Me() {
    for (var a = window, b = Xa(); b instanceof a.HTMLIFrameElement; ) {
      try {
        var c = "string" === typeof b.contentWindow.location.href;
      } catch (d) {
        c = false;
      }
      if (c) a = b.contentWindow;
      else break;
      b = Xa(a.document);
    }
    return b;
  }
  function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
  }
  function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
      if (null !== d && Ne(c)) {
        if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
        else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
          a = a.getSelection();
          var e = c.textContent.length, f2 = Math.min(d.start, e);
          d = void 0 === d.end ? f2 : Math.min(d.end, e);
          !a.extend && f2 > d && (e = d, d = f2, f2 = e);
          e = Ke(c, f2);
          var g = Ke(
            c,
            d
          );
          e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f2 > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
        }
      }
      b = [];
      for (a = c; a = a.parentNode; ) 1 === a.nodeType && b.push({ element: a, left: a.scrollLeft, top: a.scrollTop });
      "function" === typeof c.focus && c.focus();
      for (c = 0; c < b.length; c++) a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
  }
  var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = false;
  function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = { start: d.selectionStart, end: d.selectionEnd } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = { anchorNode: d.anchorNode, anchorOffset: d.anchorOffset, focusNode: d.focusNode, focusOffset: d.focusOffset }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({ event: b, listeners: d }), b.target = Qe)));
  }
  function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
  }
  var We = { animationend: Ve("Animation", "AnimationEnd"), animationiteration: Ve("Animation", "AnimationIteration"), animationstart: Ve("Animation", "AnimationStart"), transitionend: Ve("Transition", "TransitionEnd") }, Xe = {}, Ye = {};
  ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
  function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for (c in b) if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
  }
  var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = /* @__PURE__ */ new Map(), ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function ff(a, b) {
    df.set(a, b);
    fa(b, [a]);
  }
  for (var gf = 0; gf < ef.length; gf++) {
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
  }
  ff($e, "onAnimationEnd");
  ff(af, "onAnimationIteration");
  ff(bf, "onAnimationStart");
  ff("dblclick", "onDoubleClick");
  ff("focusin", "onFocus");
  ff("focusout", "onBlur");
  ff(cf, "onTransitionEnd");
  ha("onMouseEnter", ["mouseout", "mouseover"]);
  ha("onMouseLeave", ["mouseout", "mouseover"]);
  ha("onPointerEnter", ["pointerout", "pointerover"]);
  ha("onPointerLeave", ["pointerout", "pointerover"]);
  fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
  fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
  fa("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
  fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
  fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
  fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
  function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
  }
  function se(a, b) {
    b = 0 !== (b & 4);
    for (var c = 0; c < a.length; c++) {
      var d = a[c], e = d.event;
      d = d.listeners;
      a: {
        var f2 = void 0;
        if (b) for (var g = d.length - 1; 0 <= g; g--) {
          var h = d[g], k2 = h.instance, l2 = h.currentTarget;
          h = h.listener;
          if (k2 !== f2 && e.isPropagationStopped()) break a;
          nf(e, h, l2);
          f2 = k2;
        }
        else for (g = 0; g < d.length; g++) {
          h = d[g];
          k2 = h.instance;
          l2 = h.currentTarget;
          h = h.listener;
          if (k2 !== f2 && e.isPropagationStopped()) break a;
          nf(e, h, l2);
          f2 = k2;
        }
      }
    }
    if (Qb) throw a = Rb, Qb = false, Rb = null, a;
  }
  function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = /* @__PURE__ */ new Set());
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, false), c.add(d));
  }
  function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
  }
  var rf = "_reactListening" + Math.random().toString(36).slice(2);
  function sf(a) {
    if (!a[rf]) {
      a[rf] = true;
      da.forEach(function(b2) {
        "selectionchange" !== b2 && (mf.has(b2) || qf(b2, false, a), qf(b2, true, a));
      });
      var b = 9 === a.nodeType ? a : a.ownerDocument;
      null === b || b[rf] || (b[rf] = true, qf("selectionchange", false, b));
    }
  }
  function pf(a, b, c, d) {
    switch (jd(b)) {
      case 1:
        var e = ed;
        break;
      case 4:
        e = gd;
        break;
      default:
        e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = true);
    d ? void 0 !== e ? a.addEventListener(b, c, { capture: true, passive: e }) : a.addEventListener(b, c, true) : void 0 !== e ? a.addEventListener(b, c, { passive: e }) : a.addEventListener(b, c, false);
  }
  function hd(a, b, c, d, e) {
    var f2 = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for (; ; ) {
      if (null === d) return;
      var g = d.tag;
      if (3 === g || 4 === g) {
        var h = d.stateNode.containerInfo;
        if (h === e || 8 === h.nodeType && h.parentNode === e) break;
        if (4 === g) for (g = d.return; null !== g; ) {
          var k2 = g.tag;
          if (3 === k2 || 4 === k2) {
            if (k2 = g.stateNode.containerInfo, k2 === e || 8 === k2.nodeType && k2.parentNode === e) return;
          }
          g = g.return;
        }
        for (; null !== h; ) {
          g = Wc(h);
          if (null === g) return;
          k2 = g.tag;
          if (5 === k2 || 6 === k2) {
            d = f2 = g;
            continue a;
          }
          h = h.parentNode;
        }
      }
      d = d.return;
    }
    Jb(function() {
      var d2 = f2, e2 = xb(c), g2 = [];
      a: {
        var h2 = df.get(a);
        if (void 0 !== h2) {
          var k3 = td, n2 = a;
          switch (a) {
            case "keypress":
              if (0 === od(c)) break a;
            case "keydown":
            case "keyup":
              k3 = Rd;
              break;
            case "focusin":
              n2 = "focus";
              k3 = Fd;
              break;
            case "focusout":
              n2 = "blur";
              k3 = Fd;
              break;
            case "beforeblur":
            case "afterblur":
              k3 = Fd;
              break;
            case "click":
              if (2 === c.button) break a;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              k3 = Bd;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              k3 = Dd;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              k3 = Vd;
              break;
            case $e:
            case af:
            case bf:
              k3 = Hd;
              break;
            case cf:
              k3 = Xd;
              break;
            case "scroll":
              k3 = vd;
              break;
            case "wheel":
              k3 = Zd;
              break;
            case "copy":
            case "cut":
            case "paste":
              k3 = Jd;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              k3 = Td;
          }
          var t2 = 0 !== (b & 4), J2 = !t2 && "scroll" === a, x2 = t2 ? null !== h2 ? h2 + "Capture" : null : h2;
          t2 = [];
          for (var w2 = d2, u2; null !== w2; ) {
            u2 = w2;
            var F2 = u2.stateNode;
            5 === u2.tag && null !== F2 && (u2 = F2, null !== x2 && (F2 = Kb(w2, x2), null != F2 && t2.push(tf(w2, F2, u2))));
            if (J2) break;
            w2 = w2.return;
          }
          0 < t2.length && (h2 = new k3(h2, n2, null, c, e2), g2.push({ event: h2, listeners: t2 }));
        }
      }
      if (0 === (b & 7)) {
        a: {
          h2 = "mouseover" === a || "pointerover" === a;
          k3 = "mouseout" === a || "pointerout" === a;
          if (h2 && c !== wb && (n2 = c.relatedTarget || c.fromElement) && (Wc(n2) || n2[uf])) break a;
          if (k3 || h2) {
            h2 = e2.window === e2 ? e2 : (h2 = e2.ownerDocument) ? h2.defaultView || h2.parentWindow : window;
            if (k3) {
              if (n2 = c.relatedTarget || c.toElement, k3 = d2, n2 = n2 ? Wc(n2) : null, null !== n2 && (J2 = Vb(n2), n2 !== J2 || 5 !== n2.tag && 6 !== n2.tag)) n2 = null;
            } else k3 = null, n2 = d2;
            if (k3 !== n2) {
              t2 = Bd;
              F2 = "onMouseLeave";
              x2 = "onMouseEnter";
              w2 = "mouse";
              if ("pointerout" === a || "pointerover" === a) t2 = Td, F2 = "onPointerLeave", x2 = "onPointerEnter", w2 = "pointer";
              J2 = null == k3 ? h2 : ue(k3);
              u2 = null == n2 ? h2 : ue(n2);
              h2 = new t2(F2, w2 + "leave", k3, c, e2);
              h2.target = J2;
              h2.relatedTarget = u2;
              F2 = null;
              Wc(e2) === d2 && (t2 = new t2(x2, w2 + "enter", n2, c, e2), t2.target = u2, t2.relatedTarget = J2, F2 = t2);
              J2 = F2;
              if (k3 && n2) b: {
                t2 = k3;
                x2 = n2;
                w2 = 0;
                for (u2 = t2; u2; u2 = vf(u2)) w2++;
                u2 = 0;
                for (F2 = x2; F2; F2 = vf(F2)) u2++;
                for (; 0 < w2 - u2; ) t2 = vf(t2), w2--;
                for (; 0 < u2 - w2; ) x2 = vf(x2), u2--;
                for (; w2--; ) {
                  if (t2 === x2 || null !== x2 && t2 === x2.alternate) break b;
                  t2 = vf(t2);
                  x2 = vf(x2);
                }
                t2 = null;
              }
              else t2 = null;
              null !== k3 && wf(g2, h2, k3, t2, false);
              null !== n2 && null !== J2 && wf(g2, J2, n2, t2, true);
            }
          }
        }
        a: {
          h2 = d2 ? ue(d2) : window;
          k3 = h2.nodeName && h2.nodeName.toLowerCase();
          if ("select" === k3 || "input" === k3 && "file" === h2.type) var na = ve;
          else if (me(h2)) if (we) na = Fe;
          else {
            na = De;
            var xa = Ce;
          }
          else (k3 = h2.nodeName) && "input" === k3.toLowerCase() && ("checkbox" === h2.type || "radio" === h2.type) && (na = Ee);
          if (na && (na = na(a, d2))) {
            ne(g2, na, c, e2);
            break a;
          }
          xa && xa(a, h2, d2);
          "focusout" === a && (xa = h2._wrapperState) && xa.controlled && "number" === h2.type && cb(h2, "number", h2.value);
        }
        xa = d2 ? ue(d2) : window;
        switch (a) {
          case "focusin":
            if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d2, Se = null;
            break;
          case "focusout":
            Se = Re = Qe = null;
            break;
          case "mousedown":
            Te = true;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Te = false;
            Ue(g2, c, e2);
            break;
          case "selectionchange":
            if (Pe) break;
          case "keydown":
          case "keyup":
            Ue(g2, c, e2);
        }
        var $a;
        if (ae) b: {
          switch (a) {
            case "compositionstart":
              var ba = "onCompositionStart";
              break b;
            case "compositionend":
              ba = "onCompositionEnd";
              break b;
            case "compositionupdate":
              ba = "onCompositionUpdate";
              break b;
          }
          ba = void 0;
        }
        else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
        ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e2, ld = "value" in kd ? kd.value : kd.textContent, ie = true)), xa = oe(d2, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e2), g2.push({ event: ba, listeners: xa }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
        if ($a = ce ? je(a, c) : ke(a, c)) d2 = oe(d2, "onBeforeInput"), 0 < d2.length && (e2 = new Ld("onBeforeInput", "beforeinput", null, c, e2), g2.push({ event: e2, listeners: d2 }), e2.data = $a);
      }
      se(g2, b);
    });
  }
  function tf(a, b, c) {
    return { instance: a, listener: b, currentTarget: c };
  }
  function oe(a, b) {
    for (var c = b + "Capture", d = []; null !== a; ) {
      var e = a, f2 = e.stateNode;
      5 === e.tag && null !== f2 && (e = f2, f2 = Kb(a, c), null != f2 && d.unshift(tf(a, f2, e)), f2 = Kb(a, b), null != f2 && d.push(tf(a, f2, e)));
      a = a.return;
    }
    return d;
  }
  function vf(a) {
    if (null === a) return null;
    do
      a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
  }
  function wf(a, b, c, d, e) {
    for (var f2 = b._reactName, g = []; null !== c && c !== d; ) {
      var h = c, k2 = h.alternate, l2 = h.stateNode;
      if (null !== k2 && k2 === d) break;
      5 === h.tag && null !== l2 && (h = l2, e ? (k2 = Kb(c, f2), null != k2 && g.unshift(tf(c, k2, h))) : e || (k2 = Kb(c, f2), null != k2 && g.push(tf(c, k2, h))));
      c = c.return;
    }
    0 !== g.length && a.push({ event: b, listeners: g });
  }
  var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
  function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
  }
  function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
  }
  function Bf() {
  }
  var Cf = null, Df = null;
  function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
  }
  var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
  } : Ff;
  function If(a) {
    setTimeout(function() {
      throw a;
    });
  }
  function Kf(a, b) {
    var c = b, d = 0;
    do {
      var e = c.nextSibling;
      a.removeChild(c);
      if (e && 8 === e.nodeType) if (c = e.data, "/$" === c) {
        if (0 === d) {
          a.removeChild(e);
          bd(b);
          return;
        }
        d--;
      } else "$" !== c && "$?" !== c && "$!" !== c || d++;
      c = e;
    } while (c);
    bd(b);
  }
  function Lf(a) {
    for (; null != a; a = a.nextSibling) {
      var b = a.nodeType;
      if (1 === b || 3 === b) break;
      if (8 === b) {
        b = a.data;
        if ("$" === b || "$!" === b || "$?" === b) break;
        if ("/$" === b) return null;
      }
    }
    return a;
  }
  function Mf(a) {
    a = a.previousSibling;
    for (var b = 0; a; ) {
      if (8 === a.nodeType) {
        var c = a.data;
        if ("$" === c || "$!" === c || "$?" === c) {
          if (0 === b) return a;
          b--;
        } else "/$" === c && b++;
      }
      a = a.previousSibling;
    }
    return null;
  }
  var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
  function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for (var c = a.parentNode; c; ) {
      if (b = c[uf] || c[Of]) {
        c = b.alternate;
        if (null !== b.child || null !== c && null !== c.child) for (a = Mf(a); null !== a; ) {
          if (c = a[Of]) return c;
          a = Mf(a);
        }
        return b;
      }
      a = c;
      c = a.parentNode;
    }
    return null;
  }
  function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
  }
  function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
  }
  function Db(a) {
    return a[Pf] || null;
  }
  var Sf = [], Tf = -1;
  function Uf(a) {
    return { current: a };
  }
  function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
  }
  function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
  }
  var Vf = {}, H = Uf(Vf), Wf = Uf(false), Xf = Vf;
  function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f2;
    for (f2 in c) e[f2] = b[f2];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
  }
  function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
  }
  function $f() {
    E(Wf);
    E(H);
  }
  function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
  }
  function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for (var e in d) if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
  }
  function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return true;
  }
  function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
  }
  var eg = null, fg = false, gg = false;
  function hg(a) {
    null === eg ? eg = [a] : eg.push(a);
  }
  function ig(a) {
    fg = true;
    hg(a);
  }
  function jg() {
    if (!gg && null !== eg) {
      gg = true;
      var a = 0, b = C;
      try {
        var c = eg;
        for (C = 1; a < c.length; a++) {
          var d = c[a];
          do
            d = d(true);
          while (null !== d);
        }
        eg = null;
        fg = false;
      } catch (e) {
        throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
      } finally {
        C = b, gg = false;
      }
    }
    return null;
  }
  var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
  function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
  }
  function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f2 = 32 - oc(b) + e;
    if (30 < f2) {
      var g = e - e % 5;
      f2 = (d & (1 << g) - 1).toString(32);
      d >>= g;
      e -= g;
      rg = 1 << 32 - oc(b) + e | c << e | d;
      sg = f2 + a;
    } else rg = 1 << f2 | c << e | d, sg = a;
  }
  function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
  }
  function wg(a) {
    for (; a === mg; ) mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for (; a === qg; ) qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
  }
  var xg = null, yg = null, I = false, zg = null;
  function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [c], a.flags |= 16) : b.push(c);
  }
  function Cg(a, b) {
    switch (a.tag) {
      case 5:
        var c = a.type;
        b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
        return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), true) : false;
      case 6:
        return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, true) : false;
      case 13:
        return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? { id: rg, overflow: sg } : null, a.memoizedState = { dehydrated: b, treeContext: c, retryLane: 1073741824 }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, true) : false;
      default:
        return false;
    }
  }
  function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
  }
  function Eg(a) {
    if (I) {
      var b = yg;
      if (b) {
        var c = b;
        if (!Cg(a, b)) {
          if (Dg(a)) throw Error(p(418));
          b = Lf(c.nextSibling);
          var d = xg;
          b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = false, xg = a);
        }
      } else {
        if (Dg(a)) throw Error(p(418));
        a.flags = a.flags & -4097 | 2;
        I = false;
        xg = a;
      }
    }
  }
  function Fg(a) {
    for (a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag; ) a = a.return;
    xg = a;
  }
  function Gg(a) {
    if (a !== xg) return false;
    if (!I) return Fg(a), I = true, false;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
      if (Dg(a)) throw Hg(), Error(p(418));
      for (; b; ) Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
      a = a.memoizedState;
      a = null !== a ? a.dehydrated : null;
      if (!a) throw Error(p(317));
      a: {
        a = a.nextSibling;
        for (b = 0; a; ) {
          if (8 === a.nodeType) {
            var c = a.data;
            if ("/$" === c) {
              if (0 === b) {
                yg = Lf(a.nextSibling);
                break a;
              }
              b--;
            } else "$" !== c && "$!" !== c && "$?" !== c || b++;
          }
          a = a.nextSibling;
        }
        yg = null;
      }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return true;
  }
  function Hg() {
    for (var a = yg; a; ) a = Lf(a.nextSibling);
  }
  function Ig() {
    yg = xg = null;
    I = false;
  }
  function Jg(a) {
    null === zg ? zg = [a] : zg.push(a);
  }
  var Kg = ua.ReactCurrentBatchConfig;
  function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
      if (c._owner) {
        c = c._owner;
        if (c) {
          if (1 !== c.tag) throw Error(p(309));
          var d = c.stateNode;
        }
        if (!d) throw Error(p(147, a));
        var e = d, f2 = "" + a;
        if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f2) return b.ref;
        b = function(a2) {
          var b2 = e.refs;
          null === a2 ? delete b2[f2] : b2[f2] = a2;
        };
        b._stringRef = f2;
        return b;
      }
      if ("string" !== typeof a) throw Error(p(284));
      if (!c._owner) throw Error(p(290, a));
    }
    return a;
  }
  function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
  }
  function Ng(a) {
    var b = a._init;
    return b(a._payload);
  }
  function Og(a) {
    function b(b2, c2) {
      if (a) {
        var d2 = b2.deletions;
        null === d2 ? (b2.deletions = [c2], b2.flags |= 16) : d2.push(c2);
      }
    }
    function c(c2, d2) {
      if (!a) return null;
      for (; null !== d2; ) b(c2, d2), d2 = d2.sibling;
      return null;
    }
    function d(a2, b2) {
      for (a2 = /* @__PURE__ */ new Map(); null !== b2; ) null !== b2.key ? a2.set(b2.key, b2) : a2.set(b2.index, b2), b2 = b2.sibling;
      return a2;
    }
    function e(a2, b2) {
      a2 = Pg(a2, b2);
      a2.index = 0;
      a2.sibling = null;
      return a2;
    }
    function f2(b2, c2, d2) {
      b2.index = d2;
      if (!a) return b2.flags |= 1048576, c2;
      d2 = b2.alternate;
      if (null !== d2) return d2 = d2.index, d2 < c2 ? (b2.flags |= 2, c2) : d2;
      b2.flags |= 2;
      return c2;
    }
    function g(b2) {
      a && null === b2.alternate && (b2.flags |= 2);
      return b2;
    }
    function h(a2, b2, c2, d2) {
      if (null === b2 || 6 !== b2.tag) return b2 = Qg(c2, a2.mode, d2), b2.return = a2, b2;
      b2 = e(b2, c2);
      b2.return = a2;
      return b2;
    }
    function k2(a2, b2, c2, d2) {
      var f3 = c2.type;
      if (f3 === ya) return m2(a2, b2, c2.props.children, d2, c2.key);
      if (null !== b2 && (b2.elementType === f3 || "object" === typeof f3 && null !== f3 && f3.$$typeof === Ha && Ng(f3) === b2.type)) return d2 = e(b2, c2.props), d2.ref = Lg(a2, b2, c2), d2.return = a2, d2;
      d2 = Rg(c2.type, c2.key, c2.props, null, a2.mode, d2);
      d2.ref = Lg(a2, b2, c2);
      d2.return = a2;
      return d2;
    }
    function l2(a2, b2, c2, d2) {
      if (null === b2 || 4 !== b2.tag || b2.stateNode.containerInfo !== c2.containerInfo || b2.stateNode.implementation !== c2.implementation) return b2 = Sg(c2, a2.mode, d2), b2.return = a2, b2;
      b2 = e(b2, c2.children || []);
      b2.return = a2;
      return b2;
    }
    function m2(a2, b2, c2, d2, f3) {
      if (null === b2 || 7 !== b2.tag) return b2 = Tg(c2, a2.mode, d2, f3), b2.return = a2, b2;
      b2 = e(b2, c2);
      b2.return = a2;
      return b2;
    }
    function q2(a2, b2, c2) {
      if ("string" === typeof b2 && "" !== b2 || "number" === typeof b2) return b2 = Qg("" + b2, a2.mode, c2), b2.return = a2, b2;
      if ("object" === typeof b2 && null !== b2) {
        switch (b2.$$typeof) {
          case va:
            return c2 = Rg(b2.type, b2.key, b2.props, null, a2.mode, c2), c2.ref = Lg(a2, null, b2), c2.return = a2, c2;
          case wa:
            return b2 = Sg(b2, a2.mode, c2), b2.return = a2, b2;
          case Ha:
            var d2 = b2._init;
            return q2(a2, d2(b2._payload), c2);
        }
        if (eb(b2) || Ka(b2)) return b2 = Tg(b2, a2.mode, c2, null), b2.return = a2, b2;
        Mg(a2, b2);
      }
      return null;
    }
    function r2(a2, b2, c2, d2) {
      var e2 = null !== b2 ? b2.key : null;
      if ("string" === typeof c2 && "" !== c2 || "number" === typeof c2) return null !== e2 ? null : h(a2, b2, "" + c2, d2);
      if ("object" === typeof c2 && null !== c2) {
        switch (c2.$$typeof) {
          case va:
            return c2.key === e2 ? k2(a2, b2, c2, d2) : null;
          case wa:
            return c2.key === e2 ? l2(a2, b2, c2, d2) : null;
          case Ha:
            return e2 = c2._init, r2(
              a2,
              b2,
              e2(c2._payload),
              d2
            );
        }
        if (eb(c2) || Ka(c2)) return null !== e2 ? null : m2(a2, b2, c2, d2, null);
        Mg(a2, c2);
      }
      return null;
    }
    function y2(a2, b2, c2, d2, e2) {
      if ("string" === typeof d2 && "" !== d2 || "number" === typeof d2) return a2 = a2.get(c2) || null, h(b2, a2, "" + d2, e2);
      if ("object" === typeof d2 && null !== d2) {
        switch (d2.$$typeof) {
          case va:
            return a2 = a2.get(null === d2.key ? c2 : d2.key) || null, k2(b2, a2, d2, e2);
          case wa:
            return a2 = a2.get(null === d2.key ? c2 : d2.key) || null, l2(b2, a2, d2, e2);
          case Ha:
            var f3 = d2._init;
            return y2(a2, b2, c2, f3(d2._payload), e2);
        }
        if (eb(d2) || Ka(d2)) return a2 = a2.get(c2) || null, m2(b2, a2, d2, e2, null);
        Mg(b2, d2);
      }
      return null;
    }
    function n2(e2, g2, h2, k3) {
      for (var l3 = null, m3 = null, u2 = g2, w2 = g2 = 0, x2 = null; null !== u2 && w2 < h2.length; w2++) {
        u2.index > w2 ? (x2 = u2, u2 = null) : x2 = u2.sibling;
        var n3 = r2(e2, u2, h2[w2], k3);
        if (null === n3) {
          null === u2 && (u2 = x2);
          break;
        }
        a && u2 && null === n3.alternate && b(e2, u2);
        g2 = f2(n3, g2, w2);
        null === m3 ? l3 = n3 : m3.sibling = n3;
        m3 = n3;
        u2 = x2;
      }
      if (w2 === h2.length) return c(e2, u2), I && tg(e2, w2), l3;
      if (null === u2) {
        for (; w2 < h2.length; w2++) u2 = q2(e2, h2[w2], k3), null !== u2 && (g2 = f2(u2, g2, w2), null === m3 ? l3 = u2 : m3.sibling = u2, m3 = u2);
        I && tg(e2, w2);
        return l3;
      }
      for (u2 = d(e2, u2); w2 < h2.length; w2++) x2 = y2(u2, e2, w2, h2[w2], k3), null !== x2 && (a && null !== x2.alternate && u2.delete(null === x2.key ? w2 : x2.key), g2 = f2(x2, g2, w2), null === m3 ? l3 = x2 : m3.sibling = x2, m3 = x2);
      a && u2.forEach(function(a2) {
        return b(e2, a2);
      });
      I && tg(e2, w2);
      return l3;
    }
    function t2(e2, g2, h2, k3) {
      var l3 = Ka(h2);
      if ("function" !== typeof l3) throw Error(p(150));
      h2 = l3.call(h2);
      if (null == h2) throw Error(p(151));
      for (var u2 = l3 = null, m3 = g2, w2 = g2 = 0, x2 = null, n3 = h2.next(); null !== m3 && !n3.done; w2++, n3 = h2.next()) {
        m3.index > w2 ? (x2 = m3, m3 = null) : x2 = m3.sibling;
        var t3 = r2(e2, m3, n3.value, k3);
        if (null === t3) {
          null === m3 && (m3 = x2);
          break;
        }
        a && m3 && null === t3.alternate && b(e2, m3);
        g2 = f2(t3, g2, w2);
        null === u2 ? l3 = t3 : u2.sibling = t3;
        u2 = t3;
        m3 = x2;
      }
      if (n3.done) return c(
        e2,
        m3
      ), I && tg(e2, w2), l3;
      if (null === m3) {
        for (; !n3.done; w2++, n3 = h2.next()) n3 = q2(e2, n3.value, k3), null !== n3 && (g2 = f2(n3, g2, w2), null === u2 ? l3 = n3 : u2.sibling = n3, u2 = n3);
        I && tg(e2, w2);
        return l3;
      }
      for (m3 = d(e2, m3); !n3.done; w2++, n3 = h2.next()) n3 = y2(m3, e2, w2, n3.value, k3), null !== n3 && (a && null !== n3.alternate && m3.delete(null === n3.key ? w2 : n3.key), g2 = f2(n3, g2, w2), null === u2 ? l3 = n3 : u2.sibling = n3, u2 = n3);
      a && m3.forEach(function(a2) {
        return b(e2, a2);
      });
      I && tg(e2, w2);
      return l3;
    }
    function J2(a2, d2, f3, h2) {
      "object" === typeof f3 && null !== f3 && f3.type === ya && null === f3.key && (f3 = f3.props.children);
      if ("object" === typeof f3 && null !== f3) {
        switch (f3.$$typeof) {
          case va:
            a: {
              for (var k3 = f3.key, l3 = d2; null !== l3; ) {
                if (l3.key === k3) {
                  k3 = f3.type;
                  if (k3 === ya) {
                    if (7 === l3.tag) {
                      c(a2, l3.sibling);
                      d2 = e(l3, f3.props.children);
                      d2.return = a2;
                      a2 = d2;
                      break a;
                    }
                  } else if (l3.elementType === k3 || "object" === typeof k3 && null !== k3 && k3.$$typeof === Ha && Ng(k3) === l3.type) {
                    c(a2, l3.sibling);
                    d2 = e(l3, f3.props);
                    d2.ref = Lg(a2, l3, f3);
                    d2.return = a2;
                    a2 = d2;
                    break a;
                  }
                  c(a2, l3);
                  break;
                } else b(a2, l3);
                l3 = l3.sibling;
              }
              f3.type === ya ? (d2 = Tg(f3.props.children, a2.mode, h2, f3.key), d2.return = a2, a2 = d2) : (h2 = Rg(f3.type, f3.key, f3.props, null, a2.mode, h2), h2.ref = Lg(a2, d2, f3), h2.return = a2, a2 = h2);
            }
            return g(a2);
          case wa:
            a: {
              for (l3 = f3.key; null !== d2; ) {
                if (d2.key === l3) if (4 === d2.tag && d2.stateNode.containerInfo === f3.containerInfo && d2.stateNode.implementation === f3.implementation) {
                  c(a2, d2.sibling);
                  d2 = e(d2, f3.children || []);
                  d2.return = a2;
                  a2 = d2;
                  break a;
                } else {
                  c(a2, d2);
                  break;
                }
                else b(a2, d2);
                d2 = d2.sibling;
              }
              d2 = Sg(f3, a2.mode, h2);
              d2.return = a2;
              a2 = d2;
            }
            return g(a2);
          case Ha:
            return l3 = f3._init, J2(a2, d2, l3(f3._payload), h2);
        }
        if (eb(f3)) return n2(a2, d2, f3, h2);
        if (Ka(f3)) return t2(a2, d2, f3, h2);
        Mg(a2, f3);
      }
      return "string" === typeof f3 && "" !== f3 || "number" === typeof f3 ? (f3 = "" + f3, null !== d2 && 6 === d2.tag ? (c(a2, d2.sibling), d2 = e(d2, f3), d2.return = a2, a2 = d2) : (c(a2, d2), d2 = Qg(f3, a2.mode, h2), d2.return = a2, a2 = d2), g(a2)) : c(a2, d2);
    }
    return J2;
  }
  var Ug = Og(true), Vg = Og(false), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
  function $g() {
    Zg = Yg = Xg = null;
  }
  function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
  }
  function bh(a, b, c) {
    for (; null !== a; ) {
      var d = a.alternate;
      (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
      if (a === c) break;
      a = a.return;
    }
  }
  function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = true), a.firstContext = null);
  }
  function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) if (a = { context: a, memoizedValue: b, next: null }, null === Yg) {
      if (null === Xg) throw Error(p(308));
      Yg = a;
      Xg.dependencies = { lanes: 0, firstContext: a };
    } else Yg = Yg.next = a;
    return b;
  }
  var fh = null;
  function gh(a) {
    null === fh ? fh = [a] : fh.push(a);
  }
  function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
  }
  function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for (a = a.return; null !== a; ) a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
  }
  var jh = false;
  function kh(a) {
    a.updateQueue = { baseState: a.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = { baseState: a.baseState, firstBaseUpdate: a.firstBaseUpdate, lastBaseUpdate: a.lastBaseUpdate, shared: a.shared, effects: a.effects });
  }
  function mh(a, b) {
    return { eventTime: a, lane: b, tag: 0, payload: null, callback: null, next: null };
  }
  function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
      var e = d.pending;
      null === e ? b.next = b : (b.next = e.next, e.next = b);
      d.pending = b;
      return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
  }
  function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
      var d = b.lanes;
      d &= a.pendingLanes;
      c |= d;
      b.lanes = c;
      Cc(a, c);
    }
  }
  function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
      var e = null, f2 = null;
      c = c.firstBaseUpdate;
      if (null !== c) {
        do {
          var g = { eventTime: c.eventTime, lane: c.lane, tag: c.tag, payload: c.payload, callback: c.callback, next: null };
          null === f2 ? e = f2 = g : f2 = f2.next = g;
          c = c.next;
        } while (null !== c);
        null === f2 ? e = f2 = b : f2 = f2.next = b;
      } else e = f2 = b;
      c = { baseState: d.baseState, firstBaseUpdate: e, lastBaseUpdate: f2, shared: d.shared, effects: d.effects };
      a.updateQueue = c;
      return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
  }
  function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = false;
    var f2 = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
      e.shared.pending = null;
      var k2 = h, l2 = k2.next;
      k2.next = null;
      null === g ? f2 = l2 : g.next = l2;
      g = k2;
      var m2 = a.alternate;
      null !== m2 && (m2 = m2.updateQueue, h = m2.lastBaseUpdate, h !== g && (null === h ? m2.firstBaseUpdate = l2 : h.next = l2, m2.lastBaseUpdate = k2));
    }
    if (null !== f2) {
      var q2 = e.baseState;
      g = 0;
      m2 = l2 = k2 = null;
      h = f2;
      do {
        var r2 = h.lane, y2 = h.eventTime;
        if ((d & r2) === r2) {
          null !== m2 && (m2 = m2.next = {
            eventTime: y2,
            lane: 0,
            tag: h.tag,
            payload: h.payload,
            callback: h.callback,
            next: null
          });
          a: {
            var n2 = a, t2 = h;
            r2 = b;
            y2 = c;
            switch (t2.tag) {
              case 1:
                n2 = t2.payload;
                if ("function" === typeof n2) {
                  q2 = n2.call(y2, q2, r2);
                  break a;
                }
                q2 = n2;
                break a;
              case 3:
                n2.flags = n2.flags & -65537 | 128;
              case 0:
                n2 = t2.payload;
                r2 = "function" === typeof n2 ? n2.call(y2, q2, r2) : n2;
                if (null === r2 || void 0 === r2) break a;
                q2 = A({}, q2, r2);
                break a;
              case 2:
                jh = true;
            }
          }
          null !== h.callback && 0 !== h.lane && (a.flags |= 64, r2 = e.effects, null === r2 ? e.effects = [h] : r2.push(h));
        } else y2 = { eventTime: y2, lane: r2, tag: h.tag, payload: h.payload, callback: h.callback, next: null }, null === m2 ? (l2 = m2 = y2, k2 = q2) : m2 = m2.next = y2, g |= r2;
        h = h.next;
        if (null === h) if (h = e.shared.pending, null === h) break;
        else r2 = h, h = r2.next, r2.next = null, e.lastBaseUpdate = r2, e.shared.pending = null;
      } while (1);
      null === m2 && (k2 = q2);
      e.baseState = k2;
      e.firstBaseUpdate = l2;
      e.lastBaseUpdate = m2;
      b = e.shared.interleaved;
      if (null !== b) {
        e = b;
        do
          g |= e.lane, e = e.next;
        while (e !== b);
      } else null === f2 && (e.shared.lanes = 0);
      rh |= g;
      a.lanes = g;
      a.memoizedState = q2;
    }
  }
  function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for (b = 0; b < a.length; b++) {
      var d = a[b], e = d.callback;
      if (null !== e) {
        d.callback = null;
        d = c;
        if ("function" !== typeof e) throw Error(p(191, e));
        e.call(d);
      }
    }
  }
  var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
  function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
  }
  function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch (a) {
      case 9:
      case 11:
        b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
        break;
      default:
        a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
  }
  function zh() {
    E(uh);
    E(vh);
    E(wh);
  }
  function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
  }
  function Bh(a) {
    vh.current === a && (E(uh), E(vh));
  }
  var L = Uf(0);
  function Ch(a) {
    for (var b = a; null !== b; ) {
      if (13 === b.tag) {
        var c = b.memoizedState;
        if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
      } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
        if (0 !== (b.flags & 128)) return b;
      } else if (null !== b.child) {
        b.child.return = b;
        b = b.child;
        continue;
      }
      if (b === a) break;
      for (; null === b.sibling; ) {
        if (null === b.return || b.return === a) return null;
        b = b.return;
      }
      b.sibling.return = b.return;
      b = b.sibling;
    }
    return null;
  }
  var Dh = [];
  function Eh() {
    for (var a = 0; a < Dh.length; a++) Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
  }
  var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = false, Jh = false, Kh = 0, Lh = 0;
  function P() {
    throw Error(p(321));
  }
  function Mh(a, b) {
    if (null === b) return false;
    for (var c = 0; c < b.length && c < a.length; c++) if (!He(a[c], b[c])) return false;
    return true;
  }
  function Nh(a, b, c, d, e, f2) {
    Hh = f2;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
      f2 = 0;
      do {
        Jh = false;
        Kh = 0;
        if (25 <= f2) throw Error(p(301));
        f2 += 1;
        O = N = null;
        b.updateQueue = null;
        Fh.current = Qh;
        a = c(d, e);
      } while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = false;
    if (b) throw Error(p(300));
    return a;
  }
  function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
  }
  function Th() {
    var a = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
  }
  function Uh() {
    if (null === N) {
      var a = M.alternate;
      a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
      if (null === a) throw Error(p(310));
      N = a;
      a = { memoizedState: N.memoizedState, baseState: N.baseState, baseQueue: N.baseQueue, queue: N.queue, next: null };
      null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
  }
  function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
  }
  function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f2 = c.pending;
    if (null !== f2) {
      if (null !== e) {
        var g = e.next;
        e.next = f2.next;
        f2.next = g;
      }
      d.baseQueue = e = f2;
      c.pending = null;
    }
    if (null !== e) {
      f2 = e.next;
      d = d.baseState;
      var h = g = null, k2 = null, l2 = f2;
      do {
        var m2 = l2.lane;
        if ((Hh & m2) === m2) null !== k2 && (k2 = k2.next = { lane: 0, action: l2.action, hasEagerState: l2.hasEagerState, eagerState: l2.eagerState, next: null }), d = l2.hasEagerState ? l2.eagerState : a(d, l2.action);
        else {
          var q2 = {
            lane: m2,
            action: l2.action,
            hasEagerState: l2.hasEagerState,
            eagerState: l2.eagerState,
            next: null
          };
          null === k2 ? (h = k2 = q2, g = d) : k2 = k2.next = q2;
          M.lanes |= m2;
          rh |= m2;
        }
        l2 = l2.next;
      } while (null !== l2 && l2 !== f2);
      null === k2 ? g = d : k2.next = h;
      He(d, b.memoizedState) || (dh = true);
      b.memoizedState = d;
      b.baseState = g;
      b.baseQueue = k2;
      c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
      e = a;
      do
        f2 = e.lane, M.lanes |= f2, rh |= f2, e = e.next;
      while (e !== a);
    } else null === e && (c.lanes = 0);
    return [b.memoizedState, c.dispatch];
  }
  function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f2 = b.memoizedState;
    if (null !== e) {
      c.pending = null;
      var g = e = e.next;
      do
        f2 = a(f2, g.action), g = g.next;
      while (g !== e);
      He(f2, b.memoizedState) || (dh = true);
      b.memoizedState = f2;
      null === b.baseQueue && (b.baseState = f2);
      c.lastRenderedState = f2;
    }
    return [f2, d];
  }
  function Yh() {
  }
  function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f2 = !He(d.memoizedState, e);
    f2 && (d.memoizedState = e, dh = true);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [a]);
    if (d.getSnapshot !== b || f2 || null !== O && O.memoizedState.tag & 1) {
      c.flags |= 2048;
      bi(9, ci.bind(null, c, d, e, b), void 0, null);
      if (null === Q) throw Error(p(349));
      0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
  }
  function di(a, b, c) {
    a.flags |= 16384;
    a = { getSnapshot: b, value: c };
    b = M.updateQueue;
    null === b ? (b = { lastEffect: null, stores: null }, M.updateQueue = b, b.stores = [a]) : (c = b.stores, null === c ? b.stores = [a] : c.push(a));
  }
  function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
  }
  function ai(a, b, c) {
    return c(function() {
      ei(b) && fi(a);
    });
  }
  function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
      var c = b();
      return !He(a, c);
    } catch (d) {
      return true;
    }
  }
  function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
  }
  function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Vh, lastRenderedState: a };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [b.memoizedState, a];
  }
  function bi(a, b, c, d) {
    a = { tag: a, create: b, destroy: c, deps: d, next: null };
    b = M.updateQueue;
    null === b ? (b = { lastEffect: null, stores: null }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
  }
  function ji() {
    return Uh().memoizedState;
  }
  function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
  }
  function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f2 = void 0;
    if (null !== N) {
      var g = N.memoizedState;
      f2 = g.destroy;
      if (null !== d && Mh(d, g.deps)) {
        e.memoizedState = bi(b, c, f2, d);
        return;
      }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f2, d);
  }
  function mi(a, b) {
    return ki(8390656, 8, a, b);
  }
  function $h(a, b) {
    return li(2048, 8, a, b);
  }
  function ni(a, b) {
    return li(4, 2, a, b);
  }
  function oi(a, b) {
    return li(4, 4, a, b);
  }
  function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
      b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
      b.current = null;
    };
  }
  function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([a]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
  }
  function ri() {
  }
  function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [a, b];
    return a;
  }
  function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [a, b];
    return a;
  }
  function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = false, dh = true), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = true);
    return b;
  }
  function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(true);
    var d = Gh.transition;
    Gh.transition = {};
    try {
      a(false), b();
    } finally {
      C = c, Gh.transition = d;
    }
  }
  function wi() {
    return Uh().memoizedState;
  }
  function xi(a, b, c) {
    var d = yi(a);
    c = { lane: d, action: c, hasEagerState: false, eagerState: null, next: null };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
      var e = R();
      gi(c, a, d, e);
      Bi(c, b, d);
    }
  }
  function ii(a, b, c) {
    var d = yi(a), e = { lane: d, action: c, hasEagerState: false, eagerState: null, next: null };
    if (zi(a)) Ai(b, e);
    else {
      var f2 = a.alternate;
      if (0 === a.lanes && (null === f2 || 0 === f2.lanes) && (f2 = b.lastRenderedReducer, null !== f2)) try {
        var g = b.lastRenderedState, h = f2(g, c);
        e.hasEagerState = true;
        e.eagerState = h;
        if (He(h, g)) {
          var k2 = b.interleaved;
          null === k2 ? (e.next = e, gh(b)) : (e.next = k2.next, k2.next = e);
          b.interleaved = e;
          return;
        }
      } catch (l2) {
      } finally {
      }
      c = hh(a, b, e, d);
      null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
  }
  function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
  }
  function Ai(a, b) {
    Jh = Ih = true;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
  }
  function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
      var d = b.lanes;
      d &= a.pendingLanes;
      c |= d;
      b.lanes = c;
      Cc(a, c);
    }
  }
  var Rh = { readContext: eh, useCallback: P, useContext: P, useEffect: P, useImperativeHandle: P, useInsertionEffect: P, useLayoutEffect: P, useMemo: P, useReducer: P, useRef: P, useState: P, useDebugValue: P, useDeferredValue: P, useTransition: P, useMutableSource: P, useSyncExternalStore: P, useId: P, unstable_isNewReconciler: false }, Oh = { readContext: eh, useCallback: function(a, b) {
    Th().memoizedState = [a, void 0 === b ? null : b];
    return a;
  }, useContext: eh, useEffect: mi, useImperativeHandle: function(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([a]) : null;
    return ki(
      4194308,
      4,
      pi.bind(null, b, a),
      c
    );
  }, useLayoutEffect: function(a, b) {
    return ki(4194308, 4, a, b);
  }, useInsertionEffect: function(a, b) {
    return ki(4, 2, a, b);
  }, useMemo: function(a, b) {
    var c = Th();
    b = void 0 === b ? null : b;
    a = a();
    c.memoizedState = [a, b];
    return a;
  }, useReducer: function(a, b, c) {
    var d = Th();
    b = void 0 !== c ? c(b) : b;
    d.memoizedState = d.baseState = b;
    a = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: a, lastRenderedState: b };
    d.queue = a;
    a = a.dispatch = xi.bind(null, M, a);
    return [d.memoizedState, a];
  }, useRef: function(a) {
    var b = Th();
    a = { current: a };
    return b.memoizedState = a;
  }, useState: hi, useDebugValue: ri, useDeferredValue: function(a) {
    return Th().memoizedState = a;
  }, useTransition: function() {
    var a = hi(false), b = a[0];
    a = vi.bind(null, a[1]);
    Th().memoizedState = a;
    return [b, a];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(a, b, c) {
    var d = M, e = Th();
    if (I) {
      if (void 0 === c) throw Error(p(407));
      c = c();
    } else {
      c = b();
      if (null === Q) throw Error(p(349));
      0 !== (Hh & 30) || di(d, b, c);
    }
    e.memoizedState = c;
    var f2 = { value: c, getSnapshot: b };
    e.queue = f2;
    mi(ai.bind(
      null,
      d,
      f2,
      a
    ), [a]);
    d.flags |= 2048;
    bi(9, ci.bind(null, d, f2, c, b), void 0, null);
    return c;
  }, useId: function() {
    var a = Th(), b = Q.identifierPrefix;
    if (I) {
      var c = sg;
      var d = rg;
      c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
      b = ":" + b + "R" + c;
      c = Kh++;
      0 < c && (b += "H" + c.toString(32));
      b += ":";
    } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
    return a.memoizedState = b;
  }, unstable_isNewReconciler: false }, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
      return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
      var b = Uh();
      return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
      var a = Wh(Vh)[0], b = Uh().memoizedState;
      return [a, b];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: false
  }, Qh = { readContext: eh, useCallback: si, useContext: eh, useEffect: $h, useImperativeHandle: qi, useInsertionEffect: ni, useLayoutEffect: oi, useMemo: ti, useReducer: Xh, useRef: ji, useState: function() {
    return Xh(Vh);
  }, useDebugValue: ri, useDeferredValue: function(a) {
    var b = Uh();
    return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
  }, useTransition: function() {
    var a = Xh(Vh)[0], b = Uh().memoizedState;
    return [a, b];
  }, useMutableSource: Yh, useSyncExternalStore: Zh, useId: wi, unstable_isNewReconciler: false };
  function Ci(a, b) {
    if (a && a.defaultProps) {
      b = A({}, b);
      a = a.defaultProps;
      for (var c in a) void 0 === b[c] && (b[c] = a[c]);
      return b;
    }
    return b;
  }
  function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
  }
  var Ei = { isMounted: function(a) {
    return (a = a._reactInternals) ? Vb(a) === a : false;
  }, enqueueSetState: function(a, b, c) {
    a = a._reactInternals;
    var d = R(), e = yi(a), f2 = mh(d, e);
    f2.payload = b;
    void 0 !== c && null !== c && (f2.callback = c);
    b = nh(a, f2, e);
    null !== b && (gi(b, a, e, d), oh(b, a, e));
  }, enqueueReplaceState: function(a, b, c) {
    a = a._reactInternals;
    var d = R(), e = yi(a), f2 = mh(d, e);
    f2.tag = 1;
    f2.payload = b;
    void 0 !== c && null !== c && (f2.callback = c);
    b = nh(a, f2, e);
    null !== b && (gi(b, a, e, d), oh(b, a, e));
  }, enqueueForceUpdate: function(a, b) {
    a = a._reactInternals;
    var c = R(), d = yi(a), e = mh(c, d);
    e.tag = 2;
    void 0 !== b && null !== b && (e.callback = b);
    b = nh(a, e, d);
    null !== b && (gi(b, a, d, c), oh(b, a, d));
  } };
  function Fi(a, b, c, d, e, f2, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f2, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f2) : true;
  }
  function Gi(a, b, c) {
    var d = false, e = Vf;
    var f2 = b.contextType;
    "object" === typeof f2 && null !== f2 ? f2 = eh(f2) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f2 = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f2);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f2);
    return b;
  }
  function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
  }
  function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f2 = b.contextType;
    "object" === typeof f2 && null !== f2 ? e.context = eh(f2) : (f2 = Zf(b) ? Xf : H.current, e.context = Yf(a, f2));
    e.state = a.memoizedState;
    f2 = b.getDerivedStateFromProps;
    "function" === typeof f2 && (Di(a, b, f2, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
  }
  function Ji(a, b) {
    try {
      var c = "", d = b;
      do
        c += Pa(d), d = d.return;
      while (d);
      var e = c;
    } catch (f2) {
      e = "\nError generating stack: " + f2.message + "\n" + f2.stack;
    }
    return { value: a, source: b, stack: e, digest: null };
  }
  function Ki(a, b, c) {
    return { value: a, source: null, stack: null != c ? c : null, digest: null != b ? b : null };
  }
  function Li(a, b) {
    try {
      console.error(b.value);
    } catch (c) {
      setTimeout(function() {
        throw c;
      });
    }
  }
  var Mi = "function" === typeof WeakMap ? WeakMap : Map;
  function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = { element: null };
    var d = b.value;
    c.callback = function() {
      Oi || (Oi = true, Pi = d);
      Li(a, b);
    };
    return c;
  }
  function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
      var e = b.value;
      c.payload = function() {
        return d(e);
      };
      c.callback = function() {
        Li(a, b);
      };
    }
    var f2 = a.stateNode;
    null !== f2 && "function" === typeof f2.componentDidCatch && (c.callback = function() {
      Li(a, b);
      "function" !== typeof d && (null === Ri ? Ri = /* @__PURE__ */ new Set([this]) : Ri.add(this));
      var c2 = b.stack;
      this.componentDidCatch(b.value, { componentStack: null !== c2 ? c2 : "" });
    });
    return c;
  }
  function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
      d = a.pingCache = new Mi();
      var e = /* @__PURE__ */ new Set();
      d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = /* @__PURE__ */ new Set(), d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
  }
  function Ui(a) {
    do {
      var b;
      if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? true : false : true;
      if (b) return a;
      a = a.return;
    } while (null !== a);
    return null;
  }
  function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
  }
  var Wi = ua.ReactCurrentOwner, dh = false;
  function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
  }
  function Yi(a, b, c, d, e) {
    c = c.render;
    var f2 = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f2, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
  }
  function $i(a, b, c, d, e) {
    if (null === a) {
      var f2 = c.type;
      if ("function" === typeof f2 && !aj(f2) && void 0 === f2.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f2, bj(a, b, f2, d, e);
      a = Rg(c.type, null, d, b, b.mode, e);
      a.ref = b.ref;
      a.return = b;
      return b.child = a;
    }
    f2 = a.child;
    if (0 === (a.lanes & e)) {
      var g = f2.memoizedProps;
      c = c.compare;
      c = null !== c ? c : Ie;
      if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f2, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
  }
  function bj(a, b, c, d, e) {
    if (null !== a) {
      var f2 = a.memoizedProps;
      if (Ie(f2, d) && a.ref === b.ref) if (dh = false, b.pendingProps = d = f2, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = true);
      else return b.lanes = a.lanes, Zi(a, b, e);
    }
    return cj(a, b, c, d, e);
  }
  function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f2 = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) if (0 === (b.mode & 1)) b.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, G(ej, fj), fj |= c;
    else {
      if (0 === (c & 1073741824)) return a = null !== f2 ? f2.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = { baseLanes: a, cachePool: null, transitions: null }, b.updateQueue = null, G(ej, fj), fj |= a, null;
      b.memoizedState = { baseLanes: 0, cachePool: null, transitions: null };
      d = null !== f2 ? f2.baseLanes : c;
      G(ej, fj);
      fj |= d;
    }
    else null !== f2 ? (d = f2.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
  }
  function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
  }
  function cj(a, b, c, d, e) {
    var f2 = Zf(c) ? Xf : H.current;
    f2 = Yf(b, f2);
    ch(b, e);
    c = Nh(a, b, c, d, f2, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
  }
  function hj(a, b, c, d, e) {
    if (Zf(c)) {
      var f2 = true;
      cg(b);
    } else f2 = false;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = true;
    else if (null === a) {
      var g = b.stateNode, h = b.memoizedProps;
      g.props = h;
      var k2 = g.context, l2 = c.contextType;
      "object" === typeof l2 && null !== l2 ? l2 = eh(l2) : (l2 = Zf(c) ? Xf : H.current, l2 = Yf(b, l2));
      var m2 = c.getDerivedStateFromProps, q2 = "function" === typeof m2 || "function" === typeof g.getSnapshotBeforeUpdate;
      q2 || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k2 !== l2) && Hi(b, g, d, l2);
      jh = false;
      var r2 = b.memoizedState;
      g.state = r2;
      qh(b, d, g, e);
      k2 = b.memoizedState;
      h !== d || r2 !== k2 || Wf.current || jh ? ("function" === typeof m2 && (Di(b, c, m2, d), k2 = b.memoizedState), (h = jh || Fi(b, c, h, d, r2, k2, l2)) ? (q2 || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k2), g.props = d, g.state = k2, g.context = l2, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = false);
    } else {
      g = b.stateNode;
      lh(a, b);
      h = b.memoizedProps;
      l2 = b.type === b.elementType ? h : Ci(b.type, h);
      g.props = l2;
      q2 = b.pendingProps;
      r2 = g.context;
      k2 = c.contextType;
      "object" === typeof k2 && null !== k2 ? k2 = eh(k2) : (k2 = Zf(c) ? Xf : H.current, k2 = Yf(b, k2));
      var y2 = c.getDerivedStateFromProps;
      (m2 = "function" === typeof y2 || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q2 || r2 !== k2) && Hi(b, g, d, k2);
      jh = false;
      r2 = b.memoizedState;
      g.state = r2;
      qh(b, d, g, e);
      var n2 = b.memoizedState;
      h !== q2 || r2 !== n2 || Wf.current || jh ? ("function" === typeof y2 && (Di(b, c, y2, d), n2 = b.memoizedState), (l2 = jh || Fi(b, c, l2, d, r2, n2, k2) || false) ? (m2 || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n2, k2), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n2, k2)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r2 === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r2 === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n2), g.props = d, g.state = n2, g.context = k2, d = l2) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r2 === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r2 === a.memoizedState || (b.flags |= 1024), d = false);
    }
    return jj(a, b, c, d, f2, e);
  }
  function jj(a, b, c, d, e, f2) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, false), Zi(a, b, f2);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f2), b.child = Ug(b, null, h, f2)) : Xi(a, b, h, f2);
    b.memoizedState = d.state;
    e && dg(b, c, true);
    return b.child;
  }
  function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, false);
    yh(a, b.containerInfo);
  }
  function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
  }
  var mj = { dehydrated: null, treeContext: null, retryLane: 0 };
  function nj(a) {
    return { baseLanes: a, cachePool: null, transitions: null };
  }
  function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f2 = false, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? false : 0 !== (e & 2));
    if (h) f2 = true, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
      Eg(b);
      a = b.memoizedState;
      if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
      g = d.children;
      a = d.fallback;
      return f2 ? (d = b.mode, f2 = b.child, g = { mode: "hidden", children: g }, 0 === (d & 1) && null !== f2 ? (f2.childLanes = 0, f2.pendingProps = g) : f2 = pj(g, d, 0, null), a = Tg(a, d, c, null), f2.return = b, a.return = b, f2.sibling = a, b.child = f2, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f2) {
      f2 = d.fallback;
      g = b.mode;
      e = a.child;
      h = e.sibling;
      var k2 = { mode: "hidden", children: d.children };
      0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k2, b.deletions = null) : (d = Pg(e, k2), d.subtreeFlags = e.subtreeFlags & 14680064);
      null !== h ? f2 = Pg(h, f2) : (f2 = Tg(f2, g, c, null), f2.flags |= 2);
      f2.return = b;
      d.return = b;
      d.sibling = f2;
      b.child = d;
      d = f2;
      f2 = b.child;
      g = a.child.memoizedState;
      g = null === g ? nj(c) : { baseLanes: g.baseLanes | c, cachePool: null, transitions: g.transitions };
      f2.memoizedState = g;
      f2.childLanes = a.childLanes & ~c;
      b.memoizedState = mj;
      return d;
    }
    f2 = a.child;
    a = f2.sibling;
    d = Pg(f2, { mode: "visible", children: d.children });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [a], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
  }
  function qj(a, b) {
    b = pj({ mode: "visible", children: b }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
  }
  function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
  }
  function rj(a, b, c, d, e, f2, g) {
    if (c) {
      if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
      if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
      f2 = d.fallback;
      e = b.mode;
      d = pj({ mode: "visible", children: d.children }, e, 0, null);
      f2 = Tg(f2, e, g, null);
      f2.flags |= 2;
      d.return = b;
      f2.return = b;
      d.sibling = f2;
      b.child = d;
      0 !== (b.mode & 1) && Ug(b, a.child, null, g);
      b.child.memoizedState = nj(g);
      b.memoizedState = mj;
      return f2;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
      d = e.nextSibling && e.nextSibling.dataset;
      if (d) var h = d.dgst;
      d = h;
      f2 = Error(p(419));
      d = Ki(f2, d, void 0);
      return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
      d = Q;
      if (null !== d) {
        switch (g & -g) {
          case 4:
            e = 2;
            break;
          case 16:
            e = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            e = 32;
            break;
          case 536870912:
            e = 268435456;
            break;
          default:
            e = 0;
        }
        e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
        0 !== e && e !== f2.retryLane && (f2.retryLane = e, ih(a, e), gi(d, a, e, -1));
      }
      tj();
      d = Ki(Error(p(421)));
      return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f2.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = true;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
  }
  function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
  }
  function wj(a, b, c, d, e) {
    var f2 = a.memoizedState;
    null === f2 ? a.memoizedState = { isBackwards: b, rendering: null, renderingStartTime: 0, last: d, tail: c, tailMode: e } : (f2.isBackwards = b, f2.rendering = null, f2.renderingStartTime = 0, f2.last = d, f2.tail = c, f2.tailMode = e);
  }
  function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f2 = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
      if (null !== a && 0 !== (a.flags & 128)) a: for (a = b.child; null !== a; ) {
        if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
        else if (19 === a.tag) vj(a, c, b);
        else if (null !== a.child) {
          a.child.return = a;
          a = a.child;
          continue;
        }
        if (a === b) break a;
        for (; null === a.sibling; ) {
          if (null === a.return || a.return === b) break a;
          a = a.return;
        }
        a.sibling.return = a.return;
        a = a.sibling;
      }
      d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch (e) {
      case "forwards":
        c = b.child;
        for (e = null; null !== c; ) a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
        c = e;
        null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
        wj(b, false, e, c, f2);
        break;
      case "backwards":
        c = null;
        e = b.child;
        for (b.child = null; null !== e; ) {
          a = e.alternate;
          if (null !== a && null === Ch(a)) {
            b.child = e;
            break;
          }
          a = e.sibling;
          e.sibling = c;
          c = e;
          e = a;
        }
        wj(b, true, c, null, f2);
        break;
      case "together":
        wj(b, false, null, null, void 0);
        break;
      default:
        b.memoizedState = null;
    }
    return b.child;
  }
  function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
  }
  function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
      a = b.child;
      c = Pg(a, a.pendingProps);
      b.child = c;
      for (c.return = b; null !== a.sibling; ) a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
      c.sibling = null;
    }
    return b.child;
  }
  function yj(a, b, c) {
    switch (b.tag) {
      case 3:
        kj(b);
        Ig();
        break;
      case 5:
        Ah(b);
        break;
      case 1:
        Zf(b.type) && cg(b);
        break;
      case 4:
        yh(b, b.stateNode.containerInfo);
        break;
      case 10:
        var d = b.type._context, e = b.memoizedProps.value;
        G(Wg, d._currentValue);
        d._currentValue = e;
        break;
      case 13:
        d = b.memoizedState;
        if (null !== d) {
          if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
          if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
          G(L, L.current & 1);
          a = Zi(a, b, c);
          return null !== a ? a.sibling : null;
        }
        G(L, L.current & 1);
        break;
      case 19:
        d = 0 !== (c & b.childLanes);
        if (0 !== (a.flags & 128)) {
          if (d) return xj(a, b, c);
          b.flags |= 128;
        }
        e = b.memoizedState;
        null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
        G(L, L.current);
        if (d) break;
        else return null;
      case 22:
      case 23:
        return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
  }
  var zj, Aj, Bj, Cj;
  zj = function(a, b) {
    for (var c = b.child; null !== c; ) {
      if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
      else if (4 !== c.tag && null !== c.child) {
        c.child.return = c;
        c = c.child;
        continue;
      }
      if (c === b) break;
      for (; null === c.sibling; ) {
        if (null === c.return || c.return === b) return;
        c = c.return;
      }
      c.sibling.return = c.return;
      c = c.sibling;
    }
  };
  Aj = function() {
  };
  Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
      a = b.stateNode;
      xh(uh.current);
      var f2 = null;
      switch (c) {
        case "input":
          e = Ya(a, e);
          d = Ya(a, d);
          f2 = [];
          break;
        case "select":
          e = A({}, e, { value: void 0 });
          d = A({}, d, { value: void 0 });
          f2 = [];
          break;
        case "textarea":
          e = gb(a, e);
          d = gb(a, d);
          f2 = [];
          break;
        default:
          "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
      }
      ub(c, d);
      var g;
      c = null;
      for (l2 in e) if (!d.hasOwnProperty(l2) && e.hasOwnProperty(l2) && null != e[l2]) if ("style" === l2) {
        var h = e[l2];
        for (g in h) h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
      } else "dangerouslySetInnerHTML" !== l2 && "children" !== l2 && "suppressContentEditableWarning" !== l2 && "suppressHydrationWarning" !== l2 && "autoFocus" !== l2 && (ea.hasOwnProperty(l2) ? f2 || (f2 = []) : (f2 = f2 || []).push(l2, null));
      for (l2 in d) {
        var k2 = d[l2];
        h = null != e ? e[l2] : void 0;
        if (d.hasOwnProperty(l2) && k2 !== h && (null != k2 || null != h)) if ("style" === l2) if (h) {
          for (g in h) !h.hasOwnProperty(g) || k2 && k2.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
          for (g in k2) k2.hasOwnProperty(g) && h[g] !== k2[g] && (c || (c = {}), c[g] = k2[g]);
        } else c || (f2 || (f2 = []), f2.push(
          l2,
          c
        )), c = k2;
        else "dangerouslySetInnerHTML" === l2 ? (k2 = k2 ? k2.__html : void 0, h = h ? h.__html : void 0, null != k2 && h !== k2 && (f2 = f2 || []).push(l2, k2)) : "children" === l2 ? "string" !== typeof k2 && "number" !== typeof k2 || (f2 = f2 || []).push(l2, "" + k2) : "suppressContentEditableWarning" !== l2 && "suppressHydrationWarning" !== l2 && (ea.hasOwnProperty(l2) ? (null != k2 && "onScroll" === l2 && D("scroll", a), f2 || h === k2 || (f2 = [])) : (f2 = f2 || []).push(l2, k2));
      }
      c && (f2 = f2 || []).push("style", c);
      var l2 = f2;
      if (b.updateQueue = l2) b.flags |= 4;
    }
  };
  Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
  };
  function Dj(a, b) {
    if (!I) switch (a.tailMode) {
      case "hidden":
        b = a.tail;
        for (var c = null; null !== b; ) null !== b.alternate && (c = b), b = b.sibling;
        null === c ? a.tail = null : c.sibling = null;
        break;
      case "collapsed":
        c = a.tail;
        for (var d = null; null !== c; ) null !== c.alternate && (d = c), c = c.sibling;
        null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
  }
  function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for (var e = a.child; null !== e; ) c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for (e = a.child; null !== e; ) c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
  }
  function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch (b.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return S(b), null;
      case 1:
        return Zf(b.type) && $f(), S(b), null;
      case 3:
        d = b.stateNode;
        zh();
        E(Wf);
        E(H);
        Eh();
        d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
        if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
        Aj(a, b);
        S(b);
        return null;
      case 5:
        Bh(b);
        var e = xh(wh.current);
        c = b.type;
        if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
        else {
          if (!d) {
            if (null === b.stateNode) throw Error(p(166));
            S(b);
            return null;
          }
          a = xh(uh.current);
          if (Gg(b)) {
            d = b.stateNode;
            c = b.type;
            var f2 = b.memoizedProps;
            d[Of] = b;
            d[Pf] = f2;
            a = 0 !== (b.mode & 1);
            switch (c) {
              case "dialog":
                D("cancel", d);
                D("close", d);
                break;
              case "iframe":
              case "object":
              case "embed":
                D("load", d);
                break;
              case "video":
              case "audio":
                for (e = 0; e < lf.length; e++) D(lf[e], d);
                break;
              case "source":
                D("error", d);
                break;
              case "img":
              case "image":
              case "link":
                D(
                  "error",
                  d
                );
                D("load", d);
                break;
              case "details":
                D("toggle", d);
                break;
              case "input":
                Za(d, f2);
                D("invalid", d);
                break;
              case "select":
                d._wrapperState = { wasMultiple: !!f2.multiple };
                D("invalid", d);
                break;
              case "textarea":
                hb(d, f2), D("invalid", d);
            }
            ub(c, f2);
            e = null;
            for (var g in f2) if (f2.hasOwnProperty(g)) {
              var h = f2[g];
              "children" === g ? "string" === typeof h ? d.textContent !== h && (true !== f2.suppressHydrationWarning && Af(d.textContent, h, a), e = ["children", h]) : "number" === typeof h && d.textContent !== "" + h && (true !== f2.suppressHydrationWarning && Af(
                d.textContent,
                h,
                a
              ), e = ["children", "" + h]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
            }
            switch (c) {
              case "input":
                Va(d);
                db(d, f2, true);
                break;
              case "textarea":
                Va(d);
                jb(d);
                break;
              case "select":
              case "option":
                break;
              default:
                "function" === typeof f2.onClick && (d.onclick = Bf);
            }
            d = e;
            b.updateQueue = d;
            null !== d && (b.flags |= 4);
          } else {
            g = 9 === e.nodeType ? e : e.ownerDocument;
            "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
            "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script><\/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, { is: d.is }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = true : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
            a[Of] = b;
            a[Pf] = d;
            zj(a, b, false, false);
            b.stateNode = a;
            a: {
              g = vb(c, d);
              switch (c) {
                case "dialog":
                  D("cancel", a);
                  D("close", a);
                  e = d;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  D("load", a);
                  e = d;
                  break;
                case "video":
                case "audio":
                  for (e = 0; e < lf.length; e++) D(lf[e], a);
                  e = d;
                  break;
                case "source":
                  D("error", a);
                  e = d;
                  break;
                case "img":
                case "image":
                case "link":
                  D(
                    "error",
                    a
                  );
                  D("load", a);
                  e = d;
                  break;
                case "details":
                  D("toggle", a);
                  e = d;
                  break;
                case "input":
                  Za(a, d);
                  e = Ya(a, d);
                  D("invalid", a);
                  break;
                case "option":
                  e = d;
                  break;
                case "select":
                  a._wrapperState = { wasMultiple: !!d.multiple };
                  e = A({}, d, { value: void 0 });
                  D("invalid", a);
                  break;
                case "textarea":
                  hb(a, d);
                  e = gb(a, d);
                  D("invalid", a);
                  break;
                default:
                  e = d;
              }
              ub(c, e);
              h = e;
              for (f2 in h) if (h.hasOwnProperty(f2)) {
                var k2 = h[f2];
                "style" === f2 ? sb(a, k2) : "dangerouslySetInnerHTML" === f2 ? (k2 = k2 ? k2.__html : void 0, null != k2 && nb(a, k2)) : "children" === f2 ? "string" === typeof k2 ? ("textarea" !== c || "" !== k2) && ob(a, k2) : "number" === typeof k2 && ob(a, "" + k2) : "suppressContentEditableWarning" !== f2 && "suppressHydrationWarning" !== f2 && "autoFocus" !== f2 && (ea.hasOwnProperty(f2) ? null != k2 && "onScroll" === f2 && D("scroll", a) : null != k2 && ta(a, f2, k2, g));
              }
              switch (c) {
                case "input":
                  Va(a);
                  db(a, d, false);
                  break;
                case "textarea":
                  Va(a);
                  jb(a);
                  break;
                case "option":
                  null != d.value && a.setAttribute("value", "" + Sa(d.value));
                  break;
                case "select":
                  a.multiple = !!d.multiple;
                  f2 = d.value;
                  null != f2 ? fb(a, !!d.multiple, f2, false) : null != d.defaultValue && fb(
                    a,
                    !!d.multiple,
                    d.defaultValue,
                    true
                  );
                  break;
                default:
                  "function" === typeof e.onClick && (a.onclick = Bf);
              }
              switch (c) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  d = !!d.autoFocus;
                  break a;
                case "img":
                  d = true;
                  break a;
                default:
                  d = false;
              }
            }
            d && (b.flags |= 4);
          }
          null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
        }
        S(b);
        return null;
      case 6:
        if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
        else {
          if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
          c = xh(wh.current);
          xh(uh.current);
          if (Gg(b)) {
            d = b.stateNode;
            c = b.memoizedProps;
            d[Of] = b;
            if (f2 = d.nodeValue !== c) {
              if (a = xg, null !== a) switch (a.tag) {
                case 3:
                  Af(d.nodeValue, c, 0 !== (a.mode & 1));
                  break;
                case 5:
                  true !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
              }
            }
            f2 && (b.flags |= 4);
          } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
        }
        S(b);
        return null;
      case 13:
        E(L);
        d = b.memoizedState;
        if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
          if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f2 = false;
          else if (f2 = Gg(b), null !== d && null !== d.dehydrated) {
            if (null === a) {
              if (!f2) throw Error(p(318));
              f2 = b.memoizedState;
              f2 = null !== f2 ? f2.dehydrated : null;
              if (!f2) throw Error(p(317));
              f2[Of] = b;
            } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
            S(b);
            f2 = false;
          } else null !== zg && (Fj(zg), zg = null), f2 = true;
          if (!f2) return b.flags & 65536 ? b : null;
        }
        if (0 !== (b.flags & 128)) return b.lanes = c, b;
        d = null !== d;
        d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
        null !== b.updateQueue && (b.flags |= 4);
        S(b);
        return null;
      case 4:
        return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
      case 10:
        return ah(b.type._context), S(b), null;
      case 17:
        return Zf(b.type) && $f(), S(b), null;
      case 19:
        E(L);
        f2 = b.memoizedState;
        if (null === f2) return S(b), null;
        d = 0 !== (b.flags & 128);
        g = f2.rendering;
        if (null === g) if (d) Dj(f2, false);
        else {
          if (0 !== T || null !== a && 0 !== (a.flags & 128)) for (a = b.child; null !== a; ) {
            g = Ch(a);
            if (null !== g) {
              b.flags |= 128;
              Dj(f2, false);
              d = g.updateQueue;
              null !== d && (b.updateQueue = d, b.flags |= 4);
              b.subtreeFlags = 0;
              d = c;
              for (c = b.child; null !== c; ) f2 = c, a = d, f2.flags &= 14680066, g = f2.alternate, null === g ? (f2.childLanes = 0, f2.lanes = a, f2.child = null, f2.subtreeFlags = 0, f2.memoizedProps = null, f2.memoizedState = null, f2.updateQueue = null, f2.dependencies = null, f2.stateNode = null) : (f2.childLanes = g.childLanes, f2.lanes = g.lanes, f2.child = g.child, f2.subtreeFlags = 0, f2.deletions = null, f2.memoizedProps = g.memoizedProps, f2.memoizedState = g.memoizedState, f2.updateQueue = g.updateQueue, f2.type = g.type, a = g.dependencies, f2.dependencies = null === a ? null : { lanes: a.lanes, firstContext: a.firstContext }), c = c.sibling;
              G(L, L.current & 1 | 2);
              return b.child;
            }
            a = a.sibling;
          }
          null !== f2.tail && B() > Gj && (b.flags |= 128, d = true, Dj(f2, false), b.lanes = 4194304);
        }
        else {
          if (!d) if (a = Ch(g), null !== a) {
            if (b.flags |= 128, d = true, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f2, true), null === f2.tail && "hidden" === f2.tailMode && !g.alternate && !I) return S(b), null;
          } else 2 * B() - f2.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = true, Dj(f2, false), b.lanes = 4194304);
          f2.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f2.last, null !== c ? c.sibling = g : b.child = g, f2.last = g);
        }
        if (null !== f2.tail) return b = f2.tail, f2.rendering = b, f2.tail = b.sibling, f2.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
        S(b);
        return null;
      case 22:
      case 23:
        return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(p(156, b.tag));
  }
  function Ij(a, b) {
    wg(b);
    switch (b.tag) {
      case 1:
        return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
      case 3:
        return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
      case 5:
        return Bh(b), null;
      case 13:
        E(L);
        a = b.memoizedState;
        if (null !== a && null !== a.dehydrated) {
          if (null === b.alternate) throw Error(p(340));
          Ig();
        }
        a = b.flags;
        return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
      case 19:
        return E(L), null;
      case 4:
        return zh(), null;
      case 10:
        return ah(b.type._context), null;
      case 22:
      case 23:
        return Hj(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var Jj = false, U = false, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
  function Lj(a, b) {
    var c = a.ref;
    if (null !== c) if ("function" === typeof c) try {
      c(null);
    } catch (d) {
      W(a, b, d);
    }
    else c.current = null;
  }
  function Mj(a, b, c) {
    try {
      c();
    } catch (d) {
      W(a, b, d);
    }
  }
  var Nj = false;
  function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
      if ("selectionStart" in a) var c = { start: a.selectionStart, end: a.selectionEnd };
      else a: {
        c = (c = a.ownerDocument) && c.defaultView || window;
        var d = c.getSelection && c.getSelection();
        if (d && 0 !== d.rangeCount) {
          c = d.anchorNode;
          var e = d.anchorOffset, f2 = d.focusNode;
          d = d.focusOffset;
          try {
            c.nodeType, f2.nodeType;
          } catch (F2) {
            c = null;
            break a;
          }
          var g = 0, h = -1, k2 = -1, l2 = 0, m2 = 0, q2 = a, r2 = null;
          b: for (; ; ) {
            for (var y2; ; ) {
              q2 !== c || 0 !== e && 3 !== q2.nodeType || (h = g + e);
              q2 !== f2 || 0 !== d && 3 !== q2.nodeType || (k2 = g + d);
              3 === q2.nodeType && (g += q2.nodeValue.length);
              if (null === (y2 = q2.firstChild)) break;
              r2 = q2;
              q2 = y2;
            }
            for (; ; ) {
              if (q2 === a) break b;
              r2 === c && ++l2 === e && (h = g);
              r2 === f2 && ++m2 === d && (k2 = g);
              if (null !== (y2 = q2.nextSibling)) break;
              q2 = r2;
              r2 = q2.parentNode;
            }
            q2 = y2;
          }
          c = -1 === h || -1 === k2 ? null : { start: h, end: k2 };
        } else c = null;
      }
      c = c || { start: 0, end: 0 };
    } else c = null;
    Df = { focusedElem: a, selectionRange: c };
    dd = false;
    for (V = b; null !== V; ) if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for (; null !== V; ) {
      b = V;
      try {
        var n2 = b.alternate;
        if (0 !== (b.flags & 1024)) switch (b.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (null !== n2) {
              var t2 = n2.memoizedProps, J2 = n2.memoizedState, x2 = b.stateNode, w2 = x2.getSnapshotBeforeUpdate(b.elementType === b.type ? t2 : Ci(b.type, t2), J2);
              x2.__reactInternalSnapshotBeforeUpdate = w2;
            }
            break;
          case 3:
            var u2 = b.stateNode.containerInfo;
            1 === u2.nodeType ? u2.textContent = "" : 9 === u2.nodeType && u2.documentElement && u2.removeChild(u2.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(p(163));
        }
      } catch (F2) {
        W(b, b.return, F2);
      }
      a = b.sibling;
      if (null !== a) {
        a.return = b.return;
        V = a;
        break;
      }
      V = b.return;
    }
    n2 = Nj;
    Nj = false;
    return n2;
  }
  function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
      var e = d = d.next;
      do {
        if ((e.tag & a) === a) {
          var f2 = e.destroy;
          e.destroy = void 0;
          void 0 !== f2 && Mj(b, c, f2);
        }
        e = e.next;
      } while (e !== d);
    }
  }
  function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
      var c = b = b.next;
      do {
        if ((c.tag & a) === a) {
          var d = c.create;
          c.destroy = d();
        }
        c = c.next;
      } while (c !== b);
    }
  }
  function Rj(a) {
    var b = a.ref;
    if (null !== b) {
      var c = a.stateNode;
      switch (a.tag) {
        case 5:
          a = c;
          break;
        default:
          a = c;
      }
      "function" === typeof b ? b(a) : b.current = a;
    }
  }
  function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
  }
  function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
  }
  function Uj(a) {
    a: for (; ; ) {
      for (; null === a.sibling; ) {
        if (null === a.return || Tj(a.return)) return null;
        a = a.return;
      }
      a.sibling.return = a.return;
      for (a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag; ) {
        if (a.flags & 2) continue a;
        if (null === a.child || 4 === a.tag) continue a;
        else a.child.return = a, a = a.child;
      }
      if (!(a.flags & 2)) return a.stateNode;
    }
  }
  function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for (Vj(a, b, c), a = a.sibling; null !== a; ) Vj(a, b, c), a = a.sibling;
  }
  function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for (Wj(a, b, c), a = a.sibling; null !== a; ) Wj(a, b, c), a = a.sibling;
  }
  var X = null, Xj = false;
  function Yj(a, b, c) {
    for (c = c.child; null !== c; ) Zj(a, b, c), c = c.sibling;
  }
  function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
      lc.onCommitFiberUnmount(kc, c);
    } catch (h) {
    }
    switch (c.tag) {
      case 5:
        U || Lj(c, b);
      case 6:
        var d = X, e = Xj;
        X = null;
        Yj(a, b, c);
        X = d;
        Xj = e;
        null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
        break;
      case 18:
        null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
        break;
      case 4:
        d = X;
        e = Xj;
        X = c.stateNode.containerInfo;
        Xj = true;
        Yj(a, b, c);
        X = d;
        Xj = e;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
          e = d = d.next;
          do {
            var f2 = e, g = f2.destroy;
            f2 = f2.tag;
            void 0 !== g && (0 !== (f2 & 2) ? Mj(c, b, g) : 0 !== (f2 & 4) && Mj(c, b, g));
            e = e.next;
          } while (e !== d);
        }
        Yj(a, b, c);
        break;
      case 1:
        if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
          d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
        } catch (h) {
          W(c, b, h);
        }
        Yj(a, b, c);
        break;
      case 21:
        Yj(a, b, c);
        break;
      case 22:
        c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
        break;
      default:
        Yj(a, b, c);
    }
  }
  function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
      a.updateQueue = null;
      var c = a.stateNode;
      null === c && (c = a.stateNode = new Kj());
      b.forEach(function(b2) {
        var d = bk.bind(null, a, b2);
        c.has(b2) || (c.add(b2), b2.then(d, d));
      });
    }
  }
  function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for (var d = 0; d < c.length; d++) {
      var e = c[d];
      try {
        var f2 = a, g = b, h = g;
        a: for (; null !== h; ) {
          switch (h.tag) {
            case 5:
              X = h.stateNode;
              Xj = false;
              break a;
            case 3:
              X = h.stateNode.containerInfo;
              Xj = true;
              break a;
            case 4:
              X = h.stateNode.containerInfo;
              Xj = true;
              break a;
          }
          h = h.return;
        }
        if (null === X) throw Error(p(160));
        Zj(f2, g, e);
        X = null;
        Xj = false;
        var k2 = e.alternate;
        null !== k2 && (k2.return = null);
        e.return = null;
      } catch (l2) {
        W(e, b, l2);
      }
    }
    if (b.subtreeFlags & 12854) for (b = b.child; null !== b; ) dk(b, a), b = b.sibling;
  }
  function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch (a.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        ck(b, a);
        ek(a);
        if (d & 4) {
          try {
            Pj(3, a, a.return), Qj(3, a);
          } catch (t2) {
            W(a, a.return, t2);
          }
          try {
            Pj(5, a, a.return);
          } catch (t2) {
            W(a, a.return, t2);
          }
        }
        break;
      case 1:
        ck(b, a);
        ek(a);
        d & 512 && null !== c && Lj(c, c.return);
        break;
      case 5:
        ck(b, a);
        ek(a);
        d & 512 && null !== c && Lj(c, c.return);
        if (a.flags & 32) {
          var e = a.stateNode;
          try {
            ob(e, "");
          } catch (t2) {
            W(a, a.return, t2);
          }
        }
        if (d & 4 && (e = a.stateNode, null != e)) {
          var f2 = a.memoizedProps, g = null !== c ? c.memoizedProps : f2, h = a.type, k2 = a.updateQueue;
          a.updateQueue = null;
          if (null !== k2) try {
            "input" === h && "radio" === f2.type && null != f2.name && ab(e, f2);
            vb(h, g);
            var l2 = vb(h, f2);
            for (g = 0; g < k2.length; g += 2) {
              var m2 = k2[g], q2 = k2[g + 1];
              "style" === m2 ? sb(e, q2) : "dangerouslySetInnerHTML" === m2 ? nb(e, q2) : "children" === m2 ? ob(e, q2) : ta(e, m2, q2, l2);
            }
            switch (h) {
              case "input":
                bb(e, f2);
                break;
              case "textarea":
                ib(e, f2);
                break;
              case "select":
                var r2 = e._wrapperState.wasMultiple;
                e._wrapperState.wasMultiple = !!f2.multiple;
                var y2 = f2.value;
                null != y2 ? fb(e, !!f2.multiple, y2, false) : r2 !== !!f2.multiple && (null != f2.defaultValue ? fb(
                  e,
                  !!f2.multiple,
                  f2.defaultValue,
                  true
                ) : fb(e, !!f2.multiple, f2.multiple ? [] : "", false));
            }
            e[Pf] = f2;
          } catch (t2) {
            W(a, a.return, t2);
          }
        }
        break;
      case 6:
        ck(b, a);
        ek(a);
        if (d & 4) {
          if (null === a.stateNode) throw Error(p(162));
          e = a.stateNode;
          f2 = a.memoizedProps;
          try {
            e.nodeValue = f2;
          } catch (t2) {
            W(a, a.return, t2);
          }
        }
        break;
      case 3:
        ck(b, a);
        ek(a);
        if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
          bd(b.containerInfo);
        } catch (t2) {
          W(a, a.return, t2);
        }
        break;
      case 4:
        ck(b, a);
        ek(a);
        break;
      case 13:
        ck(b, a);
        ek(a);
        e = a.child;
        e.flags & 8192 && (f2 = null !== e.memoizedState, e.stateNode.isHidden = f2, !f2 || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
        d & 4 && ak(a);
        break;
      case 22:
        m2 = null !== c && null !== c.memoizedState;
        a.mode & 1 ? (U = (l2 = U) || m2, ck(b, a), U = l2) : ck(b, a);
        ek(a);
        if (d & 8192) {
          l2 = null !== a.memoizedState;
          if ((a.stateNode.isHidden = l2) && !m2 && 0 !== (a.mode & 1)) for (V = a, m2 = a.child; null !== m2; ) {
            for (q2 = V = m2; null !== V; ) {
              r2 = V;
              y2 = r2.child;
              switch (r2.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  Pj(4, r2, r2.return);
                  break;
                case 1:
                  Lj(r2, r2.return);
                  var n2 = r2.stateNode;
                  if ("function" === typeof n2.componentWillUnmount) {
                    d = r2;
                    c = r2.return;
                    try {
                      b = d, n2.props = b.memoizedProps, n2.state = b.memoizedState, n2.componentWillUnmount();
                    } catch (t2) {
                      W(d, c, t2);
                    }
                  }
                  break;
                case 5:
                  Lj(r2, r2.return);
                  break;
                case 22:
                  if (null !== r2.memoizedState) {
                    gk(q2);
                    continue;
                  }
              }
              null !== y2 ? (y2.return = r2, V = y2) : gk(q2);
            }
            m2 = m2.sibling;
          }
          a: for (m2 = null, q2 = a; ; ) {
            if (5 === q2.tag) {
              if (null === m2) {
                m2 = q2;
                try {
                  e = q2.stateNode, l2 ? (f2 = e.style, "function" === typeof f2.setProperty ? f2.setProperty("display", "none", "important") : f2.display = "none") : (h = q2.stateNode, k2 = q2.memoizedProps.style, g = void 0 !== k2 && null !== k2 && k2.hasOwnProperty("display") ? k2.display : null, h.style.display = rb("display", g));
                } catch (t2) {
                  W(a, a.return, t2);
                }
              }
            } else if (6 === q2.tag) {
              if (null === m2) try {
                q2.stateNode.nodeValue = l2 ? "" : q2.memoizedProps;
              } catch (t2) {
                W(a, a.return, t2);
              }
            } else if ((22 !== q2.tag && 23 !== q2.tag || null === q2.memoizedState || q2 === a) && null !== q2.child) {
              q2.child.return = q2;
              q2 = q2.child;
              continue;
            }
            if (q2 === a) break a;
            for (; null === q2.sibling; ) {
              if (null === q2.return || q2.return === a) break a;
              m2 === q2 && (m2 = null);
              q2 = q2.return;
            }
            m2 === q2 && (m2 = null);
            q2.sibling.return = q2.return;
            q2 = q2.sibling;
          }
        }
        break;
      case 19:
        ck(b, a);
        ek(a);
        d & 4 && ak(a);
        break;
      case 21:
        break;
      default:
        ck(
          b,
          a
        ), ek(a);
    }
  }
  function ek(a) {
    var b = a.flags;
    if (b & 2) {
      try {
        a: {
          for (var c = a.return; null !== c; ) {
            if (Tj(c)) {
              var d = c;
              break a;
            }
            c = c.return;
          }
          throw Error(p(160));
        }
        switch (d.tag) {
          case 5:
            var e = d.stateNode;
            d.flags & 32 && (ob(e, ""), d.flags &= -33);
            var f2 = Uj(a);
            Wj(a, f2, e);
            break;
          case 3:
          case 4:
            var g = d.stateNode.containerInfo, h = Uj(a);
            Vj(a, h, g);
            break;
          default:
            throw Error(p(161));
        }
      } catch (k2) {
        W(a, a.return, k2);
      }
      a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
  }
  function hk(a, b, c) {
    V = a;
    ik(a);
  }
  function ik(a, b, c) {
    for (var d = 0 !== (a.mode & 1); null !== V; ) {
      var e = V, f2 = e.child;
      if (22 === e.tag && d) {
        var g = null !== e.memoizedState || Jj;
        if (!g) {
          var h = e.alternate, k2 = null !== h && null !== h.memoizedState || U;
          h = Jj;
          var l2 = U;
          Jj = g;
          if ((U = k2) && !l2) for (V = e; null !== V; ) g = V, k2 = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k2 ? (k2.return = g, V = k2) : jk(e);
          for (; null !== f2; ) V = f2, ik(f2), f2 = f2.sibling;
          V = e;
          Jj = h;
          U = l2;
        }
        kk(a);
      } else 0 !== (e.subtreeFlags & 8772) && null !== f2 ? (f2.return = e, V = f2) : kk(a);
    }
  }
  function kk(a) {
    for (; null !== V; ) {
      var b = V;
      if (0 !== (b.flags & 8772)) {
        var c = b.alternate;
        try {
          if (0 !== (b.flags & 8772)) switch (b.tag) {
            case 0:
            case 11:
            case 15:
              U || Qj(5, b);
              break;
            case 1:
              var d = b.stateNode;
              if (b.flags & 4 && !U) if (null === c) d.componentDidMount();
              else {
                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
              }
              var f2 = b.updateQueue;
              null !== f2 && sh(b, f2, d);
              break;
            case 3:
              var g = b.updateQueue;
              if (null !== g) {
                c = null;
                if (null !== b.child) switch (b.child.tag) {
                  case 5:
                    c = b.child.stateNode;
                    break;
                  case 1:
                    c = b.child.stateNode;
                }
                sh(b, g, c);
              }
              break;
            case 5:
              var h = b.stateNode;
              if (null === c && b.flags & 4) {
                c = h;
                var k2 = b.memoizedProps;
                switch (b.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    k2.autoFocus && c.focus();
                    break;
                  case "img":
                    k2.src && (c.src = k2.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (null === b.memoizedState) {
                var l2 = b.alternate;
                if (null !== l2) {
                  var m2 = l2.memoizedState;
                  if (null !== m2) {
                    var q2 = m2.dehydrated;
                    null !== q2 && bd(q2);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(p(163));
          }
          U || b.flags & 512 && Rj(b);
        } catch (r2) {
          W(b, b.return, r2);
        }
      }
      if (b === a) {
        V = null;
        break;
      }
      c = b.sibling;
      if (null !== c) {
        c.return = b.return;
        V = c;
        break;
      }
      V = b.return;
    }
  }
  function gk(a) {
    for (; null !== V; ) {
      var b = V;
      if (b === a) {
        V = null;
        break;
      }
      var c = b.sibling;
      if (null !== c) {
        c.return = b.return;
        V = c;
        break;
      }
      V = b.return;
    }
  }
  function jk(a) {
    for (; null !== V; ) {
      var b = V;
      try {
        switch (b.tag) {
          case 0:
          case 11:
          case 15:
            var c = b.return;
            try {
              Qj(4, b);
            } catch (k2) {
              W(b, c, k2);
            }
            break;
          case 1:
            var d = b.stateNode;
            if ("function" === typeof d.componentDidMount) {
              var e = b.return;
              try {
                d.componentDidMount();
              } catch (k2) {
                W(b, e, k2);
              }
            }
            var f2 = b.return;
            try {
              Rj(b);
            } catch (k2) {
              W(b, f2, k2);
            }
            break;
          case 5:
            var g = b.return;
            try {
              Rj(b);
            } catch (k2) {
              W(b, g, k2);
            }
        }
      } catch (k2) {
        W(b, b.return, k2);
      }
      if (b === a) {
        V = null;
        break;
      }
      var h = b.sibling;
      if (null !== h) {
        h.return = b.return;
        V = h;
        break;
      }
      V = b.return;
    }
  }
  var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = false, Pi = null, Ri = null, vk = false, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
  function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
  }
  function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
  }
  function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
  }
  function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
      null != c && bc(c);
      if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
        0 === (K & 6) && jg();
      }), c = null;
      else {
        switch (Dc(d)) {
          case 1:
            c = fc;
            break;
          case 4:
            c = gc;
            break;
          case 16:
            c = hc;
            break;
          case 536870912:
            c = jc;
            break;
          default:
            c = hc;
        }
        c = Fk(c, Gk.bind(null, a));
      }
      a.callbackPriority = b;
      a.callbackNode = c;
    }
  }
  function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
      b = d;
      var e = K;
      K |= 2;
      var f2 = Jk();
      if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
      do
        try {
          Lk();
          break;
        } catch (h) {
          Mk(a, h);
        }
      while (1);
      $g();
      mk.current = f2;
      K = e;
      null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
      2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
      if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
      if (6 === b) Ck(a, d);
      else {
        e = a.current.alternate;
        if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f2 = xc(a), 0 !== f2 && (d = f2, b = Nk(a, f2))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        a.finishedWork = e;
        a.finishedLanes = d;
        switch (b) {
          case 0:
          case 1:
            throw Error(p(345));
          case 2:
            Pk(a, tk, uk);
            break;
          case 3:
            Ck(a, d);
            if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
              if (0 !== uc(a, 0)) break;
              e = a.suspendedLanes;
              if ((e & d) !== d) {
                R();
                a.pingedLanes |= a.suspendedLanes & e;
                break;
              }
              a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
              break;
            }
            Pk(a, tk, uk);
            break;
          case 4:
            Ck(a, d);
            if ((d & 4194240) === d) break;
            b = a.eventTimes;
            for (e = -1; 0 < d; ) {
              var g = 31 - oc(d);
              f2 = 1 << g;
              g = b[g];
              g > e && (e = g);
              d &= ~f2;
            }
            d = e;
            d = B() - d;
            d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3e3 > d ? 3e3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
            if (10 < d) {
              a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
              break;
            }
            Pk(a, tk, uk);
            break;
          case 5:
            Pk(a, tk, uk);
            break;
          default:
            throw Error(p(329));
        }
      }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
  }
  function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
  }
  function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
  }
  function Ok(a) {
    for (var b = a; ; ) {
      if (b.flags & 16384) {
        var c = b.updateQueue;
        if (null !== c && (c = c.stores, null !== c)) for (var d = 0; d < c.length; d++) {
          var e = c[d], f2 = e.getSnapshot;
          e = e.value;
          try {
            if (!He(f2(), e)) return false;
          } catch (g) {
            return false;
          }
        }
      }
      c = b.child;
      if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
      else {
        if (b === a) break;
        for (; null === b.sibling; ) {
          if (null === b.return || b.return === a) return true;
          b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
      }
    }
    return true;
  }
  function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for (a = a.expirationTimes; 0 < b; ) {
      var c = 31 - oc(b), d = 1 << c;
      a[c] = -1;
      b &= ~d;
    }
  }
  function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
      var d = xc(a);
      0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
  }
  function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
      return a(b);
    } finally {
      K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
  }
  function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
      if (ok.transition = null, C = 1, a) return a();
    } finally {
      C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
  }
  function Hj() {
    fj = ej.current;
    E(ej);
  }
  function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for (c = Y.return; null !== c; ) {
      var d = c;
      wg(d);
      switch (d.tag) {
        case 1:
          d = d.type.childContextTypes;
          null !== d && void 0 !== d && $f();
          break;
        case 3:
          zh();
          E(Wf);
          E(H);
          Eh();
          break;
        case 5:
          Bh(d);
          break;
        case 4:
          zh();
          break;
        case 13:
          E(L);
          break;
        case 19:
          E(L);
          break;
        case 10:
          ah(d.type._context);
          break;
        case 22:
        case 23:
          Hj();
      }
      c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
      for (b = 0; b < fh.length; b++) if (c = fh[b], d = c.interleaved, null !== d) {
        c.interleaved = null;
        var e = d.next, f2 = c.pending;
        if (null !== f2) {
          var g = f2.next;
          f2.next = e;
          d.next = g;
        }
        c.pending = d;
      }
      fh = null;
    }
    return a;
  }
  function Mk(a, b) {
    do {
      var c = Y;
      try {
        $g();
        Fh.current = Rh;
        if (Ih) {
          for (var d = M.memoizedState; null !== d; ) {
            var e = d.queue;
            null !== e && (e.pending = null);
            d = d.next;
          }
          Ih = false;
        }
        Hh = 0;
        O = N = M = null;
        Jh = false;
        Kh = 0;
        nk.current = null;
        if (null === c || null === c.return) {
          T = 1;
          pk = b;
          Y = null;
          break;
        }
        a: {
          var f2 = a, g = c.return, h = c, k2 = b;
          b = Z;
          h.flags |= 32768;
          if (null !== k2 && "object" === typeof k2 && "function" === typeof k2.then) {
            var l2 = k2, m2 = h, q2 = m2.tag;
            if (0 === (m2.mode & 1) && (0 === q2 || 11 === q2 || 15 === q2)) {
              var r2 = m2.alternate;
              r2 ? (m2.updateQueue = r2.updateQueue, m2.memoizedState = r2.memoizedState, m2.lanes = r2.lanes) : (m2.updateQueue = null, m2.memoizedState = null);
            }
            var y2 = Ui(g);
            if (null !== y2) {
              y2.flags &= -257;
              Vi(y2, g, h, f2, b);
              y2.mode & 1 && Si(f2, l2, b);
              b = y2;
              k2 = l2;
              var n2 = b.updateQueue;
              if (null === n2) {
                var t2 = /* @__PURE__ */ new Set();
                t2.add(k2);
                b.updateQueue = t2;
              } else n2.add(k2);
              break a;
            } else {
              if (0 === (b & 1)) {
                Si(f2, l2, b);
                tj();
                break a;
              }
              k2 = Error(p(426));
            }
          } else if (I && h.mode & 1) {
            var J2 = Ui(g);
            if (null !== J2) {
              0 === (J2.flags & 65536) && (J2.flags |= 256);
              Vi(J2, g, h, f2, b);
              Jg(Ji(k2, h));
              break a;
            }
          }
          f2 = k2 = Ji(k2, h);
          4 !== T && (T = 2);
          null === sk ? sk = [f2] : sk.push(f2);
          f2 = g;
          do {
            switch (f2.tag) {
              case 3:
                f2.flags |= 65536;
                b &= -b;
                f2.lanes |= b;
                var x2 = Ni(f2, k2, b);
                ph(f2, x2);
                break a;
              case 1:
                h = k2;
                var w2 = f2.type, u2 = f2.stateNode;
                if (0 === (f2.flags & 128) && ("function" === typeof w2.getDerivedStateFromError || null !== u2 && "function" === typeof u2.componentDidCatch && (null === Ri || !Ri.has(u2)))) {
                  f2.flags |= 65536;
                  b &= -b;
                  f2.lanes |= b;
                  var F2 = Qi(f2, h, b);
                  ph(f2, F2);
                  break a;
                }
            }
            f2 = f2.return;
          } while (null !== f2);
        }
        Sk(c);
      } catch (na) {
        b = na;
        Y === c && null !== c && (Y = c = c.return);
        continue;
      }
      break;
    } while (1);
  }
  function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
  }
  function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
  }
  function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    do
      try {
        Tk();
        break;
      } catch (e) {
        Mk(a, e);
      }
    while (1);
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
  }
  function Tk() {
    for (; null !== Y; ) Uk(Y);
  }
  function Lk() {
    for (; null !== Y && !cc(); ) Uk(Y);
  }
  function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
  }
  function Sk(a) {
    var b = a;
    do {
      var c = b.alternate;
      a = b.return;
      if (0 === (b.flags & 32768)) {
        if (c = Ej(c, b, fj), null !== c) {
          Y = c;
          return;
        }
      } else {
        c = Ij(c, b);
        if (null !== c) {
          c.flags &= 32767;
          Y = c;
          return;
        }
        if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
        else {
          T = 6;
          Y = null;
          return;
        }
      }
      b = b.sibling;
      if (null !== b) {
        Y = b;
        return;
      }
      Y = b = a;
    } while (null !== b);
    0 === T && (T = 5);
  }
  function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
      ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally {
      ok.transition = e, C = d;
    }
    return null;
  }
  function Wk(a, b, c, d) {
    do
      Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f2 = c.lanes | c.childLanes;
    Bc(a, f2);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = true, Fk(hc, function() {
      Hk();
      return null;
    }));
    f2 = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f2) {
      f2 = ok.transition;
      ok.transition = null;
      var g = C;
      C = 1;
      var h = K;
      K |= 4;
      nk.current = null;
      Oj(a, c);
      dk(c, a);
      Oe(Df);
      dd = !!Cf;
      Df = Cf = null;
      a.current = c;
      hk(c);
      dc();
      K = h;
      C = g;
      ok.transition = f2;
    } else a.current = c;
    vk && (vk = false, wk = a, xk = e);
    f2 = a.pendingLanes;
    0 === f2 && (Ri = null);
    mc(c.stateNode);
    Dk(a, B());
    if (null !== b) for (d = a.onRecoverableError, c = 0; c < b.length; c++) e = b[c], d(e.value, { componentStack: e.stack, digest: e.digest });
    if (Oi) throw Oi = false, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f2 = a.pendingLanes;
    0 !== (f2 & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
  }
  function Hk() {
    if (null !== wk) {
      var a = Dc(xk), b = ok.transition, c = C;
      try {
        ok.transition = null;
        C = 16 > a ? 16 : a;
        if (null === wk) var d = false;
        else {
          a = wk;
          wk = null;
          xk = 0;
          if (0 !== (K & 6)) throw Error(p(331));
          var e = K;
          K |= 4;
          for (V = a.current; null !== V; ) {
            var f2 = V, g = f2.child;
            if (0 !== (V.flags & 16)) {
              var h = f2.deletions;
              if (null !== h) {
                for (var k2 = 0; k2 < h.length; k2++) {
                  var l2 = h[k2];
                  for (V = l2; null !== V; ) {
                    var m2 = V;
                    switch (m2.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Pj(8, m2, f2);
                    }
                    var q2 = m2.child;
                    if (null !== q2) q2.return = m2, V = q2;
                    else for (; null !== V; ) {
                      m2 = V;
                      var r2 = m2.sibling, y2 = m2.return;
                      Sj(m2);
                      if (m2 === l2) {
                        V = null;
                        break;
                      }
                      if (null !== r2) {
                        r2.return = y2;
                        V = r2;
                        break;
                      }
                      V = y2;
                    }
                  }
                }
                var n2 = f2.alternate;
                if (null !== n2) {
                  var t2 = n2.child;
                  if (null !== t2) {
                    n2.child = null;
                    do {
                      var J2 = t2.sibling;
                      t2.sibling = null;
                      t2 = J2;
                    } while (null !== t2);
                  }
                }
                V = f2;
              }
            }
            if (0 !== (f2.subtreeFlags & 2064) && null !== g) g.return = f2, V = g;
            else b: for (; null !== V; ) {
              f2 = V;
              if (0 !== (f2.flags & 2048)) switch (f2.tag) {
                case 0:
                case 11:
                case 15:
                  Pj(9, f2, f2.return);
              }
              var x2 = f2.sibling;
              if (null !== x2) {
                x2.return = f2.return;
                V = x2;
                break b;
              }
              V = f2.return;
            }
          }
          var w2 = a.current;
          for (V = w2; null !== V; ) {
            g = V;
            var u2 = g.child;
            if (0 !== (g.subtreeFlags & 2064) && null !== u2) u2.return = g, V = u2;
            else b: for (g = w2; null !== V; ) {
              h = V;
              if (0 !== (h.flags & 2048)) try {
                switch (h.tag) {
                  case 0:
                  case 11:
                  case 15:
                    Qj(9, h);
                }
              } catch (na) {
                W(h, h.return, na);
              }
              if (h === g) {
                V = null;
                break b;
              }
              var F2 = h.sibling;
              if (null !== F2) {
                F2.return = h.return;
                V = F2;
                break b;
              }
              V = h.return;
            }
          }
          K = e;
          jg();
          if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
            lc.onPostCommitFiberRoot(kc, a);
          } catch (na) {
          }
          d = true;
        }
        return d;
      } finally {
        C = c, ok.transition = b;
      }
    }
    return false;
  }
  function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
  }
  function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for (; null !== b; ) {
      if (3 === b.tag) {
        Xk(b, a, c);
        break;
      } else if (1 === b.tag) {
        var d = b.stateNode;
        if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
          a = Ji(c, a);
          a = Qi(b, a, 1);
          b = nh(b, a, 1);
          a = R();
          null !== b && (Ac(b, 1, a), Dk(b, a));
          break;
        }
      }
      b = b.return;
    }
  }
  function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
  }
  function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
  }
  function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
  }
  function bk(a, b) {
    var c = 0;
    switch (a.tag) {
      case 13:
        var d = a.stateNode;
        var e = a.memoizedState;
        null !== e && (c = e.retryLane);
        break;
      case 19:
        d = a.stateNode;
        break;
      default:
        throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
  }
  var Vk;
  Vk = function(a, b, c) {
    if (null !== a) if (a.memoizedProps !== b.pendingProps || Wf.current) dh = true;
    else {
      if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = false, yj(a, b, c);
      dh = 0 !== (a.flags & 131072) ? true : false;
    }
    else dh = false, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch (b.tag) {
      case 2:
        var d = b.type;
        ij(a, b);
        a = b.pendingProps;
        var e = Yf(b, H.current);
        ch(b, c);
        e = Nh(null, b, d, a, e, c);
        var f2 = Sh();
        b.flags |= 1;
        "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f2 = true, cg(b)) : f2 = false, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, true, f2, c)) : (b.tag = 0, I && f2 && vg(b), Xi(null, b, e, c), b = b.child);
        return b;
      case 16:
        d = b.elementType;
        a: {
          ij(a, b);
          a = b.pendingProps;
          e = d._init;
          d = e(d._payload);
          b.type = d;
          e = b.tag = Zk(d);
          a = Ci(d, a);
          switch (e) {
            case 0:
              b = cj(null, b, d, a, c);
              break a;
            case 1:
              b = hj(null, b, d, a, c);
              break a;
            case 11:
              b = Yi(null, b, d, a, c);
              break a;
            case 14:
              b = $i(null, b, d, Ci(d.type, a), c);
              break a;
          }
          throw Error(p(
            306,
            d,
            ""
          ));
        }
        return b;
      case 0:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
      case 1:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
      case 3:
        a: {
          kj(b);
          if (null === a) throw Error(p(387));
          d = b.pendingProps;
          f2 = b.memoizedState;
          e = f2.element;
          lh(a, b);
          qh(b, d, null, c);
          var g = b.memoizedState;
          d = g.element;
          if (f2.isDehydrated) if (f2 = { element: d, isDehydrated: false, cache: g.cache, pendingSuspenseBoundaries: g.pendingSuspenseBoundaries, transitions: g.transitions }, b.updateQueue.baseState = f2, b.memoizedState = f2, b.flags & 256) {
            e = Ji(Error(p(423)), b);
            b = lj(a, b, d, c, e);
            break a;
          } else if (d !== e) {
            e = Ji(Error(p(424)), b);
            b = lj(a, b, d, c, e);
            break a;
          } else for (yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = true, zg = null, c = Vg(b, null, d, c), b.child = c; c; ) c.flags = c.flags & -3 | 4096, c = c.sibling;
          else {
            Ig();
            if (d === e) {
              b = Zi(a, b, c);
              break a;
            }
            Xi(a, b, d, c);
          }
          b = b.child;
        }
        return b;
      case 5:
        return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f2 = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f2 && Ef(d, f2) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
      case 6:
        return null === a && Eg(b), null;
      case 13:
        return oj(a, b, c);
      case 4:
        return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
      case 11:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
      case 7:
        return Xi(a, b, b.pendingProps, c), b.child;
      case 8:
        return Xi(a, b, b.pendingProps.children, c), b.child;
      case 12:
        return Xi(a, b, b.pendingProps.children, c), b.child;
      case 10:
        a: {
          d = b.type._context;
          e = b.pendingProps;
          f2 = b.memoizedProps;
          g = e.value;
          G(Wg, d._currentValue);
          d._currentValue = g;
          if (null !== f2) if (He(f2.value, g)) {
            if (f2.children === e.children && !Wf.current) {
              b = Zi(a, b, c);
              break a;
            }
          } else for (f2 = b.child, null !== f2 && (f2.return = b); null !== f2; ) {
            var h = f2.dependencies;
            if (null !== h) {
              g = f2.child;
              for (var k2 = h.firstContext; null !== k2; ) {
                if (k2.context === d) {
                  if (1 === f2.tag) {
                    k2 = mh(-1, c & -c);
                    k2.tag = 2;
                    var l2 = f2.updateQueue;
                    if (null !== l2) {
                      l2 = l2.shared;
                      var m2 = l2.pending;
                      null === m2 ? k2.next = k2 : (k2.next = m2.next, m2.next = k2);
                      l2.pending = k2;
                    }
                  }
                  f2.lanes |= c;
                  k2 = f2.alternate;
                  null !== k2 && (k2.lanes |= c);
                  bh(
                    f2.return,
                    c,
                    b
                  );
                  h.lanes |= c;
                  break;
                }
                k2 = k2.next;
              }
            } else if (10 === f2.tag) g = f2.type === b.type ? null : f2.child;
            else if (18 === f2.tag) {
              g = f2.return;
              if (null === g) throw Error(p(341));
              g.lanes |= c;
              h = g.alternate;
              null !== h && (h.lanes |= c);
              bh(g, c, b);
              g = f2.sibling;
            } else g = f2.child;
            if (null !== g) g.return = f2;
            else for (g = f2; null !== g; ) {
              if (g === b) {
                g = null;
                break;
              }
              f2 = g.sibling;
              if (null !== f2) {
                f2.return = g.return;
                g = f2;
                break;
              }
              g = g.return;
            }
            f2 = g;
          }
          Xi(a, b, e.children, c);
          b = b.child;
        }
        return b;
      case 9:
        return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
      case 14:
        return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
      case 15:
        return bj(a, b, b.type, b.pendingProps, c);
      case 17:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = true, cg(b)) : a = false, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, true, a, c);
      case 19:
        return xj(a, b, c);
      case 22:
        return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
  };
  function Fk(a, b) {
    return ac(a, b);
  }
  function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
  }
  function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
  }
  function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
  }
  function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
      a = a.$$typeof;
      if (a === Da) return 11;
      if (a === Ga) return 14;
    }
    return 2;
  }
  function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : { lanes: b.lanes, firstContext: b.firstContext };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
  }
  function Rg(a, b, c, d, e, f2) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch (a) {
      case ya:
        return Tg(c.children, e, f2, b);
      case za:
        g = 8;
        e |= 8;
        break;
      case Aa:
        return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f2, a;
      case Ea:
        return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f2, a;
      case Fa:
        return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f2, a;
      case Ia:
        return pj(c, e, f2, b);
      default:
        if ("object" === typeof a && null !== a) switch (a.$$typeof) {
          case Ba:
            g = 10;
            break a;
          case Ca:
            g = 9;
            break a;
          case Da:
            g = 11;
            break a;
          case Ga:
            g = 14;
            break a;
          case Ha:
            g = 16;
            d = null;
            break a;
        }
        throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f2;
    return b;
  }
  function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
  }
  function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = { isHidden: false };
    return a;
  }
  function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
  }
  function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = { containerInfo: a.containerInfo, pendingChildren: null, implementation: a.implementation };
    return b;
  }
  function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
  }
  function bl(a, b, c, d, e, f2, g, h, k2) {
    a = new al(a, b, c, h, k2);
    1 === b ? (b = 1, true === f2 && (b |= 8)) : b = 0;
    f2 = Bg(3, null, null, b);
    a.current = f2;
    f2.stateNode = a;
    f2.memoizedState = { element: d, isDehydrated: c, cache: null, transitions: null, pendingSuspenseBoundaries: null };
    kh(f2);
    return a;
  }
  function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return { $$typeof: wa, key: null == d ? null : "" + d, children: a, containerInfo: b, implementation: c };
  }
  function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
      if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
      var b = a;
      do {
        switch (b.tag) {
          case 3:
            b = b.stateNode.context;
            break a;
          case 1:
            if (Zf(b.type)) {
              b = b.stateNode.__reactInternalMemoizedMergedChildContext;
              break a;
            }
        }
        b = b.return;
      } while (null !== b);
      throw Error(p(171));
    }
    if (1 === a.tag) {
      var c = a.type;
      if (Zf(c)) return bg(a, c, b);
    }
    return b;
  }
  function el(a, b, c, d, e, f2, g, h, k2) {
    a = bl(c, d, true, a, e, f2, g, h, k2);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f2 = mh(d, e);
    f2.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f2, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
  }
  function fl(a, b, c, d) {
    var e = b.current, f2 = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f2, g);
    b.payload = { element: a };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f2), oh(a, e, g));
    return g;
  }
  function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch (a.child.tag) {
      case 5:
        return a.child.stateNode;
      default:
        return a.child.stateNode;
    }
  }
  function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
      var c = a.retryLane;
      a.retryLane = 0 !== c && c < b ? c : b;
    }
  }
  function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
  }
  function jl() {
    return null;
  }
  var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
  };
  function ll(a) {
    this._internalRoot = a;
  }
  ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
  };
  ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
      this._internalRoot = null;
      var b = a.containerInfo;
      Rk(function() {
        fl(null, a, null, null);
      });
      b[uf] = null;
    }
  };
  function ml(a) {
    this._internalRoot = a;
  }
  ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
      var b = Hc();
      a = { blockedOn: null, target: a, priority: b };
      for (var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++) ;
      Qc.splice(c, 0, a);
      0 === c && Vc(a);
    }
  };
  function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
  }
  function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
  }
  function pl() {
  }
  function ql(a, b, c, d, e) {
    if (e) {
      if ("function" === typeof d) {
        var f2 = d;
        d = function() {
          var a2 = gl(g);
          f2.call(a2);
        };
      }
      var g = el(b, d, a, 0, null, false, false, "", pl);
      a._reactRootContainer = g;
      a[uf] = g.current;
      sf(8 === a.nodeType ? a.parentNode : a);
      Rk();
      return g;
    }
    for (; e = a.lastChild; ) a.removeChild(e);
    if ("function" === typeof d) {
      var h = d;
      d = function() {
        var a2 = gl(k2);
        h.call(a2);
      };
    }
    var k2 = bl(a, 0, false, null, null, false, false, "", pl);
    a._reactRootContainer = k2;
    a[uf] = k2.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
      fl(b, k2, c, d);
    });
    return k2;
  }
  function rl(a, b, c, d, e) {
    var f2 = c._reactRootContainer;
    if (f2) {
      var g = f2;
      if ("function" === typeof e) {
        var h = e;
        e = function() {
          var a2 = gl(g);
          h.call(a2);
        };
      }
      fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
  }
  Ec = function(a) {
    switch (a.tag) {
      case 3:
        var b = a.stateNode;
        if (b.current.memoizedState.isDehydrated) {
          var c = tc(b.pendingLanes);
          0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
        }
        break;
      case 13:
        Rk(function() {
          var b2 = ih(a, 1);
          if (null !== b2) {
            var c2 = R();
            gi(b2, a, 1, c2);
          }
        }), il(a, 1);
    }
  };
  Fc = function(a) {
    if (13 === a.tag) {
      var b = ih(a, 134217728);
      if (null !== b) {
        var c = R();
        gi(b, a, 134217728, c);
      }
      il(a, 134217728);
    }
  };
  Gc = function(a) {
    if (13 === a.tag) {
      var b = yi(a), c = ih(a, b);
      if (null !== c) {
        var d = R();
        gi(c, a, b, d);
      }
      il(a, b);
    }
  };
  Hc = function() {
    return C;
  };
  Ic = function(a, b) {
    var c = C;
    try {
      return C = a, b();
    } finally {
      C = c;
    }
  };
  yb = function(a, b, c) {
    switch (b) {
      case "input":
        bb(a, c);
        b = c.name;
        if ("radio" === c.type && null != b) {
          for (c = a; c.parentNode; ) c = c.parentNode;
          c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
          for (b = 0; b < c.length; b++) {
            var d = c[b];
            if (d !== a && d.form === a.form) {
              var e = Db(d);
              if (!e) throw Error(p(90));
              Wa(d);
              bb(d, e);
            }
          }
        }
        break;
      case "textarea":
        ib(a, c);
        break;
      case "select":
        b = c.value, null != b && fb(a, !!c.multiple, b, false);
    }
  };
  Gb = Qk;
  Hb = Rk;
  var sl = { usingClientEntryPoint: false, Events: [Cb, ue, Db, Eb, Fb, Qk] }, tl = { findFiberByHostInstance: Wc, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" };
  var ul = { bundleType: tl.bundleType, version: tl.version, rendererPackageName: tl.rendererPackageName, rendererConfig: tl.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: ua.ReactCurrentDispatcher, findHostInstanceByFiber: function(a) {
    a = Zb(a);
    return null === a ? null : a.stateNode;
  }, findFiberByHostInstance: tl.findFiberByHostInstance || jl, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
      kc = vl.inject(ul), lc = vl;
    } catch (a) {
    }
  }
  reactDom_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
  reactDom_production_min.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
  };
  reactDom_production_min.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = false, d = "", e = kl;
    null !== b && void 0 !== b && (true === b.unstable_strictMode && (c = true), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, false, null, null, c, false, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
  };
  reactDom_production_min.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
      if ("function" === typeof a.render) throw Error(p(188));
      a = Object.keys(a).join(",");
      throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
  };
  reactDom_production_min.flushSync = function(a) {
    return Rk(a);
  };
  reactDom_production_min.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, true, c);
  };
  reactDom_production_min.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = false, f2 = "", g = kl;
    null !== c && void 0 !== c && (true === c.unstable_strictMode && (e = true), void 0 !== c.identifierPrefix && (f2 = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, false, f2, g);
    a[uf] = b.current;
    sf(a);
    if (d) for (a = 0; a < d.length; a++) c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [c, e] : b.mutableSourceEagerHydrationData.push(
      c,
      e
    );
    return new ml(b);
  };
  reactDom_production_min.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, false, c);
  };
  reactDom_production_min.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
      rl(null, null, a, false, function() {
        a._reactRootContainer = null;
        a[uf] = null;
      });
    }), true) : false;
  };
  reactDom_production_min.unstable_batchedUpdates = Qk;
  reactDom_production_min.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, false, d);
  };
  reactDom_production_min.version = "18.3.1-next-f1338f8080-20240426";
  function checkDCE() {
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") {
      return;
    }
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
      console.error(err);
    }
  }
  {
    checkDCE();
    reactDom.exports = reactDom_production_min;
  }
  var reactDomExports = reactDom.exports;
  var m = reactDomExports;
  {
    client.createRoot = m.createRoot;
    client.hydrateRoot = m.hydrateRoot;
  }
  function floorCard(c) {
    const s = c.scryfallId;
    return {
      id: c.cardId,
      name: c.name,
      nameFr: c.nameFr ?? null,
      expansion: c.expansionCode,
      expansionCode: c.expansionCode,
      collectorNumber: c.collectorNumber,
      rarity: "Common",
      colors: null,
      typeLine: null,
      imageUrl: s ? `https://cards.scryfall.io/normal/front/${s[0]}/${s[1]}/${s}.jpg` : null,
      scryfallId: s ?? null,
      isBasicLand: false,
      cmEur: 0,
      cmEurFoil: 0,
      languages: ["fr", "en"],
      floorOnly: true
    };
  }
  function variantKey(language, foil) {
    return `${language}${foil ? "f" : ""}`;
  }
  const CONDITIONS = [
    { code: "NM", label: "Near Mint", hint: "Comme neuve, aucun défaut visible" },
    { code: "EX", label: "Excellent", hint: "Micro-usures sur les bords, aucun pli" },
    { code: "GD", label: "Good", hint: "Usure légère mais nette, petites marques" },
    { code: "LP", label: "Light Played", hint: "Usure visible, rayures, bords blanchis" },
    { code: "PL", label: "Played", hint: "Usure marquée, pli léger toléré" }
  ];
  const DEFAULT_VARIANT = { language: "fr", foil: false, condition: "NM" };
  function lineKey(k2) {
    return `${k2.cardId}|${k2.language}|${k2.foil ? "F" : "N"}|${k2.condition}`;
  }
  function injected() {
    if (typeof window === "undefined") return {};
    const w2 = window;
    return w2.CARD_SHOP_CONFIG ?? w2.NEVERMINT_BUYBACK ?? {};
  }
  function getLocale() {
    const raw = injected().locale ?? (typeof navigator === "undefined" ? "fr" : navigator.language) ?? "fr";
    return raw.toLowerCase().startsWith("fr") ? "fr" : "en";
  }
  function getRootUrl() {
    const raw = injected().rootUrl ?? "/";
    return raw === "/" ? "" : raw.replace(/\/$/, "");
  }
  function shopPath(path) {
    return `${getRootUrl()}${path}`;
  }
  function interpolate(raw, vars) {
    if (!vars) return raw;
    return raw.replace(
      /\{(\w+)\}/g,
      (whole, name) => name in vars ? String(vars[name]) : whole
    );
  }
  function normalize(s) {
    return s.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[’‘ʼ]/g, "'").replace(/\s+/g, " ").trim();
  }
  function displayName(card, language) {
    return language === "fr" ? card.nameFr || card.name : card.name;
  }
  function availableVariants(card) {
    const languages = ["fr", "en"];
    if (card.finishOnly === "f") return { languages, foil: true, nonFoil: false };
    if (card.finishOnly === "n") return { languages, foil: false, nonFoil: true };
    const foil = card.cmEurFoil > 0;
    const nonFoil = card.cmEur > 0;
    return {
      languages,
      // Aucune cote des deux côtés : on n'en sait rien, on n'interdit rien.
      foil: foil || !nonFoil,
      nonFoil: nonFoil || !foil
    };
  }
  function clampVariant(card, variant) {
    const v2 = availableVariants(card);
    return {
      ...variant,
      foil: variant.foil ? v2.foil : !v2.nonFoil,
      language: v2.languages.includes(variant.language) ? variant.language : "en"
    };
  }
  const RARITY_FR = {
    Common: "Commune",
    Uncommon: "Peu commune",
    Rare: "Rare",
    Mythic: "Mythique"
  };
  function rarityLabel(code) {
    return getLocale() === "fr" ? RARITY_FR[code] ?? code : code;
  }
  const EMPTY_CATALOG_FILTERS = {
    search: "",
    expansions: [],
    rarity: "",
    // Décoché par défaut : le client cherche SES cartes, pas seulement celles qui
    // atteignent le seuil. En masquer d'emblée une partie donne l'impression d'un
    // catalogue incomplet — celles sous le seuil partent au poids, elles ne sont
    // pas refusées.
    eligibleOnly: false
  };
  const SESSION_SEED = Math.random() * 1e3 + 1;
  function shuffleKey(id2) {
    const x2 = Math.sin(id2 * SESSION_SEED) * 43758.5453;
    return x2 - Math.floor(x2);
  }
  const stripLeadingZeros = (s) => s.replace(/^0+(?=\d)/, "");
  function parseSearch(raw) {
    const q2 = normalize(raw);
    if (!q2) return { text: "", collector: null, expansionCode: null };
    const withSet = q2.match(/^([a-z0-9]{3,5})[ \-]?(\d{1,4})[a-z]?$/);
    if (withSet && /[a-z]/.test(withSet[1])) {
      return {
        text: "",
        collector: stripLeadingZeros(withSet[2]),
        expansionCode: withSet[1].toUpperCase()
      };
    }
    if (/^\d{1,4}$/.test(q2)) {
      return { text: "", collector: stripLeadingZeros(q2), expansionCode: null };
    }
    return { text: q2, collector: null, expansionCode: null };
  }
  function filterCatalog(cards, filters, minRefPrice) {
    const { text, collector, expansionCode } = parseSearch(filters.search);
    return cards.filter((c) => {
      if (filters.eligibleOnly && c.cmEur < minRefPrice && c.cmEurFoil < minRefPrice) return false;
      if (filters.expansions.length > 0 && !filters.expansions.includes(c.expansionCode)) return false;
      if (filters.rarity && c.rarity !== filters.rarity) return false;
      if (collector !== null) {
        if (stripLeadingZeros(normalize(c.collectorNumber)) !== collector) return false;
        if (expansionCode && c.expansionCode !== expansionCode) return false;
        return true;
      }
      if (text && !normalize(c.name).includes(text) && !normalize(c.nameFr ?? "").includes(text)) {
        return false;
      }
      return true;
    });
  }
  function sortCatalog(cards, sort) {
    const out = [...cards];
    switch (sort) {
      case "release":
        return out.sort(
          (a, b) => (b.releasedAt ?? "").localeCompare(a.releasedAt ?? "") || shuffleKey(a.id) - shuffleKey(b.id)
        );
      case "value-desc":
        return out.sort((a, b) => b.cmEur - a.cmEur);
      case "value-asc":
        return out.sort((a, b) => a.cmEur - b.cmEur);
      case "expansion":
        return out.sort(
          (a, b) => a.expansion.localeCompare(b.expansion, "fr") || a.collectorNumber.localeCompare(b.collectorNumber, "fr", { numeric: true })
        );
      default:
        return out.sort((a, b) => a.name.localeCompare(b.name, "fr"));
    }
  }
  function expansionOptions(cards) {
    const m2 = /* @__PURE__ */ new Map();
    for (const c of cards) m2.set(c.expansionCode, c.expansion);
    return [...m2.entries()].map(([code, name]) => ({ code, name })).sort((a, b) => a.name.localeCompare(b.name, "fr"));
  }
  const DEFAULT_CONFIG = {
    minCardPriceEur: 0.25,
    cashRate: 0.7,
    creditRate: 0.85,
    priceTiers: [],
    maxPerCardEur: 50,
    maxCartTotalEur: 300,
    shippingFeeEur: 4.9,
    shippingFreeThresholdEur: 40,
    bulkEnabled: true,
    bulkPricePerKgEur: 6,
    bulkMaxKg: 20,
    conditionMultipliers: { NM: 1, EX: 0.9, GD: 0.75, LP: 0.55, PL: 0.35 },
    requirePriorPurchase: true,
    floorPriceEur: 0.02
  };
  const STORAGE_KEY$2 = "buyback-config-override";
  function loadConfig() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY$2);
      if (!raw) return DEFAULT_CONFIG;
      const parsed = JSON.parse(raw);
      return {
        ...DEFAULT_CONFIG,
        ...parsed,
        priceTiers: Array.isArray(parsed.priceTiers) ? parsed.priceTiers : [],
        conditionMultipliers: {
          ...DEFAULT_CONFIG.conditionMultipliers,
          ...parsed.conditionMultipliers ?? {}
        }
      };
    } catch {
      return DEFAULT_CONFIG;
    }
  }
  function saveConfig(config) {
    localStorage.setItem(STORAGE_KEY$2, JSON.stringify(config));
  }
  function resetConfig() {
    localStorage.removeItem(STORAGE_KEY$2);
  }
  function round2(n2) {
    return Math.round(n2 * 100) / 100;
  }
  function formatEur(n2) {
    return n2.toFixed(2).replace(".", ",") + " €";
  }
  function rateFor(mode, config, conditionedPrice2 = Infinity) {
    const credit = mode === "credit";
    let rate = credit ? config.creditRate : config.cashRate;
    for (const tier of [...config.priceTiers ?? []].sort((a, b) => a.fromEur - b.fromEur)) {
      if (conditionedPrice2 < tier.fromEur) break;
      rate = credit ? tier.creditRate : tier.cashRate;
    }
    return rate;
  }
  function rateRange(mode, config) {
    const credit = mode === "credit";
    const global = credit ? config.creditRate : config.cashRate;
    const tiers = [...config.priceTiers ?? []].sort((a, b) => a.fromEur - b.fromEur);
    const rates = tiers.map((t2) => credit ? t2.creditRate : t2.cashRate);
    if (tiers.length === 0 || tiers[0].fromEur > 0) rates.push(global);
    return { min: Math.min(...rates), max: Math.max(...rates) };
  }
  function formatRate(mode, config) {
    const { min, max } = rateRange(mode, config);
    const lo = Math.round(min * 100);
    const hi2 = Math.round(max * 100);
    return lo === hi2 ? `${hi2} %` : `${lo} à ${hi2} %`;
  }
  function effectiveRate(card, conditionedPrice2, language, foil, mode, config) {
    var _a;
    const deduction = ((_a = card.stockDeduction) == null ? void 0 : _a[variantKey(language, foil)]) ?? 0;
    const bonus = card.wantedBonus ?? 0;
    const rate = rateFor(mode, config, conditionedPrice2) * (1 - deduction) * (1 + bonus);
    return Math.round(Math.min(Math.max(rate, 0), 1) * 1e4) / 1e4;
  }
  function refPrice(card, foil) {
    return foil ? card.cmEurFoil : card.cmEur;
  }
  function conditionedPrice(card, foil, condition, config) {
    return round2(refPrice(card, foil) * (config.conditionMultipliers[condition] ?? 1));
  }
  function quoteUnit(card, language, foil, condition, mode, config) {
    var _a;
    if (card.floorOnly) {
      const unit2 = round2(config.floorPriceEur ?? 0);
      return { ref: 0, refConditioned: 0, raw: unit2, unit: unit2, capped: false, eligible: unit2 > 0, rate: 0, wanted: false, deducted: false };
    }
    const ref = refPrice(card, foil);
    const refConditioned = conditionedPrice(card, foil, condition, config);
    const rate = effectiveRate(card, refConditioned, language, foil, mode, config);
    const raw = round2(refConditioned * rate);
    const unit = Math.min(raw, config.maxPerCardEur);
    return {
      ref,
      refConditioned,
      raw,
      unit: round2(unit),
      capped: raw > config.maxPerCardEur,
      eligible: refConditioned >= config.minCardPriceEur,
      rate,
      wanted: (card.wantedBonus ?? 0) > 0,
      deducted: (((_a = card.stockDeduction) == null ? void 0 : _a[variantKey(language, foil)]) ?? 0) > 0
    };
  }
  function quoteCart(state, cardsById, config) {
    const lines = [];
    for (const line of state.lines) {
      const card = cardsById.get(line.cardId);
      if (!card) continue;
      const quote = quoteUnit(card, line.language, line.foil, line.condition, state.payoutMode, config);
      const lineOffer = quote.eligible ? round2(quote.unit * line.quantity) : 0;
      lines.push({ ...line, card, quote, lineOffer });
    }
    const itemsValue = round2(lines.reduce((s, l2) => s + l2.lineOffer, 0));
    const bulkValue = 0;
    const subtotal = itemsValue;
    const shippingFee = subtotal <= 0 || subtotal >= config.shippingFreeThresholdEur ? 0 : config.shippingFeeEur;
    const missingForFreeShipping = shippingFee > 0 ? round2(config.shippingFreeThresholdEur - subtotal) : 0;
    const overCartCapBy = round2(Math.max(0, subtotal - config.maxCartTotalEur));
    return {
      lines,
      cardCount: lines.reduce((s, l2) => s + l2.quantity, 0),
      itemsValue,
      bulkValue,
      subtotal,
      shippingFee,
      total: round2(Math.max(0, subtotal - shippingFee)),
      missingForFreeShipping,
      overCartCap: overCartCapBy > 0,
      overCartCapBy,
      hasCappedLine: lines.some((l2) => l2.quote.capped),
      hasIneligibleLine: lines.some((l2) => !l2.quote.eligible)
    };
  }
  function payoutDelta(state, cardsById, config) {
    const other = state.payoutMode === "cash" ? "credit" : "cash";
    const here = quoteCart(state, cardsById, config).total;
    const there = quoteCart({ ...state, payoutMode: other }, cardsById, config).total;
    return round2(there - here);
  }
  function maxAddable(unitOffer, subtotal, config) {
    if (unitOffer <= 0) return Infinity;
    return Math.max(0, Math.floor((config.maxCartTotalEur - subtotal) / unitOffer));
  }
  const STORAGE_KEY$1 = "buyback-cart";
  const STAMP_KEY = "buyback-cart-at";
  const EMPTY$1 = {
    lines: [],
    payoutMode: "cash",
    bulkKg: 0,
    bulkNoBasics: false
  };
  function read() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY$1);
      if (!raw) return EMPTY$1;
      const parsed = JSON.parse(raw);
      return {
        lines: Array.isArray(parsed.lines) ? parsed.lines : [],
        payoutMode: parsed.payoutMode === "credit" ? "credit" : "cash",
        bulkKg: typeof parsed.bulkKg === "number" ? parsed.bulkKg : 0,
        bulkNoBasics: parsed.bulkNoBasics === true,
        extraCards: parsed.extraCards && typeof parsed.extraCards === "object" ? parsed.extraCards : {}
      };
    } catch {
      return EMPTY$1;
    }
  }
  const Ctx = reactExports.createContext(null);
  function withMeta(line, meta) {
    if (!meta) return line;
    return {
      ...line,
      origins: [.../* @__PURE__ */ new Set([...line.origins ?? [], meta.origin])],
      photoIds: meta.photoId ? [.../* @__PURE__ */ new Set([...line.photoIds ?? [], meta.photoId])] : line.photoIds
    };
  }
  function BuybackCartProvider({ children }) {
    const [state, setState] = reactExports.useState(read);
    reactExports.useEffect(() => {
      try {
        localStorage.setItem(STORAGE_KEY$1, JSON.stringify(state));
        localStorage.setItem(STAMP_KEY, (/* @__PURE__ */ new Date()).toISOString());
      } catch {
      }
    }, [state]);
    const setQty = reactExports.useCallback((k2, qty, meta) => {
      const key = lineKey(k2);
      const next = Math.max(0, Math.min(Math.round(qty), 99));
      setState((prev) => {
        const index = prev.lines.findIndex((l2) => l2.key === key);
        if (index === -1) {
          if (next === 0) return prev;
          const line = {
            cardId: k2.cardId,
            language: k2.language,
            foil: k2.foil,
            condition: k2.condition,
            key,
            quantity: next,
            ...meta ? { origins: [meta.origin], photoIds: meta.photoId ? [meta.photoId] : [] } : {}
          };
          return { ...prev, lines: [line, ...prev.lines] };
        }
        if (next === 0) {
          return { ...prev, lines: prev.lines.filter((_, i) => i !== index) };
        }
        const lines = [...prev.lines];
        lines[index] = withMeta({ ...lines[index], quantity: next }, meta);
        return { ...prev, lines };
      });
    }, []);
    const value = reactExports.useMemo(() => {
      const qtyOf = (k2) => {
        var _a;
        return ((_a = state.lines.find((l2) => l2.key === lineKey(k2))) == null ? void 0 : _a.quantity) ?? 0;
      };
      return {
        state,
        qtyOf,
        setQty,
        add: (k2, qty, meta) => setQty(k2, qtyOf(k2) + qty, meta),
        remove: (k2) => setQty(k2, 0),
        setVariant: (from, to) => {
          const fromKey = lineKey(from);
          const toKey = lineKey(to);
          if (fromKey === toKey) return;
          setState((prev) => {
            const index = prev.lines.findIndex((l2) => l2.key === fromKey);
            if (index === -1) return prev;
            const existing = prev.lines.find((l2) => l2.key === toKey);
            const source = prev.lines[index];
            const merged = {
              ...to,
              key: toKey,
              quantity: Math.min(99, source.quantity + ((existing == null ? void 0 : existing.quantity) ?? 0)),
              // Changer d'état ne change pas d'où vient la carte.
              origins: [.../* @__PURE__ */ new Set([...source.origins ?? [], ...(existing == null ? void 0 : existing.origins) ?? []])],
              photoIds: [.../* @__PURE__ */ new Set([...source.photoIds ?? [], ...(existing == null ? void 0 : existing.photoIds) ?? []])]
            };
            const lines = prev.lines.map((l2, i) => i === index ? merged : l2).filter((l2, i) => i === index || l2.key !== toKey);
            return { ...prev, lines };
          });
        },
        setPayoutMode: (payoutMode) => setState((prev) => ({ ...prev, payoutMode })),
        setBulkKg: (bulkKg) => setState((prev) => ({ ...prev, bulkKg: Math.max(0, bulkKg) })),
        setBulkNoBasics: (bulkNoBasics) => setState((prev) => ({ ...prev, bulkNoBasics })),
        registerCard: (card) => setState((prev) => ({ ...prev, extraCards: { ...prev.extraCards ?? {}, [card.id]: card } })),
        clear: () => setState(EMPTY$1),
        /**
         * Remplace le panier par celui du serveur.
         *
         * Sert au passage d'un appareil à l'autre : le panier appartient au
         * compte client, pas au navigateur. On ne fusionne pas — deux paniers
         * divergents ne se marient pas sans arbitraire, et le plus récent est ce
         * que le client a sous les yeux dans sa tête.
         */
        replaceAll: (next) => setState(next),
        /** Date de la dernière modification locale, pour comparer au serveur. */
        localUpdatedAt: () => {
          try {
            return localStorage.getItem(STAMP_KEY);
          } catch {
            return null;
          }
        }
      };
    }, [state, setQty]);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Ctx.Provider, { value, children });
  }
  function useBuybackCart() {
    const ctx = reactExports.useContext(Ctx);
    if (!ctx) throw new Error("useBuybackCart must be used within BuybackCartProvider");
    return ctx;
  }
  const FR$1 = {
    // ─── Chargement, erreurs ─────────────────────────────────────────────────
    "catalog.loading": "Chargement du catalogue…",
    "catalog.error.title": "Erreur de chargement",
    "catalog.error.body": "Impossible de charger le catalogue.",
    "catalog.empty": "Aucune carte ne correspond à ces critères.",
    "catalog.reset": "Réinitialiser les filtres",
    "cart.error.title": "Erreur panier",
    "cart.error.body": "Impossible de charger le panier.",
    // ─── En-tête ─────────────────────────────────────────────────────────────
    "header.title": "Cartes à l’unité",
    "header.freeShipping": "Livraison gratuite en France Métropolitaine en point relais à partir de 60 EUR.",
    // ─── Panier ──────────────────────────────────────────────────────────────
    "cart.title": "Panier",
    "cart.empty": "Votre panier est vide.",
    "cart.clear": "Vider le panier",
    "cart.otherItems": "Autres articles du panier",
    "cart.standaloneNotice": "Mode standalone : le paiement passe par Shopify une fois la page intégrée à la boutique.",
    "cart.add": "Ajouter au panier",
    "cart.addOne": "Ajouter un exemplaire",
    "cart.removeOne": "Enlever un exemplaire",
    "cart.removeAll": "Retirer du panier",
    "cart.maxReached": "Stock maximum au panier",
    "cart.added": "✓ Ajouté au panier",
    // ─── Filtres ─────────────────────────────────────────────────────────────
    "filter.search": "Rechercher une carte (FR ou EN)…",
    "filter.searchOracle": "Chercher aussi dans le texte des cartes (effets)",
    "filter.searchOracleOn": "La recherche couvre aussi le texte des cartes — cliquer pour désactiver",
    "filter.clearAll": "Tout effacer",
    "filter.name": "Filtrer (FR ou EN)…",
    "filter.expansions": "Filtrer les extensions…",
    "filter.keywords": "Filtrer les mots-clés (FR ou EN)…",
    "filter.noExpansion": "Aucune extension trouvée.",
    "filter.noType": "Aucun type trouvé.",
    "filter.noKeyword": "Aucun mot-clé trouvé.",
    "filter.creatureType": "Type de créature",
    "filter.manaCost": "Coût de mana",
    "filter.allFormats": "Tous les formats",
    "filter.allLanguages": "Toutes les langues",
    "filter.legendary": "⭐ Légendaire",
    "filter.legendaryOnly": "⭐ Légendaire uniquement",
    "filter.condition": "État : NM",
    "filter.conditionNote": "Tout le stock actuel est Near Mint",
    "filter.min": "Min",
    "filter.max": "Max",
    "filter.french": "🇫🇷 Français",
    "filter.english": "🇬🇧 Anglais",
    "sort.priceAsc": "Prix croissant",
    "sort.priceDesc": "Prix décroissant",
    "view.grid": "Vue grille",
    "view.list": "Vue liste compacte",
    "filter.manaValue": "Valeur de mana {value}",
    // ─── Fiche carte ─────────────────────────────────────────────────────────
    "card.prev": "Carte précédente",
    "card.next": "Carte suivante",
    "card.close": "Fermer",
    "card.previousShort": "‹ Précédente",
    "card.front": "Voir le recto",
    "card.back": "Voir le verso",
    "card.rarity": "Rareté",
    "card.condition": "État",
    "card.keywords": "Mots-clés",
    "card.oracle": "Texte de la carte",
    "card.synergies": "Fonctionne bien avec",
    "card.scryfall": "Voir sur Scryfall ↗",
    "card.allVersions": "Voir toutes les versions (extensions, langues, finitions)",
    "card.badge.new": "🆕 Nouveau",
    "card.badge.restock": "↺ Restock",
    "card.secondHand": "Occasion",
    "card.secondHandNote": "Carte d'occasion : elle a déjà eu un propriétaire, quel que soit son état de jeu. Elle bénéficie de la garantie légale de conformité de 2 ans ; pour un bien d'occasion, un défaut apparu dans les 12 mois suivant la livraison est présumé exister dès la vente (art. L217-7 du Code de la consommation).",
    // ─── Synergies du panier ─────────────────────────────────────────────────
    "synergies.intro": "Synergies EDHREC des cartes de votre panier, disponibles en boutique.",
    // ─── Import de decklist ──────────────────────────────────────────────────
    "deck.open": "Importer une liste",
    "deck.openLabel": "📋 Importer une liste",
    "deck.title": "Importer une decklist",
    "deck.help": "Collez votre liste (MTGA, Moxfield, texte…) — une carte par ligne, ex. « 4 Sol Ring ».",
    "deck.resultPlaceholder": "Le résultat de la correspondance avec le stock s’affichera ici.",
    "deck.copyMissing": "Copier les manquantes",
    "deck.addCards": "Ajouter {count} carte au panier",
    "deck.addCards_plural": "Ajouter {count} cartes au panier",
    // ─── Ajouts ────────────────────────────────────────────────────────────
    "card.type": "Type",
    "card.versions": "⧉ Voir les {count} versions",
    "card.inCart": "🛒 Déjà {count} dans votre panier",
    "cart.cards": "{count} carte",
    "cart.cards_plural": "{count} cartes",
    "deck.stockWarning": "⚠ Seulement {available} en stock sur {asked} demandées",
    "filter.all": "Toutes",
    "filter.conditionLabel": "État :",
    "filter.conditionFull": "Near Mint — tout le stock actuel",
    "filter.showResults": "Voir {count} carte",
    "filter.showResults_plural": "Voir {count} cartes",
    "filter.colors": "Couleurs",
    "filter.format": "Format",
    "filter.expansion": "Extension",
    "filter.language": "Langue",
    "filter.finish": "Finition",
    "filter.price": "Prix",
    "filter.type": "Type",
    "filter.land": "Terrain :",
    "filter.creature": "Créature :",
    "lang.frCard": "Carte en français",
    "lang.enCard": "Carte en anglais"
  };
  const EN$1 = {
    "catalog.loading": "Loading the catalogue…",
    "catalog.error.title": "Loading error",
    "catalog.error.body": "The catalogue could not be loaded.",
    "catalog.empty": "No card matches these filters.",
    "catalog.reset": "Reset filters",
    "cart.error.title": "Cart error",
    "cart.error.body": "The cart could not be loaded.",
    "header.title": "Single cards",
    "header.freeShipping": "Free pickup-point delivery in mainland France from €60.",
    "cart.title": "Cart",
    "cart.empty": "Your cart is empty.",
    "cart.clear": "Empty the cart",
    "cart.otherItems": "Other items in your cart",
    "cart.standaloneNotice": "Standalone mode: checkout goes through Shopify once the page is embedded in the shop.",
    "cart.add": "Add to cart",
    "cart.addOne": "Add one",
    "cart.removeOne": "Remove one",
    "cart.removeAll": "Remove from cart",
    "cart.maxReached": "All available stock is in your cart",
    "cart.added": "✓ Added to cart",
    "filter.search": "Search for a card (FR or EN)…",
    "filter.searchOracle": "Also search the card text (effects)",
    "filter.searchOracleOn": "Search also covers card text — click to turn off",
    "filter.clearAll": "Clear all",
    "filter.name": "Filter (FR or EN)…",
    "filter.expansions": "Filter sets…",
    "filter.keywords": "Filter keywords (FR or EN)…",
    "filter.noExpansion": "No set found.",
    "filter.noType": "No type found.",
    "filter.noKeyword": "No keyword found.",
    "filter.creatureType": "Creature type",
    "filter.manaCost": "Mana cost",
    "filter.allFormats": "All formats",
    "filter.allLanguages": "All languages",
    "filter.legendary": "⭐ Legendary",
    "filter.legendaryOnly": "⭐ Legendary only",
    "filter.condition": "Condition: NM",
    "filter.conditionNote": "All current stock is Near Mint",
    "filter.min": "Min",
    "filter.max": "Max",
    "filter.french": "🇫🇷 French",
    "filter.english": "🇬🇧 English",
    "sort.priceAsc": "Price, low to high",
    "sort.priceDesc": "Price, high to low",
    "view.grid": "Grid view",
    "view.list": "Compact list view",
    "filter.manaValue": "Mana value {value}",
    "card.prev": "Previous card",
    "card.next": "Next card",
    "card.close": "Close",
    "card.previousShort": "‹ Previous",
    "card.front": "Show front face",
    "card.back": "Show back face",
    "card.rarity": "Rarity",
    "card.condition": "Condition",
    "card.keywords": "Keywords",
    "card.oracle": "Card text",
    "card.synergies": "Works well with",
    "card.scryfall": "View on Scryfall ↗",
    "card.allVersions": "See every version (sets, languages, finishes)",
    "card.badge.new": "🆕 New",
    "card.badge.restock": "↺ Back in stock",
    "card.secondHand": "Pre-owned",
    "card.secondHandNote": "Pre-owned card: it has had a previous owner, whatever its playing condition. It is covered by the 2-year legal guarantee of conformity; for second-hand goods, a defect appearing within 12 months of delivery is presumed to have existed at the time of sale (French Consumer Code, art. L217-7).",
    "synergies.intro": "EDHREC synergies for the cards in your cart, in stock here.",
    "deck.open": "Import a list",
    "deck.openLabel": "📋 Import a list",
    "deck.title": "Import a decklist",
    "deck.help": "Paste your list (MTGA, Moxfield, plain text…) — one card per line, e.g. “4 Sol Ring”.",
    "deck.resultPlaceholder": "Matches against our stock will appear here.",
    "deck.copyMissing": "Copy the missing ones",
    "deck.addCards": "Add {count} card to cart",
    "deck.addCards_plural": "Add {count} cards to cart",
    "card.type": "Type",
    "card.versions": "⧉ See {count} versions",
    "card.inCart": "🛒 {count} already in your cart",
    "cart.cards": "{count} card",
    "cart.cards_plural": "{count} cards",
    "deck.stockWarning": "⚠ Only {available} in stock out of {asked} requested",
    "filter.all": "All",
    "filter.conditionLabel": "Condition:",
    "filter.conditionFull": "Near Mint — all current stock",
    "filter.showResults": "Show {count} card",
    "filter.showResults_plural": "Show {count} cards",
    "filter.colors": "Colours",
    "filter.format": "Format",
    "filter.expansion": "Set",
    "filter.language": "Language",
    "filter.finish": "Finish",
    "filter.price": "Price",
    "filter.type": "Type",
    "filter.land": "Land:",
    "filter.creature": "Creature:",
    "lang.frCard": "French-language card",
    "lang.enCard": "English-language card"
  };
  const MESSAGES$1 = { fr: FR$1, en: EN$1 };
  function t$1(key, vars) {
    const raw = MESSAGES$1[getLocale()][key] ?? FR$1[key];
    return interpolate(raw, vars);
  }
  const LANG_STYLES = {
    fr: { label: "FR", classes: "bg-blue-700 text-white" },
    en: { label: "EN", classes: "bg-red-700 text-white" }
  };
  function FlagIcon({ language, className = "" }) {
    if (language === "fr") {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { viewBox: "0 0 3 2", className: `${className} rounded-[2px] ring-1 ring-white/70`, "aria-hidden": true, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "1", height: "2", fill: "#002395" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "1", width: "1", height: "2", fill: "#fff" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "2", width: "1", height: "2", fill: "#ED2939" })
      ] });
    }
    if (language === "en") {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { viewBox: "0 0 60 30", className: `${className} rounded-[2px] ring-1 ring-white/70`, "aria-hidden": true, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "60", height: "30", fill: "#012169" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M0,0 L60,30 M60,0 L0,30", stroke: "#fff", strokeWidth: "6" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M0,0 L60,30 M60,0 L0,30", stroke: "#C8102E", strokeWidth: "2.5" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M30,0 v30 M0,15 h60", stroke: "#fff", strokeWidth: "10" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M30,0 v30 M0,15 h60", stroke: "#C8102E", strokeWidth: "6" })
      ] });
    }
    return null;
  }
  function LangBadge({ language, size = "sm" }) {
    const style = LANG_STYLES[language] ?? { label: language.toUpperCase(), classes: "bg-neutral-700 text-white" };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "span",
      {
        translate: "no",
        className: `notranslate inline-flex items-center gap-1 rounded-md font-bold shadow-sm ${style.classes} ${size === "md" ? "px-2.5 py-1 text-sm" : "px-1.5 py-0.5 text-xs"}`,
        title: style.label === "FR" ? t$1("lang.frCard") : style.label === "EN" ? t$1("lang.enCard") : style.label,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FlagIcon, { language, className: size === "md" ? "h-3 w-[18px]" : "h-2.5 w-[15px]" }),
          style.label
        ]
      }
    );
  }
  const FR = {
    // ─── Amorçage ────────────────────────────────────────────────────────────
    "boot.loading": "Chargement du catalogue de reprise…",
    "boot.closed": "La reprise est momentanément fermée. Revenez bientôt.",
    "boot.unavailable": "Le service de reprise est momentanément indisponible.",
    "error.catalog": "Catalogue de reprise indisponible",
    "error.config": "Réglages de la reprise indisponibles",
    "error.quote": "Estimation indisponible",
    "error.submit": "Envoi impossible",
    // ─── En-tête et recherche ────────────────────────────────────────────────
    "app.title": "Je revends mes cartes",
    "app.tagline": "Reprise de vos cartes Magic — payées en avoir boutique, au barème affiché ci-dessous.",
    "app.howItWorks": "Comment ça marche ?",
    "app.myBuyback": "Ma reprise",
    "app.openCart": "Ouvrir mon panier de reprise",
    "app.searchPlaceholder": "Nom, numéro (123) ou extension+numéro (blb123)…",
    "app.tabSearch": "🔍 Recherche",
    "app.tabPaste": "📋 Coller une liste",
    "app.noResult": "Aucune carte ne correspond à cette recherche.",
    "app.resetSearch": "Réinitialiser la recherche",
    "app.loading": "Chargement…",
    "app.minOfferHint": "Masque les cartes dont l’offre n’atteint pas ce montant — elles restent reprises au poids, dans le colis.",
    "app.allRarities": "Toutes raretés",
    "app.myCardsAre": "Mes cartes sont",
    "app.minValue": "Valeur minimale : {amount}",
    "app.resultCount": "{count} carte",
    "app.resultCount_plural": "{count} cartes",
    // ─── Filtres (barre et feuille mobile) ───────────────────────────────────
    "filter.title": "Filtres",
    "filter.close": "Fermer les filtres",
    "filter.clearAll": "Tout effacer",
    "filter.expansion": "Extension",
    "filter.rarity": "Rareté",
    "filter.sort": "Tri",
    "filter.showResults": "Voir {count} carte",
    "filter.showResults_plural": "Voir {count} cartes",
    // ─── Tris ────────────────────────────────────────────────────────────────
    "sort.offerDesc": "Offre décroissante",
    "sort.offerAsc": "Offre croissante",
    "sort.name": "Nom",
    "sort.recent": "Sorties récentes",
    "sort.expansion": "Extension",
    // ─── Raretés ─────────────────────────────────────────────────────────────
    "rarity.common": "Commune",
    "rarity.uncommon": "Peu commune",
    "rarity.rare": "Rare",
    "rarity.mythic": "Mythique",
    // ─── Vignette et fiche d'offre ───────────────────────────────────────────
    "offer.add": "Ajouter à la reprise",
    "offer.addOne": "Ajouter un exemplaire",
    "offer.removeOne": "Enlever un exemplaire",
    "offer.removeAll": "Retirer du panier",
    "offer.detail": "Voir le détail de l’offre",
    "offer.capReached": "Plafond du panier atteint",
    "offer.wanted": "★ Recherchée",
    // ⚠️ **Un prix nu sur une vignette se lit comme un prix de VENTE.** La grille
    // a la grammaire visuelle d'une boutique — image, nom, prix en gras, bouton
    // « + » — et un client qui arrive là ne devine pas que ce montant est ce que
    // NOUS lui versons. D'où ce qualificatif, collé au montant partout où il
    // apparaît hors de la fiche détaillée.
    "offer.wePay": "nous vous payons",
    "offer.wePayHint": "Prix de reprise : ce que nous vous versons pour cette carte, pas un prix de vente.",
    "offer.bulkShort": "vrac",
    "grid.priceNotice": "Les montants affichés sont des <b>prix de reprise</b> : ce que nous vous versons pour vos cartes.",
    "offer.wantedHint": "Nous cherchons cette carte : son prix de reprise est majoré.",
    "offer.wantedHintLong": "★ Nous cherchons cette carte : son taux de reprise est majoré.",
    "offer.marketPrice": "Cote Cardmarket",
    "offer.unitOffer": "Offre à l’unité",
    "offer.notTakenAlone": "Non reprise à l’unité",
    "offer.byWeight": ", repris au poids.",
    "offer.notEligiblePrefix": "Sous {min}, cette carte n’est pas reprise à l’unité. Vous pouvez l’envoyer avec votre lot",
    "submit.noBasicLands": "aucun terrain de base",
    "submit.basicLandsList": "(Plaine, Île, Marais, Montagne, Forêt, y compris enneigés).",
    "list.batchIntro": "Les valeurs ci-dessous s’appliquent à toutes les lignes, sauf mention contraire sur la ligne — ex.",
    "offer.yourLanguage": "Langue de votre carte",
    "offer.cardCondition": "État de la carte",
    // ─── Variante ────────────────────────────────────────────────────────────
    "variant.language": "Langue de la carte",
    "variant.condition": "État de la carte — vérifié à la réception",
    "variant.foil": "✦ Foil",
    "variant.normal": "✦ Normale",
    "variant.toFoil": "Carte normale — cliquer pour foil",
    "variant.toNormal": "Carte foil — cliquer pour revenir en normale",
    "variant.noFoil": "Cette carte n’existe pas en foil",
    "variant.foilOnly": "Cette carte n’existe qu’en foil",
    "variant.french": "🇫🇷 Français",
    "variant.english": "🇬🇧 Anglais",
    // ─── Panier de reprise ───────────────────────────────────────────────────
    "cart.singles": "Cartes à l’unité",
    "cart.empty": "Aucune carte à l’unité. Recherchez vos cartes ci-contre, ou ajoutez un lot bulk.",
    "cart.clear": "Vider le panier de reprise",
    "cart.remove": "Retirer",
    "cart.detail": "Détail du calcul",
    "cart.shippingFee": "Frais d’envoi de vos cartes",
    "cart.missing": "Il vous manque",
    "cart.weighedOnArrival": "pesé à réception",
    "cart.bulkExcluded": "Hors vrac : il s’ajoutera à ce montant une fois pesé.",
    "cart.submit": "Valider ma reprise",
    "cart.foil": "· ✦ Foil",
    // ─── BÊTA et nature des montants ─────────────────────────────────────────
    // ⚠️ **Aucun montant affiché ici n'engage.** Le client compose son panier sur
    // des cotes qui bougent, et deux étapes peuvent encore corriger l'offre :
    // l'examen du panier, puis l'ouverture du colis. Le dire une seule fois, en
    // petit, ne suffit pas — la mention accompagne le montant partout où il
    // apparaît, sinon la première correction sera vécue comme un revirement.
    "beta.badge": "BÊTA",
    "beta.hint": "Service en cours de rodage : le parcours peut évoluer.",
    "beta.estimateShort": "Estimation",
    "beta.estimateCart": "Les montants affichés sont des estimations, calculées sur les cotes du jour.",
    "beta.estimateWhy": "Ils peuvent être revus deux fois : après examen de votre panier, puis après réception et vérification de vos cartes. Vous validez chaque nouvelle offre — rien ne part sans votre accord.",
    "beta.estimateTile": "Estimation, révisable après vérification",
    // ─── Revue du panier ─────────────────────────────────────────────────────
    "review.open": "Revoir mes cartes",
    "review.openHint": "Afficher toutes les cartes du panier en grand pour ajuster les quantités",
    "review.title": "Les cartes de ma reprise",
    "review.subtitle": "Ajustez les quantités, retirez ce que vous ne souhaitez plus envoyer.",
    "review.optional": "Cette étape est facultative : vous pouvez valider votre reprise sans passer par ici.",
    "review.empty": "Votre panier de reprise ne contient aucune carte à l’unité.",
    "review.back": "Retour au catalogue",
    "review.cards": "carte(s) à l’unité",
    "review.lineTotal": "Total de la ligne",
    "review.removeLine": "Retirer cette carte du panier",
    "review.belowThreshold": "Sous le seuil : à joindre au vrac",
    "review.capped": "Plafonnée",
    // ─── Vrac ────────────────────────────────────────────────────────────────
    "bulk.title": "Poids approximatif de vos cartes en vrac",
    "bulk.intro": "Joignez vos cartes de faible valeur au colis,",
    "bulk.noBasicLands": "sans terrains de base",
    "bulk.estimate": "(estimation)",
    "bulk.noCommitment": "Le poids que vous indiquez n’est qu’une estimation, il n’engage rien.",
    // ─── Collage de liste ────────────────────────────────────────────────────
    "list.oneCardPerLine": "Une carte par ligne :",
    "list.format": "[qté] Nom [(EXT)] [n°] [foil] [état] [langue]",
    "list.example": "1 Contresort (DOM) *F* LP",
    "list.batchIs": "Ce lot est :",
    "list.allEditions": "Toutes éditions",
    "list.reset": "réinitialiser",
    "list.emptyResult": "Collez votre liste ci-dessus : le résultat s’affichera ici avec l’offre de reprise ligne par ligne.",
    "list.copy": "Copier",
    "list.copied": "Lignes introuvables copiées dans le presse-papiers.",
    "list.detail": "Voir le détail",
    "list.editionOwned": "Édition que vous possédez",
    "list.toBulk": "→ bulk",
    "list.joinBulk": "à joindre en vrac",
    "list.belowThreshold": "Sous le seuil de reprise à l’unité : joignez-la au colis avec vos cartes en vrac, nous la pesons à réception.",
    // ─── Extensions ──────────────────────────────────────────────────────────
    "expansion.all": "Toutes extensions",
    "expansion.filter": "Filtrer les extensions…",
    "expansion.none": "Aucune extension",
    "expansion.clear": "Tout désélectionner ({count})",
    "expansion.count": "{count} extensions",
    // ─── Mode de règlement ───────────────────────────────────────────────────
    "payout.credit": "Avoir boutique",
    "payout.creditSub": "Crédit sur votre compte Nevermint",
    "payout.cash": "Virement bancaire",
    // ─── Formulaire de validation ────────────────────────────────────────────
    "submit.title": "Valider ma reprise",
    "submit.addressIntro": "Coordonnées reprises de votre compte — corrigez-les si vos cartes partent d’ailleurs.",
    "submit.name": "Nom et prénom",
    "submit.zip": "Code postal",
    "submit.extra": "Complément (facultatif)",
    "submit.phone": "Téléphone (facultatif)",
    "submit.iban": "IBAN (pour le virement)",
    "submit.ibanNote": "Stocké chiffré, utilisé uniquement pour vous régler.",
    "submit.shipping": "Frais de port",
    "submit.yourCredit": "Votre avoir de",
    "submit.errName": "Nom requis",
    "submit.errEmail": "Email invalide",
    "submit.errAddress": "Adresse requise",
    "submit.errCity": "Ville requise",
    "submit.errZip": "Code postal à 5 chiffres",
    "submit.errIban": "IBAN français requis pour le virement",
    "submit.errAccept": "Acceptation requise",
    "submit.errBulk": "Cochez la certification « aucun terrain de base » sur votre lot bulk.",
    "submit.bulkCertify": "Mon lot en vrac ne contient",
    // ─── Confirmation ────────────────────────────────────────────────────────
    "done.title": "Demande de reprise enregistrée",
    "done.reference": "Référence",
    "done.step1.title": "Nous validons votre demande",
    "done.step1.body": "Sous {hours} h ouvrées. Vous recevez alors par email votre étiquette d’envoi prépayée au format PDF.",
    "done.step2.title": "Vous expédiez vos cartes",
    "done.step3.title": "Nous réceptionnons et vérifions",
    "done.step3.body": "Chaque carte est contrôlée (état, extension, langue) et le bulk est pesé. Toute différence avec votre déclaration vous est soumise avant règlement.",
    "done.step4.title": "Vous êtes réglé",
    "done.step4.credit": "Votre avoir est déposé sur votre compte Nevermint sous {hours} h après validation : rien à recopier, il vous est proposé au paiement.",
    "done.step4.cash": "Le virement est émis sous {hours} h après validation.",
    "done.again": "Faire une nouvelle reprise",
    "done.inCredit": "en avoir boutique",
    "done.inCash": "en cash",
    // ─── Qui peut valider ────────────────────────────────────────────────────
    // ⚠️ Ces textes ne ferment plus la page : ils accompagnent un bouton éteint.
    // Ils disent donc ce qui manque et comment l'obtenir, jamais « vous n'avez
    // rien à faire ici ».
    "access.anonTitle": "Composez librement — connectez-vous pour valider",
    "access.anonBody": "Estimez vos cartes autant que vous voulez, sans compte. La validation d’une reprise demande un compte Nevermint et une commande terminée.",
    "access.noOrderTitle": "Une commande terminée ouvre la reprise",
    "access.noOrderBody": "Votre panier est estimé et conservé. Il pourra être validé dès qu’une commande passée sur la boutique aura été livrée.",
    "access.pendingTitle": "Votre commande est en route",
    "access.pendingBody": "Votre panier de reprise est prêt. Il pourra être validé dès que votre commande en cours sera livrée.",
    "access.cartAnon": "Connectez-vous pour valider cette reprise. L’estimation, elle, reste à vous.",
    "access.cartNoOrder": "La validation est réservée aux clients ayant une commande terminée sur la boutique. Votre panier est conservé en attendant.",
    "access.cartPending": "Votre commande n’est pas encore livrée. Dès qu’elle le sera, ce panier pourra être validé.",
    "access.login": "Me connecter",
    "access.createAccount": "Créer un compte",
    "access.shop": "Voir la boutique",
    // ─── Guide ───────────────────────────────────────────────────────────────
    "how.title": "Comment se passe une reprise ?",
    "how.subtitle": "De la composition de mon panier au paiement.",
    "how.close": "Fermer",
    "how.cta": "J’ai compris, je compose mon panier",
    "how.fork": "↓ deux issues possibles ↓",
    "how.s1.title": "Je compose mon panier et je le valide",
    "how.s1.bodyCredit": "Je cherche mes cartes ou je colle ma liste, je déclare pour chacune sa langue, sa finition et son état, puis je renseigne mes coordonnées et je valide ma demande.",
    "how.s1.bodyBoth": "Je cherche mes cartes ou je colle ma liste, je déclare pour chacune sa langue, sa finition et son état. Je choisis mon mode d’encaissement — cash ou avoir boutique — puis je renseigne mes coordonnées et je valide ma demande.",
    "how.s1.noteCredit": "La reprise est réglée en avoir boutique, à {credit} de la cote selon la valeur de la carte. Sous {threshold} de reprise, {fee} de frais de port sont déduits.",
    "how.s1.noteBoth": "L’avoir boutique rapporte {credit} de la cote contre {cash} en cash, selon la valeur de la carte. Sous {threshold} de reprise, {fee} de frais de port sont déduits.",
    "how.s2.title": "Je reçois mon bon d’envoi",
    "how.s2.body": "Nevermint analyse ma demande et la valide. Je reçois par email mon étiquette d’envoi prépayée au format PDF, accompagnée du bordereau récapitulatif de ma reprise.",
    "how.s2.note": "Sous {hours} h ouvrées. L’envoi est à la charge de Nevermint — je n’avance rien. L’étiquette reste valable {days} jours.",
    "how.s3.title": "Je prépare mes cartes et je les expédie",
    "how.s3.body": "J’imprime l’étiquette et le bordereau, je glisse le bordereau dans le colis, puis je le dépose dans un bureau de poste ou un point relais Pickup. Le suivi est attaché à mon étiquette.",
    "how.s3.note": "Je protège bien mes cartes : pochettes individuelles pour les pièces de valeur, le tout serré entre deux cartons rigides. Une carte abîmée pendant le transport est une carte déclassée à la réception.",
    "how.s4.title": "Nevermint reçoit mon colis et me le confirme",
    "how.s4.body": "Dès l’ouverture du colis, je reçois un email confirmant que mes cartes sont bien arrivées.",
    "how.s5.title": "Mes cartes sont vérifiées une à une",
    "how.s5.body": "Chaque carte est contrôlée : version, extension, langue et état réel. Le lot bulk est pesé. Deux issues possibles — soit tout correspond à ma déclaration et mon panier est validé tel quel, soit des modifications me sont proposées.",
    "how.s5.note": "C’est l’état constaté qui fait foi. Une carte annoncée NM et reçue en Light Played est repayée au tarif Light Played.",
    "how.s6.title": "Panier validé : je suis payé",
    "how.s6.body": "Si aucune modification n’est nécessaire, je reçois mon virement bancaire ou mon avoir sur mon compte Nevermint, sous {hours} h.",
    "how.s7.title": "Modifications proposées : j’accepte ou je refuse",
    "how.s7.body": "Si l’état constaté diffère, je reçois le détail ligne par ligne avec le nouveau montant. J’accepte et je suis payé sous {hours} h, ou je refuse — les cartes me sont alors renvoyées aux frais de Nevermint.",
    "how.s7.note": "L’offre reste valable {hours} h. Sans réponse de ma part, une relance m’est envoyée avant toute clôture.",
    "how.s8.title": "Si je refuse : mes cartes me sont renvoyées",
    "how.s8.body": "Nevermint me réexpédie l’intégralité de mon lot, dans l’état où il a été reçu. Rien n’est conservé sans mon accord.",
    // ─── Écran d'entrée : trois façons de vendre ─────────────────────────────
    "door.title": "Comment voulez-vous nous confier vos cartes ?",
    "door.subtitle": "Trois façons de faire, du plus précis au plus simple. Toutes se règlent en avoir boutique, et l’envoi est toujours à notre charge.",
    "door.badge": "Le plus simple",
    "door.back": "← Revenir au choix",
    "door.list.name": "À la carte",
    "door.list.promise": "Vous savez déjà ce que vous avez.",
    "door.list.b1": "Vous cotez vos cartes une par une",
    "door.list.b2": "Vous connaissez le montant avant d’envoyer",
    "door.list.b3": "Jusqu’à {rate} de la cote en avoir",
    "door.list.min": "À partir de {min} cartes par envoi",
    "door.list.cta": "Composer ma liste",
    "door.bulk.name": "En vrac",
    "door.bulk.promise": "Un lot payé au poids, sans détail.",
    "door.bulk.b1": "Aucune carte à identifier",
    "door.bulk.b2": "{price} le kilo, jusqu’à {max} kg",
    "door.bulk.b3": "C’est notre balance qui fait foi",
    "door.bulk.cta": "Envoyer un lot en vrac",
    "door.full.name": "Clé en main",
    "door.full.promise": "Vous n’avez rien à trier. On s’occupe de tout.",
    "door.full.b1": "Vous dites combien de cartes, à peu près",
    "door.full.b2": "Chaque carte au-dessus de {threshold} vous est détaillée",
    "door.full.b3bulk": "Les autres sont reprises en lot, au poids — rien n’est écarté",
    "door.full.b3": "Vous refusez ? Renvoi gratuit au relais de votre choix",
    "door.full.cta": "Confier mes cartes",
    // ─── Formulaire des dépôts sans chiffrage ────────────────────────────────
    "simple.full.title": "Confiez-nous vos cartes",
    "simple.full.intro": "Dites-nous seulement combien de cartes vous avez. Nous vous envoyons une étiquette prépayée, vous postez, et nous trions.",
    "simple.bulk.title": "Envoyez votre lot en vrac",
    "simple.bulk.intro": "Indiquez un ordre de grandeur — poids ou nombre de cartes. Seule notre pesée à réception fixera le montant.",
    "simple.cards.label": "Combien de cartes, à peu près ?",
    "simple.cards.help": "Une estimation suffit : elle sert à préparer votre envoi, pas à calculer un prix.",
    "simple.full.detail": "Nous trions tout. Chaque carte qui vaut plus de {threshold} apparaît sur une ligne à elle, avec son prix. **Les autres ne sont pas mises de côté** : elles sont reprises ensemble, au poids, à {bulk} le kilo. Vous recevez le détail des deux avant de décider.",
    "simple.cards.max": "Jusqu’à {max} cartes par envoi.",
    "simple.kg.label": "Poids approximatif (kg)",
    "simple.kg.help": "Si vous ne savez pas, laissez vide et donnez un nombre de cartes.",
    "simple.note.label": "Un mot sur votre lot (facultatif)",
    "simple.note.placeholder": "Ex. : surtout du commun récent, avec une dizaine de rares dedans. Deux cartes abîmées.",
    "simple.note.help": "Ce que vous nous en dites oriente notre tri. Rien de ce que vous écrivez ici ne vous engage.",
    "simple.steps.title": "Ce qui se passe ensuite",
    "simple.steps.1": "Nous vous envoyons une étiquette prépayée sous {hours} h.",
    "simple.steps.2": "Vous postez vos cartes — l’envoi ne vous coûte rien.",
    "simple.steps.3": "Nous trions et vous faisons une proposition détaillée sous {reception} h.",
    "simple.steps.4": "Vous acceptez, ou vous refusez et nous vous renvoyons tout, gratuitement.",
    "simple.submit.full": "Envoyer ma demande",
    "simple.submit.bulk": "Envoyer mon lot",
    "simple.sending": "Envoi…",
    "simple.needCards": "Indiquez le nombre de cartes que vous souhaitez proposer.",
    "simple.needSomething": "Indiquez un poids ou un nombre de cartes, même approximatif.",
    "simple.done.title": "C’est noté, votre demande est enregistrée",
    "simple.done.body": "Votre référence est {reference}. Vous recevrez l’étiquette prépayée par e-mail sous {hours} h, avec la marche à suivre.",
    "simple.done.track": "Suivre ma reprise",
    "simple.terms": "J’accepte les conditions de reprise : le montant m’est proposé après tri et je reste libre de le refuser ; en cas de refus, mes cartes me sont renvoyées gratuitement au point relais de mon choix.",
    "simple.noBasics": "Je certifie que mon lot ne contient aucun terrain de base.",
    "simple.payout": "Comment souhaitez-vous être réglé ?",
    // ─── Ma liste (recherche, photo, liste collée) ────────────────────────────
    "list.title": "Ma liste de reprise",
    "list.subtitle": "Ajoutez vos cartes une à une : par leur nom ou leur numéro, en collant une liste, ou en les photographiant.",
    "list.myCardsAre": "Mes cartes sont :",
    "list.tab.search": "🔍 Rechercher",
    "list.tab.photo": "📷 Photographier",
    "list.tab.paste": "📋 Coller une liste",
    "search.placeholder": "Nom de la carte, ou extension + numéro (ex. « blb 123 »)",
    "search.hint": "Le numéro et le code d’extension sont imprimés en bas à gauche de la carte.",
    "search.none": "Aucune carte reprise ne correspond.",
    "search.add": "Ajouter",
    "search.added": "Ajoutée : {name}",
    "search.bulk": "au vrac",
    "photo.cta": "Prendre une carte en photo",
    "photo.next": "Ajouter et photographier la suivante",
    "photo.tips": "Une carte par photo, à plat sur un fond clair, entière dans le cadre, sans reflet.",
    "photo.reading": "Reconnaissance de la carte…",
    "photo.error": "La photo n’a pas pu être lue.",
    "photo.confident": "Carte reconnue",
    "photo.pick": "Laquelle est-ce ?",
    "photo.pickHint": "Touchez la bonne impression : l’extension et le numéro sont en bas à gauche de la carte.",
    "photo.none": "Aucune de celles-ci",
    "photo.noneHint": "Cherchez-la par son nom ou son numéro dans l’onglet Rechercher.",
    "photo.noMatch": "Aucune carte reconnue sur cette photo. Recadrez-la, ou cherchez-la par son nom.",
    "photo.notBought": "pas reprise",
    "photo.remaining": "{count} photos possibles encore aujourd’hui",
    "photo.closed": "La reconnaissance par photo n’est pas ouverte pour l’instant.",
    "photo.retake": "Reprendre la photo",
    "photo.loginRequired": "La reconnaissance des cartes par photo est réservée aux clients connectés.",
    "photo.login": "Me connecter",
    "photo.basicLand": "terrain de base, non repris",
    "photo.floor": "hors catalogue",
    "photo.floorHint": "Cette carte n’est pas au catalogue de reprise : nous la prenons quand même, à prix fixe.",
    "list.count": "{count} carte(s) dans ma liste"
  };
  const EN = {
    "boot.loading": "Loading the buyback catalogue…",
    "boot.closed": "Buyback is closed for the moment. Please check back soon.",
    "boot.unavailable": "The buyback service is temporarily unavailable.",
    "error.catalog": "Buyback catalogue unavailable",
    "error.config": "Buyback settings unavailable",
    "error.quote": "Quote unavailable",
    "error.submit": "Submission failed",
    "app.title": "Sell us your cards",
    "app.tagline": "We buy your Magic cards — paid in store credit, at the rates shown below.",
    "app.howItWorks": "How does it work?",
    "app.myBuyback": "My buyback",
    "app.openCart": "Open my buyback basket",
    "app.searchPlaceholder": "Name, number (123) or set+number (blb123)…",
    "app.tabSearch": "🔍 Search",
    "app.tabPaste": "📋 Paste a list",
    "app.noResult": "No card matches this search.",
    "app.resetSearch": "Reset the search",
    "app.loading": "Loading…",
    "app.minOfferHint": "Hides cards whose offer falls below this amount — they are still bought by weight, in the same parcel.",
    "app.allRarities": "All rarities",
    "app.myCardsAre": "My cards are",
    "app.minValue": "Minimum value: {amount}",
    "app.resultCount": "{count} card",
    "app.resultCount_plural": "{count} cards",
    "filter.title": "Filters",
    "filter.close": "Close the filters",
    "filter.clearAll": "Clear all",
    "filter.expansion": "Set",
    "filter.rarity": "Rarity",
    "filter.sort": "Sort",
    "filter.showResults": "Show {count} card",
    "filter.showResults_plural": "Show {count} cards",
    "sort.offerDesc": "Offer, high to low",
    "sort.offerAsc": "Offer, low to high",
    "sort.name": "Name",
    "sort.recent": "Recent releases",
    "sort.expansion": "Set",
    "rarity.common": "Common",
    "rarity.uncommon": "Uncommon",
    "rarity.rare": "Rare",
    "rarity.mythic": "Mythic",
    "offer.add": "Add to buyback",
    "offer.addOne": "Add one",
    "offer.removeOne": "Remove one",
    "offer.removeAll": "Remove from basket",
    "offer.detail": "See the offer in detail",
    "offer.capReached": "Basket cap reached",
    "offer.wanted": "★ Wanted",
    "offer.wePay": "we pay you",
    "offer.wePayHint": "Buyback price: what we pay you for this card, not a sale price.",
    "offer.bulkShort": "bulk",
    "grid.priceNotice": "The amounts shown are <b>buyback prices</b>: what we pay you for your cards.",
    "offer.wantedHint": "We are looking for this card: its buyback price is increased.",
    "offer.wantedHintLong": "★ We are looking for this card: its buyback rate is increased.",
    "offer.marketPrice": "Cardmarket price",
    "offer.unitOffer": "Offer per card",
    "offer.notTakenAlone": "Not bought individually",
    "offer.byWeight": ", bought by weight.",
    "offer.notEligiblePrefix": "Below {min}, this card is not bought individually. You can send it with your",
    "submit.noBasicLands": "no basic lands",
    "submit.basicLandsList": "(Plains, Island, Swamp, Mountain, Forest, including snow-covered).",
    "list.batchIntro": "The values below apply to every line, unless the line says otherwise — e.g.",
    "offer.yourLanguage": "Your card’s language",
    "offer.cardCondition": "Card condition",
    "variant.language": "Card language",
    "variant.condition": "Card condition — checked on arrival",
    "variant.foil": "✦ Foil",
    "variant.normal": "✦ Non-foil",
    "variant.toFoil": "Non-foil card — click for foil",
    "variant.toNormal": "Foil card — click to go back to non-foil",
    "variant.noFoil": "This card has no foil printing",
    "variant.foilOnly": "This card only exists in foil",
    "variant.french": "🇫🇷 French",
    "variant.english": "🇬🇧 English",
    "cart.singles": "Individual cards",
    "cart.empty": "No individual cards yet. Search for your cards opposite, or add a bulk lot.",
    "cart.clear": "Empty the buyback basket",
    "cart.remove": "Remove",
    "cart.detail": "Breakdown",
    "cart.shippingFee": "Cost of sending your cards",
    "cart.missing": "You still need",
    "cart.weighedOnArrival": "weighed on arrival",
    "cart.bulkExcluded": "Bulk excluded: it will be added to this amount once weighed.",
    "cart.submit": "Confirm my buyback",
    "cart.foil": "· ✦ Foil",
    // ─── Beta and what the amounts mean ──────────────────────────────────────
    "beta.badge": "BETA",
    "beta.hint": "This service is still being fine-tuned — the flow may change.",
    "beta.estimateShort": "Estimate",
    "beta.estimateCart": "The amounts shown are estimates, based on today's market prices.",
    "beta.estimateWhy": "They may be revised twice: after we review your cart, and again after we receive and check your cards. You approve every new offer — nothing proceeds without your agreement.",
    "beta.estimateTile": "Estimate, may be revised after checking",
    // ─── Cart review ─────────────────────────────────────────────────────────
    "review.open": "Review my cards",
    "review.openHint": "Show every card in the cart at full size to adjust quantities",
    "review.title": "The cards in my buyback",
    "review.subtitle": "Adjust quantities, remove anything you would rather keep.",
    "review.optional": "This step is optional — you can submit your buyback without it.",
    "review.empty": "Your buyback cart has no single cards in it.",
    "review.back": "Back to the catalogue",
    "review.cards": "single card(s)",
    "review.lineTotal": "Line total",
    "review.removeLine": "Remove this card from the cart",
    "review.belowThreshold": "Below the threshold — send it with your bulk",
    "review.capped": "Capped",
    "bulk.title": "Approximate weight of your bulk cards",
    "bulk.intro": "Add your low-value cards to the parcel,",
    "bulk.noBasicLands": "no basic lands",
    "bulk.estimate": "(estimate)",
    "bulk.noCommitment": "The weight you enter is only an estimate — it commits you to nothing.",
    "list.oneCardPerLine": "One card per line:",
    "list.format": "[qty] Name [(SET)] [no.] [foil] [condition] [language]",
    "list.example": "1 Counterspell (DOM) *F* LP",
    "list.batchIs": "This batch is:",
    "list.allEditions": "All editions",
    "list.reset": "reset",
    "list.emptyResult": "Paste your list above: the result will appear here, with the buyback offer line by line.",
    "list.copy": "Copy",
    "list.copied": "Unmatched lines copied to the clipboard.",
    "list.detail": "See details",
    "list.editionOwned": "The edition you own",
    "list.toBulk": "→ bulk",
    "list.joinBulk": "add to the bulk lot",
    "list.belowThreshold": "Below the individual buyback threshold: add it to the parcel with your bulk cards and we will weigh it on arrival.",
    "expansion.all": "All sets",
    "expansion.filter": "Filter sets…",
    "expansion.none": "No set",
    "expansion.clear": "Clear the selection ({count})",
    "expansion.count": "{count} sets",
    "payout.credit": "Store credit",
    "payout.creditSub": "Credit on your Nevermint account",
    "payout.cash": "Bank transfer",
    "submit.title": "Confirm my buyback",
    "submit.addressIntro": "Details taken from your account — correct them if your cards are sent from elsewhere.",
    "submit.name": "First and last name",
    "submit.zip": "Postcode",
    "submit.extra": "Address line 2 (optional)",
    "submit.phone": "Phone (optional)",
    "submit.iban": "IBAN (for the transfer)",
    "submit.ibanNote": "Stored encrypted, used only to pay you.",
    "submit.shipping": "Postage",
    "submit.yourCredit": "Your credit of",
    "submit.errName": "Name required",
    "submit.errEmail": "Invalid email",
    "submit.errAddress": "Address required",
    "submit.errCity": "City required",
    "submit.errZip": "5-digit postcode",
    "submit.errIban": "A French IBAN is required for the transfer",
    "submit.errAccept": "You must accept the terms",
    "submit.errBulk": "Tick the “no basic lands” certification on your bulk lot.",
    "submit.bulkCertify": "My bulk lot contains",
    "done.title": "Buyback request registered",
    "done.reference": "Reference",
    "done.step1.title": "We review your request",
    "done.step1.body": "Within {hours} working hours. You then receive your prepaid shipping label by email, as a PDF.",
    "done.step2.title": "You send your cards",
    "done.step3.title": "We receive and check them",
    "done.step3.body": "Every card is checked (condition, set, language) and the bulk is weighed. Any difference from your declaration is put to you before payment.",
    "done.step4.title": "You get paid",
    "done.step4.credit": "Your credit is added to your Nevermint account within {hours} h of approval — nothing to copy, it is offered at checkout.",
    "done.step4.cash": "The transfer is issued within {hours} h of approval.",
    "done.again": "Start another buyback",
    "done.inCredit": "in store credit",
    "done.inCash": "in cash",
    "access.anonTitle": "Browse freely — log in to confirm",
    "access.anonBody": "Price up as many cards as you like, no account needed. Confirming a buyback requires a Nevermint account and a completed order.",
    "access.noOrderTitle": "A completed order unlocks buyback",
    "access.noOrderBody": "Your basket is priced and saved. You will be able to confirm it once an order placed on the shop has been delivered.",
    "access.pendingTitle": "Your order is on its way",
    "access.pendingBody": "Your buyback basket is ready. You will be able to confirm it as soon as your current order is delivered.",
    "access.cartAnon": "Log in to confirm this buyback. The estimate stays yours either way.",
    "access.cartNoOrder": "Confirming is reserved for customers with a completed order on the shop. Your basket is saved in the meantime.",
    "access.cartPending": "Your order has not been delivered yet. As soon as it is, this basket can be confirmed.",
    "access.login": "Log in",
    "access.createAccount": "Create an account",
    "access.shop": "Visit the shop",
    "how.title": "How does a buyback work?",
    "how.subtitle": "From building my basket to getting paid.",
    "how.close": "Close",
    "how.cta": "Got it — let me build my basket",
    "how.fork": "↓ two possible outcomes ↓",
    "how.s1.title": "I build my basket and confirm it",
    "how.s1.bodyCredit": "I search for my cards or paste my list, I state the language, finish and condition of each one, then I fill in my details and confirm my request.",
    "how.s1.bodyBoth": "I search for my cards or paste my list, I state the language, finish and condition of each one. I choose how I want to be paid — cash or store credit — then I fill in my details and confirm my request.",
    "how.s1.noteCredit": "Buyback is paid in store credit, at {credit} of the market price depending on the value of the card. Below {threshold}, {fee} of postage is deducted.",
    "how.s1.noteBoth": "Store credit pays {credit} of the market price against {cash} in cash, depending on the value of the card. Below {threshold}, {fee} of postage is deducted.",
    "how.s2.title": "I receive my shipping voucher",
    "how.s2.body": "Nevermint reviews my request and approves it. I receive my prepaid shipping label by email as a PDF, together with the summary slip for my buyback.",
    "how.s2.note": "Within {hours} working hours. Nevermint pays for the shipping — I am never out of pocket. The label stays valid for {days} days.",
    "how.s3.title": "I pack my cards and send them",
    "how.s3.body": "I print the label and the slip, I put the slip inside the parcel, then I drop it off at a post office or a Pickup point. Tracking is attached to my label.",
    "how.s3.note": "I protect my cards properly: individual sleeves for the valuable ones, everything held tight between two rigid pieces of cardboard. A card damaged in transit is a card downgraded on arrival.",
    "how.s4.title": "Nevermint receives my parcel and confirms it",
    "how.s4.body": "As soon as the parcel is opened, I receive an email confirming that my cards have arrived.",
    "how.s5.title": "My cards are checked one by one",
    "how.s5.body": "Every card is checked: printing, set, language and actual condition. The bulk lot is weighed. Two outcomes are possible — either everything matches my declaration and my basket is approved as is, or changes are proposed to me.",
    "how.s5.note": "It is the observed condition that counts. A card declared NM and received in Light Played is paid at the Light Played rate.",
    "how.s6.title": "Basket approved: I get paid",
    "how.s6.body": "If no change is needed, I receive my bank transfer or my credit on my Nevermint account within {hours} h.",
    "how.s7.title": "Changes proposed: I accept or I decline",
    "how.s7.body": "If the observed condition differs, I receive the details line by line with the new amount. I accept and I am paid within {hours} h, or I decline — the cards are then sent back to me at Nevermint’s expense.",
    "how.s7.note": "The offer stays valid for {hours} h. If I do not reply, a reminder is sent before anything is closed.",
    "how.s8.title": "If I decline: my cards are sent back",
    "how.s8.body": "Nevermint sends my whole lot back, in the condition it was received. Nothing is kept without my agreement.",
    // ─── Entry screen ────────────────────────────────────────────────────────
    "door.title": "How would you like to send us your cards?",
    "door.subtitle": "Three ways to do it, from the most precise to the simplest. All are paid in store credit, and shipping is always on us.",
    "door.badge": "Simplest",
    "door.back": "← Back to the options",
    "door.list.name": "Card by card",
    "door.list.promise": "You already know what you have.",
    "door.list.b1": "You price your cards one by one",
    "door.list.b2": "You know the amount before you ship",
    "door.list.b3": "Up to {rate} of market value in store credit",
    "door.list.min": "From {min} cards per shipment",
    "door.list.cta": "Build my list",
    "door.bulk.name": "Bulk",
    "door.bulk.promise": "A lot paid by weight, no itemising.",
    "door.bulk.b1": "No card to identify",
    "door.bulk.b2": "{price} per kilo, up to {max} kg",
    "door.bulk.b3": "Our scales settle it",
    "door.bulk.cta": "Send a bulk lot",
    "door.full.name": "Full service",
    "door.full.promise": "Nothing to sort. We handle everything.",
    "door.full.b1": "Just tell us roughly how many cards",
    "door.full.b2": "Every card above {threshold} is itemised for you",
    "door.full.b3bulk": "The rest is bought as one lot, by weight — nothing is set aside",
    "door.full.b3": "Not happy? Free return to the pickup point you choose",
    "door.full.cta": "Hand over my cards",
    // ─── Unpriced submission form ────────────────────────────────────────────
    "simple.full.title": "Hand us your cards",
    "simple.full.intro": "Just tell us how many cards you have. We send you a prepaid label, you post them, and we do the sorting.",
    "simple.bulk.title": "Send your bulk lot",
    "simple.bulk.intro": "Give us a rough figure — weight or card count. Only our weigh-in on arrival sets the amount.",
    "simple.cards.label": "Roughly how many cards?",
    "simple.cards.help": "An estimate is enough: it helps us prepare your shipment, it does not set a price.",
    "simple.full.detail": "We sort everything. Every card worth more than {threshold} gets its own line, with its price. **The rest is not set aside**: it is bought together, by weight, at {bulk} per kilo. You get both figures before you decide.",
    "simple.cards.max": "Up to {max} cards per shipment.",
    "simple.kg.label": "Approximate weight (kg)",
    "simple.kg.help": "If you are unsure, leave it blank and give a card count instead.",
    "simple.note.label": "A word about your lot (optional)",
    "simple.note.placeholder": "E.g. mostly recent commons, with a dozen rares in there. Two damaged cards.",
    "simple.note.help": "What you tell us guides our sorting. Nothing you write here commits you.",
    "simple.steps.title": "What happens next",
    "simple.steps.1": "We send you a prepaid label within {hours} h.",
    "simple.steps.2": "You post your cards — shipping costs you nothing.",
    "simple.steps.3": "We sort them and send you an itemised offer within {reception} h.",
    "simple.steps.4": "You accept, or you decline and we send everything back, free of charge.",
    "simple.submit.full": "Send my request",
    "simple.submit.bulk": "Send my lot",
    "simple.sending": "Sending…",
    "simple.needCards": "Tell us how many cards you would like to offer.",
    "simple.needSomething": "Give a weight or a card count, even a rough one.",
    "simple.done.title": "All set, your request is registered",
    "simple.done.body": "Your reference is {reference}. You will receive the prepaid label by e-mail within {hours} h, with the instructions.",
    "simple.done.track": "Track my buyback",
    "simple.terms": "I accept the buyback terms: the amount is offered to me after sorting and I remain free to decline; if I decline, my cards are returned free of charge to the pickup point of my choice.",
    "simple.noBasics": "I certify that my lot contains no basic lands.",
    "simple.payout": "How would you like to be paid?",
    "list.title": "My buyback list",
    "list.subtitle": "Add your cards one by one: by name or number, by pasting a list, or by taking photos.",
    "list.myCardsAre": "My cards are:",
    "list.tab.search": "🔍 Search",
    "list.tab.photo": "📷 Take photos",
    "list.tab.paste": "📋 Paste a list",
    "search.placeholder": "Card name, or set + number (e.g. “blb 123”)",
    "search.hint": "The set code and number are printed at the bottom left of the card.",
    "search.none": "No card we buy matches.",
    "search.add": "Add",
    "search.added": "Added: {name}",
    "search.bulk": "bulk",
    "photo.cta": "Take a photo of a card",
    "photo.next": "Add and photograph the next one",
    "photo.tips": "One card per photo, flat on a light background, fully in frame, no glare.",
    "photo.reading": "Recognising the card…",
    "photo.error": "The photo could not be read.",
    "photo.confident": "Card recognised",
    "photo.pick": "Which one is it?",
    "photo.pickHint": "Tap the right printing: the set and number are at the bottom left of the card.",
    "photo.none": "None of these",
    "photo.noneHint": "Look it up by name or number in the Search tab.",
    "photo.noMatch": "No card recognised on this photo. Reframe it, or search it by name.",
    "photo.notBought": "not bought",
    "photo.remaining": "{count} photos left today",
    "photo.closed": "Photo recognition is not open yet.",
    "photo.retake": "Retake the photo",
    "photo.loginRequired": "Photo recognition is available to signed-in customers only.",
    "photo.login": "Sign in",
    "photo.basicLand": "basic land, not bought",
    "photo.floor": "off-catalogue",
    "photo.floorHint": "This card is not in our buyback catalogue: we still take it, at a fixed price.",
    "list.count": "{count} card(s) in my list"
  };
  const MESSAGES = { fr: FR, en: EN };
  function t(key, vars) {
    const raw = MESSAGES[getLocale()][key] ?? FR[key];
    return interpolate(raw, vars);
  }
  const MAX_SUGGESTIONS = 8;
  function CardSearchBox({ catalog, config, mode, defaults }) {
    const { add } = useBuybackCart();
    const [query, setQuery] = reactExports.useState("");
    const [flash, setFlash] = reactExports.useState(null);
    const inputRef = reactExports.useRef(null);
    const results = reactExports.useMemo(() => {
      if (query.trim().length < 2) return [];
      const q2 = normalize(query);
      const rank = (c) => {
        const names = [normalize(c.name), normalize(c.nameFr ?? "")];
        if (names.includes(q2)) return 0;
        if (names.some((n2) => n2.startsWith(q2))) return 1;
        return 2;
      };
      const found = sortCatalog(
        filterCatalog(catalog, { ...EMPTY_CATALOG_FILTERS, search: query }, config.minCardPriceEur),
        "release"
      );
      return found.map((c, i) => ({ c, r: rank(c), i })).sort((a, b) => a.r - b.r || a.i - b.i).slice(0, MAX_SUGGESTIONS).map((x2) => x2.c);
    }, [catalog, query, config.minCardPriceEur]);
    const pick = (card) => {
      var _a;
      const v2 = clampVariant(card, defaults);
      add({ cardId: card.id, ...v2 }, 1, { origin: "SEARCH" });
      setFlash(t("search.added", { name: displayName(card, v2.language) }));
      setQuery("");
      (_a = inputRef.current) == null ? void 0 : _a.focus();
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          ref: inputRef,
          type: "search",
          value: query,
          autoFocus: true,
          onChange: (e) => {
            setQuery(e.target.value);
            setFlash(null);
          },
          onKeyDown: (e) => {
            if (e.key === "Enter" && results[0]) {
              e.preventDefault();
              pick(results[0]);
            }
          },
          placeholder: t("search.placeholder"),
          className: "w-full rounded-xl border border-neutral-300 bg-white px-4 py-3 text-base shadow-sm outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-1.5 text-xs text-neutral-500", children: flash ? /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "font-medium text-green-700", children: [
        "✓ ",
        flash
      ] }) : t("search.hint") }),
      query.trim().length >= 2 && /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { className: "mt-2 divide-y divide-neutral-100 overflow-hidden rounded-xl border border-neutral-200 bg-white", children: [
        results.length === 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "px-4 py-3 text-sm text-neutral-500", children: t("search.none") }),
        results.map((card) => {
          const v2 = clampVariant(card, defaults);
          const q2 = quoteUnit(card, v2.language, v2.foil, v2.condition, mode, config);
          return /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "button",
            {
              type: "button",
              onClick: () => pick(card),
              className: "flex w-full items-center gap-3 px-3 py-2 text-left transition hover:bg-indigo-50",
              children: [
                card.imageUrl ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: card.imageUrl.replace("/normal/", "/small/"), alt: "", loading: "lazy", className: "h-14 w-10 shrink-0 rounded object-cover" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "h-14 w-10 shrink-0 rounded bg-neutral-100" }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "min-w-0 flex-1", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "block truncate text-sm font-medium text-neutral-900", children: displayName(card, v2.language) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "flex items-center gap-1.5 text-xs text-neutral-500", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "whitespace-nowrap font-mono", children: [
                      card.expansionCode,
                      " ",
                      card.collectorNumber
                    ] }),
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "truncate", children: [
                      "· ",
                      card.expansion
                    ] }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(LangBadge, { language: v2.language })
                  ] })
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "shrink-0 text-right", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "block text-sm font-semibold text-neutral-900", children: q2.eligible ? formatEur(q2.unit) : t("search.bulk") }),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-xs font-medium text-indigo-700", children: [
                    "+ ",
                    t("search.add")
                  ] })
                ] })
              ]
            }
          ) }, card.id);
        })
      ] })
    ] });
  }
  function apiHeaders(extra) {
    const locale = runtime().locale;
    return { ...locale ? { "Accept-Language": locale } : {}, ...extra ?? {} };
  }
  function runtime() {
    const injected2 = typeof window === "undefined" ? void 0 : window.NEVERMINT_BUYBACK;
    return {
      apiBase: (injected2 == null ? void 0 : injected2.apiBase) ?? "/apps/nevermint",
      indexBase: (injected2 == null ? void 0 : injected2.indexBase) ?? "http://localhost:3150/public/buyback/catalog",
      locale: injected2 == null ? void 0 : injected2.locale,
      rootUrl: injected2 == null ? void 0 : injected2.rootUrl,
      loggedIn: injected2 == null ? void 0 : injected2.loggedIn,
      loginUrl: (injected2 == null ? void 0 : injected2.loginUrl) ?? "/account/login",
      registerUrl: (injected2 == null ? void 0 : injected2.registerUrl) ?? "/account/register"
    };
  }
  function accountUrls() {
    const r2 = runtime();
    return { login: r2.loginUrl ?? "/account/login", register: r2.registerUrl ?? "/account/register" };
  }
  const RARITY_FROM_CODE = {
    c: "Common",
    u: "Uncommon",
    r: "Rare",
    m: "Mythic",
    s: "Rare"
  };
  async function fetchCatalog() {
    const { indexBase } = runtime();
    const manifestRes = await fetch(`${indexBase}/manifest.json`, { cache: "no-store" });
    if (!manifestRes.ok) throw new Error(t("error.catalog"));
    const manifest = await manifestRes.json();
    const expansionNames = new Map(manifest.expansions.map((e) => [e.code, e.name]));
    const expansionDates = new Map(manifest.expansions.map((e) => [e.code, e.releasedAt]));
    const indexRes = await fetch(`${indexBase}/${manifest.file}`);
    if (!indexRes.ok) throw new Error(t("error.catalog"));
    const raw = await indexRes.json();
    const list = Array.isArray(raw) ? raw : raw.cards;
    const cards = list.map((c) => ({
      id: c.i,
      name: c.n,
      nameFr: c.f ?? null,
      expansion: expansionNames.get(c.e) ?? c.e,
      expansionCode: c.e,
      collectorNumber: c.c,
      rarity: RARITY_FROM_CODE[c.r] ?? "Common",
      colors: null,
      typeLine: null,
      // L'index ne transporte pas d'URL d'image : elle se recompose depuis
      // l'identifiant Scryfall, ce qui économise ~60 octets par carte.
      imageUrl: c.s ? `https://cards.scryfall.io/normal/front/${c.s[0]}/${c.s[1]}/${c.s}.jpg` : null,
      scryfallId: c.s ?? null,
      isBasicLand: c.b === 1,
      cmEur: c.p ?? 0,
      cmEurFoil: c.pf ?? 0,
      releasedAt: expansionDates.get(c.e) ?? null,
      finishOnly: c.x ?? null,
      wantedBonus: c.w ?? 0,
      stockDeduction: c.d,
      languages: ["fr", "en"]
    }));
    return { cards, builtAt: manifest.builtAt };
  }
  async function fetchConfig() {
    const res = await fetch(`${runtime().apiBase}/config`, { cache: "no-store", headers: apiHeaders() });
    if (!res.ok) throw new Error(t("error.config"));
    const c = await res.json();
    return {
      enabled: c.enabled,
      minCardPriceEur: c.minCardPriceEur,
      cashRate: c.cashRate,
      creditRate: c.creditRate,
      // Un serveur antérieur aux paliers n'envoie rien : liste vide, donc taux
      // unique — exactement le comportement d'avant.
      priceTiers: c.priceTiers ?? [],
      maxPerCardEur: c.maxPerCardEur,
      maxCartTotalEur: c.maxCartTotalEur,
      shippingFeeEur: c.shippingFeeEur,
      shippingFreeThresholdEur: c.shippingFreeThresholdEur,
      bulkEnabled: c.bulkEnabled,
      bulkPricePerKgEur: c.bulkPricePerKgEur,
      bulkMaxKg: c.bulkMaxKg,
      conditionMultipliers: c.conditionMultipliers,
      requirePriorPurchase: c.requirePriorPurchase,
      cashEnabled: c.cashEnabled,
      minCardsPerCart: c.minCardsPerCart,
      maxCardsPerCart: c.maxCardsPerCart,
      enabledConditions: c.enabledConditions,
      fullServiceEnabled: c.fullServiceEnabled ?? false,
      fullServiceDetailThresholdEur: c.fullServiceDetailThresholdEur ?? 0.2,
      fullServiceMaxCards: c.fullServiceMaxCards ?? 2e3,
      photoDailyLimit: c.photoDailyLimit ?? 0,
      floorPriceEur: c.floorPriceEur ?? 0
    };
  }
  async function fetchEligibility() {
    const res = await fetch(`${runtime().apiBase}/eligibility`, { cache: "no-store", headers: apiHeaders() });
    if (!res.ok) return "anonymous";
    const e = await res.json();
    if (!e.loggedIn) return "anonymous";
    if (e.eligible) return "eligible";
    return e.reason === "ORDER_IN_PROGRESS" ? "order-pending" : "no-purchase";
  }
  async function fetchPrefill() {
    try {
      const res = await fetch(`${runtime().apiBase}/me`, { cache: "no-store", headers: apiHeaders() });
      if (!res.ok) return null;
      return await res.json();
    } catch {
      return null;
    }
  }
  function payoutForServer(mode) {
    return mode === "cash" ? "CASH" : "STORE_CREDIT";
  }
  function toServerCart(cart) {
    return {
      lines: cart.lines,
      payoutMode: payoutForServer(cart.payoutMode),
      bulkKg: cart.bulkKg || void 0
    };
  }
  async function recognizePhoto(imageDataUrl) {
    const res = await fetch(`${runtime().apiBase}/photos`, {
      method: "POST",
      headers: apiHeaders({ "Content-Type": "application/json" }),
      body: JSON.stringify({ image: imageDataUrl })
    });
    if (!res.ok) {
      const body = await res.json().catch(() => null);
      const msg = Array.isArray(body == null ? void 0 : body.message) ? body.message[0] : body == null ? void 0 : body.message;
      throw new Error(msg || t("photo.error"));
    }
    return res.json();
  }
  async function choosePhoto(photoId, cardId, rank) {
    await fetch(`${runtime().apiBase}/photos/${photoId}/choice`, {
      method: "POST",
      headers: apiHeaders({ "Content-Type": "application/json" }),
      body: JSON.stringify({ ...cardId ? { cardId } : {}, ...rank !== null ? { rank } : {} })
    }).catch(() => void 0);
  }
  async function saveDraft(cart) {
    await fetch(`${runtime().apiBase}/draft`, {
      method: "PUT",
      headers: apiHeaders({ "Content-Type": "application/json" }),
      body: JSON.stringify(toServerCart(cart))
    });
  }
  async function fetchDraft() {
    try {
      const res = await fetch(`${runtime().apiBase}/draft`, { cache: "no-store", headers: apiHeaders() });
      if (!res.ok) return null;
      return await res.json();
    } catch {
      return null;
    }
  }
  async function submitBuyback(payload) {
    const { lines, payoutMode, bulkKg, bulkNoBasics, ...contact } = payload;
    const res = await fetch(`${runtime().apiBase}/submit`, {
      method: "POST",
      headers: apiHeaders({ "Content-Type": "application/json" }),
      body: JSON.stringify({
        ...toServerCart({ lines, payoutMode, bulkKg }),
        // Envoyé seulement s'il y a du vrac : le serveur n'en a que faire sinon.
        ...bulkKg > 0 ? { bulkNoBasics: bulkNoBasics === true } : {},
        ...contact
      })
    });
    if (!res.ok) {
      const detail = await res.json().catch(() => null);
      throw new Error((detail == null ? void 0 : detail.message) ?? t("error.submit"));
    }
    return res.json();
  }
  async function submitSimpleBuyback(payload) {
    const res = await fetch(`${runtime().apiBase}/submit-simple`, {
      method: "POST",
      headers: apiHeaders({ "Content-Type": "application/json" }),
      body: JSON.stringify({
        ...payload,
        payoutMode: payoutForServer(payload.payoutMode)
      })
    });
    if (!res.ok) {
      const detail = await res.json().catch(() => null);
      throw new Error((detail == null ? void 0 : detail.message) ?? t("error.submit"));
    }
    return res.json();
  }
  const MAX_SIDE = 1280;
  async function shrinkPhoto(file) {
    const url = URL.createObjectURL(file);
    try {
      const img = await new Promise((resolve, reject) => {
        const el2 = new Image();
        el2.onload = () => resolve(el2);
        el2.onerror = () => reject(new Error(t("photo.error")));
        el2.src = url;
      });
      const scale = Math.min(1, MAX_SIDE / Math.max(img.naturalWidth, img.naturalHeight));
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.naturalWidth * scale);
      canvas.height = Math.round(img.naturalHeight * scale);
      const ctx = canvas.getContext("2d");
      if (!ctx) throw new Error(t("photo.error"));
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      return canvas.toDataURL("image/jpeg", 0.85);
    } finally {
      URL.revokeObjectURL(url);
    }
  }
  function PhotoCapture({ cardsById, config, mode, defaults, dailyLimit, onSearchInstead, loggedIn }) {
    var _a, _b;
    const { add, registerCard } = useBuybackCart();
    const floor = config.floorPriceEur ?? 0;
    const inputRef = reactExports.useRef(null);
    const [current, setCurrent] = reactExports.useState(null);
    const [busy, setBusy] = reactExports.useState(false);
    const [added, setAdded] = reactExports.useState(null);
    const open = () => {
      var _a2;
      return (_a2 = inputRef.current) == null ? void 0 : _a2.click();
    };
    const onFile = async (file) => {
      if (!file) return;
      setAdded(null);
      setBusy(true);
      let preview = "";
      try {
        preview = await shrinkPhoto(file);
        setCurrent({ preview, result: null, error: null });
        const result2 = await recognizePhoto(preview);
        setCurrent({ preview, result: result2, error: null });
      } catch (e) {
        setCurrent({ preview, result: null, error: e instanceof Error ? e.message : t("photo.error") });
      } finally {
        setBusy(false);
        if (inputRef.current) inputRef.current.value = "";
      }
    };
    const options = reactExports.useMemo(() => {
      var _a2;
      const seen = /* @__PURE__ */ new Set();
      return (((_a2 = current == null ? void 0 : current.result) == null ? void 0 : _a2.proposals) ?? []).map((p2, rank) => ({
        p: p2,
        rank,
        card: p2.cardId ? cardsById.get(p2.cardId) ?? (!p2.basicLand && floor > 0 ? floorCard({
          cardId: p2.cardId,
          name: p2.name,
          nameFr: p2.nameFr,
          expansionCode: p2.expansionCode,
          collectorNumber: p2.collectorNumber,
          scryfallId: p2.scryfallId
        }) : null) : null
      })).filter((o) => {
        if (!o.card) return o.rank === 0;
        if (seen.has(o.card.id)) return false;
        seen.add(o.card.id);
        return true;
      }).slice(0, 5);
    }, [current, cardsById, floor]);
    const choose = (p2, rank, card, thenNext) => {
      const photoId = current.result.photoId;
      const lang = p2.language;
      const v2 = clampVariant(card, { ...defaults, language: lang });
      if (card.floorOnly) registerCard(card);
      add({ cardId: card.id, ...v2 }, 1, { origin: "PHOTO", photoId });
      void choosePhoto(photoId, card.id, rank);
      setAdded(displayName(card, v2.language));
      setCurrent(null);
      if (thenNext) open();
    };
    const none = () => {
      if (current == null ? void 0 : current.result) void choosePhoto(current.result.photoId, null, -1);
      setCurrent(null);
      onSearchInstead();
    };
    if (dailyLimit <= 0) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "rounded-xl bg-neutral-100 px-4 py-6 text-center text-sm text-neutral-600", children: t("photo.closed") });
    }
    if (!loggedIn) {
      const urls = accountUrls();
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rounded-xl bg-neutral-100 px-4 py-6 text-center text-sm text-neutral-700", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: t("photo.loginRequired") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: urls.login, className: "mt-3 inline-block rounded-lg bg-indigo-600 px-4 py-2 font-semibold text-white hover:bg-indigo-700", children: t("photo.login") })
      ] });
    }
    const result = (current == null ? void 0 : current.result) ?? null;
    const confident = !!(result == null ? void 0 : result.confident) && !!((_a = options[0]) == null ? void 0 : _a.card);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "space-y-3", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          ref: inputRef,
          type: "file",
          accept: "image/*",
          capture: "environment",
          className: "hidden",
          onChange: (e) => {
            var _a2;
            return void onFile((_a2 = e.target.files) == null ? void 0 : _a2[0]);
          }
        }
      ),
      !current && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rounded-xl border border-dashed border-indigo-300 bg-indigo-50/50 px-4 py-6 text-center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "button",
          {
            type: "button",
            onClick: open,
            disabled: busy,
            className: "rounded-xl bg-indigo-600 px-5 py-3 text-base font-semibold text-white shadow-sm transition hover:bg-indigo-700 disabled:opacity-50",
            children: [
              "📷 ",
              t("photo.cta")
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-2 text-xs text-neutral-600", children: t("photo.tips") }),
        added && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "mt-2 text-sm font-medium text-green-700", children: [
          "✓ ",
          t("search.added", { name: added })
        ] })
      ] }),
      current && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col gap-3 rounded-xl border border-neutral-200 bg-white p-3 sm:flex-row", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: current.preview, alt: "", className: "mx-auto h-32 w-auto shrink-0 rounded-lg object-contain sm:mx-0 sm:h-48" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "min-w-0 flex-1", children: [
          busy && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "py-6 text-center text-sm text-neutral-500", children: t("photo.reading") }),
          current.error && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "py-3 text-sm text-rose-700", children: current.error }),
          result && options.length === 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "py-3 text-sm text-neutral-600", children: t("photo.noMatch") }),
          result && options.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm font-semibold text-neutral-900", children: confident ? `✓ ${t("photo.confident")}` : t("photo.pick") }),
            !confident && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-xs text-neutral-500", children: t("photo.pickHint") }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "mt-2 space-y-1.5", children: options.map(({ p: p2, rank, card }, i) => {
              const v2 = card ? clampVariant(card, { ...defaults, language: p2.language }) : null;
              const q2 = card && v2 ? quoteUnit(card, v2.language, v2.foil, v2.condition, mode, config) : null;
              const img = `https://cards.scryfall.io/small/front/${p2.scryfallId[0]}/${p2.scryfallId[1]}/${p2.scryfallId}.jpg`;
              return /* @__PURE__ */ jsxRuntimeExports.jsxs(
                "li",
                {
                  className: "flex items-center gap-3 rounded-lg border px-2 py-1.5 " + (i === 0 && confident ? "border-green-300 bg-green-50" : "border-neutral-200"),
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: img, alt: "", loading: "lazy", className: "h-16 w-12 shrink-0 rounded object-cover" }),
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "min-w-0 flex-1", children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "block truncate text-sm font-medium text-neutral-900", children: card && v2 ? displayName(card, v2.language) : p2.nameFr || p2.name }),
                      /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "flex items-center gap-1.5 text-xs text-neutral-500", children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "whitespace-nowrap font-mono", children: [
                          p2.expansionCode,
                          " ",
                          p2.collectorNumber
                        ] }),
                        v2 && /* @__PURE__ */ jsxRuntimeExports.jsx(LangBadge, { language: v2.language }),
                        q2 && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "font-semibold text-neutral-800", children: q2.eligible ? formatEur(q2.unit) : t("search.bulk") }),
                        (card == null ? void 0 : card.floorOnly) && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-[10px] text-neutral-400", title: t("photo.floorHint"), children: t("photo.floor") })
                      ] })
                    ] }),
                    card ? i === 0 && confident ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "shrink-0 text-lg text-green-600", "aria-hidden": true, children: "✓" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "button",
                      {
                        type: "button",
                        onClick: () => choose(p2, rank, card, true),
                        className: "shrink-0 rounded-lg bg-indigo-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-indigo-700",
                        children: t("search.add")
                      }
                    ) : /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "shrink-0 text-xs text-neutral-400", children: p2.basicLand ? t("photo.basicLand") : t("photo.notBought") })
                  ]
                },
                `${p2.scryfallId}-${i}`
              );
            }) }),
            confident && ((_b = options[0]) == null ? void 0 : _b.card) && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-2 flex flex-col gap-1.5 sm:flex-row", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(
                "button",
                {
                  type: "button",
                  onClick: () => choose(options[0].p, options[0].rank, options[0].card, true),
                  className: "rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-indigo-700",
                  children: [
                    "📷 ",
                    t("photo.next")
                  ]
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  type: "button",
                  onClick: () => choose(options[0].p, options[0].rank, options[0].card, false),
                  className: "rounded-lg border border-indigo-200 px-4 py-2.5 text-sm font-medium text-indigo-700 hover:bg-indigo-50",
                  children: t("search.add")
                }
              )
            ] }),
            result.remainingToday < 30 && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-2 text-[11px] text-neutral-400", children: t("photo.remaining", { count: result.remainingToday }) })
          ] }),
          !busy && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-3 flex flex-wrap gap-3 text-sm", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", onClick: open, className: "text-indigo-700 hover:underline", children: t("photo.retake") }),
            result && /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", onClick: none, className: "text-neutral-500 hover:underline", title: t("photo.noneHint"), children: t("photo.none") })
          ] })
        ] })
      ] })
    ] });
  }
  function VariantPicker({
    value,
    onChange,
    size = "full",
    hideLanguage,
    disabled,
    available
  }) {
    const compact = size === "compact";
    const canFoil = available ? available.foil : true;
    const canNonFoil = available ? available.nonFoil : true;
    const languages = (available == null ? void 0 : available.languages) ?? ["fr", "en"];
    const foilLocked = !(canFoil && canNonFoil);
    const control = compact ? "h-7 rounded-md border border-neutral-300 bg-white px-1 text-xs text-neutral-700" : "h-9 rounded-lg border border-neutral-300 bg-white px-2 text-sm text-neutral-700";
    return (
      // min-w-0 + flex-wrap : posé dans une rangée étroite (mode liste sur
      // mobile), le trio finition/état/langue débordait de son cadre au lieu de
      // passer à la ligne.
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `flex min-w-0 flex-wrap items-center ${compact ? "gap-1" : "gap-1.5"}`, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            type: "button",
            disabled: disabled || foilLocked,
            onClick: () => onChange({ ...value, foil: !value.foil }),
            title: foilLocked ? value.foil ? t("variant.foilOnly") : t("variant.noFoil") : value.foil ? t("variant.toNormal") : t("variant.toFoil"),
            className: `${control} shrink-0 font-medium transition disabled:opacity-40 ${value.foil ? "foil-badge !border-transparent text-neutral-900" : "text-neutral-500 hover:border-neutral-400"}`,
            children: value.foil ? t("variant.foil") : compact ? "✦" : t("variant.normal")
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "select",
          {
            disabled,
            value: value.condition,
            onChange: (e) => onChange({ ...value, condition: e.target.value }),
            title: t("variant.condition"),
            className: `${control} min-w-0 disabled:opacity-40`,
            children: CONDITIONS.map((c) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: c.code, children: compact ? c.code : `${c.code} — ${c.label}` }, c.code))
          }
        ),
        !hideLanguage && languages.length > 1 && /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "select",
          {
            disabled,
            value: value.language,
            onChange: (e) => onChange({ ...value, language: e.target.value }),
            title: t("variant.language"),
            className: `${control} min-w-0 disabled:opacity-40`,
            children: [
              languages.includes("fr") && /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "fr", children: t("variant.french") }),
              languages.includes("en") && /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "en", children: t("variant.english") })
            ]
          }
        )
      ] })
    );
  }
  function AccessNotice({
    state,
    variant
  }) {
    if (state === "eligible") return null;
    const urls = accountUrls();
    const copy = {
      anonymous: {
        title: t("access.anonTitle"),
        body: variant === "cart" ? t("access.cartAnon") : t("access.anonBody"),
        href: urls.login,
        cta: t("access.login")
      },
      "no-purchase": {
        title: t("access.noOrderTitle"),
        body: variant === "cart" ? t("access.cartNoOrder") : t("access.noOrderBody"),
        // ⚠️ **Préfixé par la langue, comme toute URL Shopify construite ici.**
        // Écrit en dur, ce lien ramenait le visiteur anglophone sur la boutique
        // française — et, le jour où un marché vit dans un sous-dossier, hors de
        // son marché : devise et taxes changeraient sous ses pieds.
        href: shopPath("/collections/all"),
        cta: t("access.shop")
      },
      "order-pending": {
        title: t("access.pendingTitle"),
        body: variant === "cart" ? t("access.cartPending") : t("access.pendingBody"),
        // Rien à faire qu'attendre : proposer d'aller commander serait à côté.
        href: null,
        cta: null
      }
    }[state];
    if (variant === "cart") {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rounded-lg bg-amber-50 px-3 py-2 text-xs text-amber-900", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: copy.body }),
        copy.href && /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: copy.href, className: "mt-1 inline-block font-semibold underline hover:text-amber-700", children: copy.cta })
      ] });
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mx-auto mb-3 flex max-w-screen-2xl flex-wrap items-center gap-x-3 gap-y-1 rounded-lg bg-amber-50 px-3 py-2 text-xs text-amber-900", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "font-semibold", children: copy.title }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-amber-800", children: copy.body }),
      copy.href && /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: copy.href, className: "font-semibold underline hover:text-amber-700", children: copy.cta }),
      state === "anonymous" && /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: urls.register, className: "underline hover:text-amber-700", children: t("access.createAccount") })
    ] });
  }
  function CartReviewModal({
    quote,
    config,
    customerState,
    canSubmit,
    onClose,
    onSubmit
  }) {
    const { state } = useBuybackCart();
    const empty = quote.lines.length === 0;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fixed inset-0 z-50 flex flex-col bg-neutral-50", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("header", { className: "shrink-0 border-b border-neutral-200 bg-white", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mx-auto flex max-w-screen-2xl flex-wrap items-center gap-x-4 gap-y-2 px-4 py-3", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "min-w-0", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { className: "flex items-center gap-2 text-lg font-semibold text-neutral-900", children: [
              t("review.title"),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "rounded bg-indigo-100 px-1.5 py-0.5 text-[11px] font-bold tracking-wide text-indigo-700", children: t("beta.badge") })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm text-neutral-500", children: t("review.subtitle") })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ml-auto flex items-center gap-2", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              "button",
              {
                onClick: onClose,
                className: "rounded-lg border border-neutral-300 bg-white px-3 py-2 text-sm font-medium text-neutral-700 transition hover:border-neutral-400",
                children: [
                  "← ",
                  t("review.back")
                ]
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "button",
              {
                disabled: !canSubmit || empty || quote.overCartCap || quote.total <= 0,
                onClick: onSubmit,
                className: "rounded-lg bg-neutral-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-indigo-600 disabled:cursor-not-allowed disabled:bg-neutral-300",
                children: t("cart.submit")
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "border-t border-neutral-100 bg-indigo-50/60", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mx-auto flex max-w-screen-2xl flex-wrap items-baseline gap-x-4 gap-y-1 px-4 py-2", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-sm text-neutral-700", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: quote.cardCount }),
            " ",
            t("review.cards")
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-sm text-neutral-500", children: [
            t("beta.estimateShort"),
            " :",
            " ",
            /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { className: "text-indigo-700", children: formatEur(quote.total) }),
            state.bulkKg > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-neutral-400", children: " + vrac" })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "min-w-0 flex-1 text-xs text-neutral-500", children: t("beta.estimateCart") })
        ] }) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "min-h-0 flex-1 overflow-y-auto", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mx-auto max-w-screen-2xl px-4 py-4", children: [
        !empty && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mb-3", children: /* @__PURE__ */ jsxRuntimeExports.jsx(AccessNotice, { state: customerState, variant: "cart" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mb-3 rounded-lg bg-white px-3 py-2 text-xs text-neutral-500 ring-1 ring-neutral-200", children: t("review.optional") }),
        empty ? /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "py-24 text-center text-neutral-500", children: t("review.empty") }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5", children: quote.lines.map((line) => /* @__PURE__ */ jsxRuntimeExports.jsx(ReviewTile, { line, config, subtotal: quote.subtotal }, line.key)) })
      ] }) })
    ] });
  }
  function ReviewTile({
    line,
    config,
    subtotal
  }) {
    const { setQty, setVariant, remove } = useBuybackCart();
    const key = {
      cardId: line.cardId,
      language: line.language,
      foil: line.foil,
      condition: line.condition
    };
    const room = maxAddable(line.quote.unit, subtotal - line.lineOffer, config);
    const canAdd = line.quote.eligible && room > line.quantity;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col overflow-hidden rounded-xl border border-neutral-200 bg-white", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative", children: [
        line.card.imageUrl ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: line.card.imageUrl, alt: "", loading: "lazy", className: "w-full" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "aspect-card w-full bg-neutral-200" }),
        line.foil && line.card.imageUrl && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "foil-overlay", "aria-hidden": true }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "absolute right-2 top-2 flex h-6 min-w-6 items-center justify-center rounded-full bg-indigo-600 px-1.5 text-xs font-bold text-white shadow", children: line.quantity }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            onClick: () => remove(key),
            title: t("review.removeLine"),
            className: "absolute left-2 top-2 rounded-full bg-white/90 p-1.5 text-neutral-500 shadow transition hover:bg-white hover:text-red-600",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M4 7h16M9 7V4h6v3m-8 0 1 13h8l1-13", strokeLinecap: "round", strokeLinejoin: "round" }) })
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-1 flex-col gap-1 p-2.5", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-1.5", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "span",
            {
              className: "min-w-0 truncate text-sm font-medium text-neutral-900",
              title: displayName(line.card, line.language),
              children: displayName(line.card, line.language)
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(LangBadge, { language: line.language })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "truncate text-xs text-neutral-500", children: [
          line.card.expansionCode,
          " · #",
          line.card.collectorNumber,
          " · ",
          rarityLabel(line.card.rarity)
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-auto pt-1.5", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            VariantPicker,
            {
              value: { language: line.language, foil: line.foil, condition: line.condition },
              onChange: (v2) => setVariant(key, { cardId: line.cardId, ...v2 }),
              size: "compact",
              hideLanguage: true,
              available: availableVariants(line.card)
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-1.5 flex items-center justify-between gap-1", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex h-9 items-center rounded-lg border border-neutral-300 bg-white", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  onClick: () => setQty(key, line.quantity - 1),
                  title: line.quantity === 1 ? t("offer.removeAll") : t("offer.removeOne"),
                  className: "px-2 text-neutral-600 hover:text-red-600",
                  children: "−"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-5 text-center text-sm font-semibold", children: line.quantity }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  onClick: () => setQty(key, line.quantity + 1),
                  disabled: !canAdd,
                  title: canAdd ? t("offer.addOne") : t("offer.capReached"),
                  className: "px-2 text-neutral-600 hover:text-indigo-600 disabled:cursor-not-allowed disabled:opacity-30",
                  children: "+"
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "span",
              {
                className: `text-base font-bold ${line.quote.eligible ? "text-indigo-700" : "text-neutral-400"}`,
                title: t("beta.estimateTile"),
                children: line.quote.eligible ? formatEur(line.lineOffer) : "—"
              }
            )
          ] }),
          !line.quote.eligible && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-1 text-xs text-amber-700", children: t("review.belowThreshold") }),
          line.quote.capped && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "mt-1 text-xs text-amber-700", children: [
            t("review.capped"),
            " ",
            formatEur(config.maxPerCardEur),
            "/u"
          ] })
        ] })
      ] })
    ] });
  }
  function CardOfferModal({ card, config, mode, initialVariant, subtotal, onClose }) {
    const { add, qtyOf } = useBuybackCart();
    const [language, setLanguage] = reactExports.useState(initialVariant.language);
    const [foil, setFoil] = reactExports.useState(initialVariant.foil);
    const [condition, setCondition] = reactExports.useState(initialVariant.condition);
    const [quantity, setQuantity] = reactExports.useState(1);
    reactExports.useEffect(() => {
      const handler = (e) => {
        if (e.key === "Escape") onClose();
      };
      window.addEventListener("keydown", handler);
      return () => window.removeEventListener("keydown", handler);
    }, [onClose]);
    const quote = quoteUnit(card, language, foil, condition, mode, config);
    const already = qtyOf({ cardId: card.id, language, foil, condition });
    const room = maxAddable(quote.unit, subtotal, config);
    const canAdd = quote.eligible && quantity > 0 && quantity <= room;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: "fixed inset-0 z-50 flex items-center justify-center p-4",
        onMouseDown: (e) => {
          if (e.target === e.currentTarget) onClose();
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute inset-0 bg-neutral-900/60", onClick: onClose }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative flex max-h-[92vh] w-full max-w-3xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-start justify-between gap-3 border-b border-neutral-200 px-5 py-3", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "min-w-0", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "truncate text-lg font-semibold text-neutral-900", children: displayName(card, language) }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "truncate text-xs text-neutral-500", children: [
                  card.expansion,
                  " · #",
                  card.collectorNumber,
                  " · ",
                  rarityLabel(card.rarity)
                ] })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: onClose, className: "rounded p-1 text-neutral-400 hover:bg-neutral-100", children: "✕" })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-1 flex-col gap-5 overflow-y-auto p-5 sm:flex-row", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mx-auto w-40 shrink-0 sm:mx-0 sm:w-48", children: card.imageUrl ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: card.imageUrl, alt: "", className: "w-full rounded-xl shadow-md" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "aspect-card w-full rounded-xl bg-neutral-200" }) }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex-1 space-y-4", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Field$1, { label: t("offer.yourLanguage"), children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Segmented,
                  {
                    options: [
                      { value: "fr", label: "🇫🇷 Français" },
                      { value: "en", label: "🇬🇧 Anglais" }
                    ],
                    value: language,
                    onChange: (v2) => setLanguage(v2)
                  }
                ) }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(Field$1, { label: "Finition", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Segmented,
                  {
                    options: [
                      { value: "no", label: "Normale" },
                      { value: "yes", label: "✦ Foil" }
                    ],
                    value: foil ? "yes" : "no",
                    onChange: (v2) => setFoil(v2 === "yes")
                  }
                ) }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(Field$1, { label: t("offer.cardCondition"), children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid grid-cols-1 gap-1.5", children: CONDITIONS.map((c) => {
                  const q2 = quoteUnit(card, language, foil, c.code, mode, config);
                  const active = condition === c.code;
                  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
                    "button",
                    {
                      onClick: () => setCondition(c.code),
                      className: `flex items-center justify-between gap-3 rounded-lg border px-3 py-2 text-left transition ${active ? "border-indigo-600 bg-indigo-50 ring-1 ring-indigo-600" : "border-neutral-200 hover:border-neutral-300 hover:bg-neutral-50"}`,
                      children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "min-w-0", children: [
                          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "block text-sm font-medium text-neutral-900", children: [
                            c.code,
                            " — ",
                            c.label
                          ] }),
                          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "block truncate text-xs text-neutral-500", children: c.hint })
                        ] }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx(
                          "span",
                          {
                            className: `shrink-0 text-sm font-semibold ${q2.eligible ? "text-neutral-900" : "text-neutral-400"}`,
                            children: q2.eligible ? formatEur(q2.unit) : "—"
                          }
                        )
                      ]
                    },
                    c.code
                  );
                }) }) }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rounded-xl bg-neutral-50 p-3 text-sm", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Row$1, { label: t("offer.marketPrice"), value: formatEur(quote.ref) }),
                  quote.refConditioned !== quote.ref && /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Row$1,
                    {
                      label: `Après état ${condition} (×${(config.conditionMultipliers[condition] ?? 1).toFixed(2)})`,
                      value: formatEur(quote.refConditioned)
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Row$1,
                    {
                      label: `Reprise ${mode === "credit" ? "en avoir" : "en cash"} (${Math.round(
                        quote.rate * 100
                      )} %)`,
                      value: formatEur(quote.raw)
                    }
                  ),
                  quote.wanted && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-1 text-xs font-medium text-amber-700", children: t("offer.wantedHintLong") }),
                  quote.capped && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "mt-1 text-xs text-amber-700", children: [
                    "Plafonné à ",
                    formatEur(config.maxPerCardEur),
                    " par carte — contactez-nous pour les pièces au-delà."
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-2 flex items-baseline justify-between border-t border-neutral-200 pt-2", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "font-medium text-neutral-700", children: t("offer.unitOffer") }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-xl font-bold text-indigo-700", children: quote.eligible ? formatEur(quote.unit) : "—" })
                  ] })
                ] }),
                !quote.eligible && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-800", children: [
                  t("offer.notEligiblePrefix", { min: formatEur(config.minCardPriceEur) }),
                  " ",
                  /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "bulk" }),
                  t("offer.byWeight")
                ] }),
                quote.eligible && room === 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-800", children: [
                  "Plafond de ",
                  formatEur(config.maxCartTotalEur),
                  " atteint pour ce panier de reprise."
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-3", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center rounded-lg border border-neutral-300", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "button",
                      {
                        onClick: () => setQuantity((q2) => Math.max(1, q2 - 1)),
                        className: "px-3 py-2 text-neutral-600 hover:bg-neutral-100",
                        children: "−"
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-10 text-center font-semibold", children: quantity }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "button",
                      {
                        onClick: () => setQuantity((q2) => Math.min(99, q2 + 1)),
                        className: "px-3 py-2 text-neutral-600 hover:bg-neutral-100",
                        children: "+"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "button",
                    {
                      disabled: !canAdd,
                      onClick: () => {
                        add({ cardId: card.id, language, foil, condition }, quantity, { origin: "SEARCH" });
                        onClose();
                      },
                      className: "flex-1 rounded-lg bg-neutral-900 py-2.5 text-sm font-semibold text-white transition hover:bg-indigo-600 disabled:cursor-not-allowed disabled:bg-neutral-300",
                      children: canAdd ? `Ajouter ${quantity} × ${formatEur(quote.unit)} = ${formatEur(quote.unit * quantity)}` : quote.eligible ? `Plafond atteint (${room} max)` : t("offer.notTakenAlone")
                    }
                  )
                ] }),
                already > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-xs text-neutral-500", children: [
                  "Déjà ",
                  already,
                  " exemplaire",
                  already > 1 ? "s" : "",
                  " de cette déclinaison dans votre panier de reprise."
                ] })
              ] })
            ] })
          ] })
        ]
      }
    );
  }
  function Field$1({ label, children }) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mb-1.5 block text-xs font-semibold uppercase tracking-wide text-neutral-500", children: label }),
      children
    ] });
  }
  function Segmented({
    options,
    value,
    onChange
  }) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "inline-flex rounded-lg border border-neutral-300 p-0.5", children: options.map((o) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        onClick: () => onChange(o.value),
        className: `rounded-md px-3 py-1.5 text-sm transition ${value === o.value ? "bg-neutral-900 font-semibold text-white" : "text-neutral-600 hover:bg-neutral-100"}`,
        children: o.label
      },
      o.value
    )) });
  }
  function Row$1({ label, value }) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex justify-between text-neutral-600", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: label }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "font-medium text-neutral-900", children: value })
    ] });
  }
  const CONDITION_CODES = new Set(CONDITIONS.map((c) => c.code));
  const IGNORED_LINES = /^(deck|sideboard|réserve|commander|commandant|companion|compagnon|maybeboard|considering|about|name .*)$/i;
  function variantToken(token) {
    const t2 = token.replace(/^[[(*]+|[\])*]+$/g, "").toUpperCase();
    if (!t2) return null;
    if (t2 === "F" || t2 === "FOIL") return { foil: true };
    if (t2 === "NF" || t2 === "NONFOIL" || t2 === "NORMAL") return { foil: false };
    if (t2 === "FR" || t2 === "FRA" || t2 === "FRENCH") return { language: "fr" };
    if (t2 === "EN" || t2 === "ENG" || t2 === "ENGLISH") return { language: "en" };
    if (CONDITION_CODES.has(t2)) return { condition: t2 };
    return null;
  }
  function parseBuylist(text) {
    const byKey = /* @__PURE__ */ new Map();
    for (const rawLine of text.split("\n")) {
      const raw = rawLine.trim();
      if (!raw || raw.startsWith("#") || raw.startsWith("//") || IGNORED_LINES.test(raw)) continue;
      const withQty = raw.match(/^(\d+)\s*[xX]?\s+(.+)$/);
      const qty = withQty ? Number(withQty[1]) : 1;
      if (qty <= 0 || qty > 999) continue;
      let rest = (withQty ? withQty[2] : raw).trim();
      const overrides = {};
      let expansionCode = null;
      let collectorNumber = null;
      const set = rest.match(/\(([A-Za-z0-9]{2,6})\)\s*([\w-]+)?/);
      if (set) {
        expansionCode = set[1].toUpperCase();
        if (set[2] && !variantToken(set[2])) collectorNumber = set[2];
        rest = rest.replace(set[0], " ").trim();
      }
      let words = rest.split(/\s+/).filter(Boolean);
      while (words.length > 1) {
        const found = variantToken(words[words.length - 1]);
        if (!found) break;
        Object.assign(overrides, found);
        words.pop();
      }
      if (!collectorNumber && words.length > 1 && /^\d{1,4}[a-z]?$/i.test(words[words.length - 1])) {
        collectorNumber = words.pop();
      }
      const name = words.join(" ").trim();
      if (!name) continue;
      const key = [
        normalize(name),
        expansionCode ?? "",
        collectorNumber ?? "",
        overrides.foil === void 0 ? "" : String(overrides.foil),
        overrides.condition ?? "",
        overrides.language ?? ""
      ].join("|");
      const existing = byKey.get(key);
      if (existing) existing.qty += qty;
      else byKey.set(key, { raw, qty, name, expansionCode, collectorNumber, overrides });
    }
    return [...byKey.values()];
  }
  function buildCardIndex(cards) {
    const index = /* @__PURE__ */ new Map();
    const push = (key, card) => {
      const arr = index.get(key);
      if (arr) {
        if (!arr.includes(card)) arr.push(card);
      } else {
        index.set(key, [card]);
      }
    };
    for (const card of cards) {
      for (const name of [card.name, card.nameFr]) {
        if (!name) continue;
        push(normalize(name), card);
        if (name.includes(" // ")) push(normalize(name.split(" // ")[0]), card);
      }
    }
    return index;
  }
  function matchBuylist(lines, index, defaults, defaultExpansion) {
    return lines.map((line) => {
      let candidates = index.get(normalize(line.name)) ?? [];
      if (!line.expansionCode && defaultExpansion) {
        const byDefault = candidates.filter((c) => c.expansionCode === defaultExpansion);
        if (byDefault.length > 0) candidates = byDefault;
      }
      if (line.expansionCode) {
        candidates = candidates.filter((c) => c.expansionCode.toUpperCase() === line.expansionCode);
      }
      if (line.collectorNumber) {
        const byNumber = candidates.filter((c) => c.collectorNumber === line.collectorNumber);
        if (byNumber.length > 0) candidates = byNumber;
      }
      candidates = [...candidates].sort((a, b) => a.cmEur - b.cmEur);
      return {
        line,
        candidates,
        selected: candidates[0] ?? null,
        variant: { ...defaults, ...line.overrides }
      };
    });
  }
  function ExpansionList({
    options,
    selected,
    onChange,
    single,
    autoFocus,
    listClass = "max-h-72",
    onPicked
  }) {
    const [query, setQuery] = reactExports.useState("");
    const shown = reactExports.useMemo(() => {
      const q2 = query.trim().toLowerCase();
      if (!q2) return options;
      return options.filter(
        (o) => o.name.toLowerCase().includes(q2) || o.code.toLowerCase().includes(q2)
      );
    }, [options, query]);
    const toggle = (code) => {
      if (single) {
        onChange(selected.includes(code) ? [] : [code]);
        onPicked == null ? void 0 : onPicked();
        return;
      }
      onChange(selected.includes(code) ? selected.filter((c) => c !== code) : [...selected, code]);
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          autoFocus,
          value: query,
          onChange: (e) => setQuery(e.target.value),
          placeholder: t("expansion.filter"),
          className: "mb-2 w-full rounded-lg border border-neutral-300 px-2 py-1.5 text-sm"
        }
      ),
      selected.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          type: "button",
          onClick: () => onChange([]),
          className: "mb-1 w-full rounded-lg px-2 py-1 text-left text-xs text-neutral-500 hover:bg-neutral-50",
          children: t("expansion.clear", { count: selected.length })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `${listClass} overflow-y-auto`, children: shown.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "px-2 py-3 text-center text-xs text-neutral-400", children: t("expansion.none") }) : shown.map((o) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "label",
        {
          className: "flex cursor-pointer items-center gap-2 rounded-lg px-2 py-2 text-sm hover:bg-neutral-50",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "input",
              {
                type: single ? "radio" : "checkbox",
                checked: selected.includes(o.code),
                onChange: () => toggle(o.code)
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "flex-1 truncate", children: o.name }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "shrink-0 font-mono text-[11px] text-neutral-400", children: o.code })
          ]
        },
        o.code
      )) })
    ] });
  }
  function ExpansionPicker({
    options,
    selected,
    onChange,
    single,
    emptyLabel = t("expansion.all")
  }) {
    var _a;
    const [open, setOpen] = reactExports.useState(false);
    const boxRef = reactExports.useRef(null);
    reactExports.useEffect(() => {
      if (!open) return;
      const onDown = (e) => {
        if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
      };
      document.addEventListener("mousedown", onDown);
      return () => document.removeEventListener("mousedown", onDown);
    }, [open]);
    const label = selected.length === 0 ? emptyLabel : selected.length === 1 ? ((_a = options.find((o) => o.code === selected[0])) == null ? void 0 : _a.name) ?? selected[0] : t("expansion.count", { count: selected.length });
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { ref: boxRef, className: "relative", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "button",
        {
          type: "button",
          onClick: () => setOpen((v2) => !v2),
          className: `flex min-w-0 max-w-[14rem] items-center gap-1.5 rounded-lg border px-2 py-2 text-sm ${selected.length > 0 ? "border-neutral-900 bg-neutral-900 text-white" : "border-neutral-300 bg-white text-neutral-700"}`,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "truncate", children: label }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-xs opacity-70", children: "▾" })
          ]
        }
      ),
      open && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute left-0 top-full z-10 mt-1 w-72 rounded-xl border border-neutral-200 bg-white p-2 shadow-lg", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        ExpansionList,
        {
          options,
          selected,
          onChange,
          single,
          autoFocus: true,
          onPicked: () => setOpen(false)
        }
      ) })
    ] });
  }
  const PLACEHOLDER = `4 Sol Ring
2 Sol Ring (C21) 263
1 Contresort (DOM) *F* LP
3 Lightning Bolt NM EN
Jeska's Will`;
  function BuylistPanel({
    catalog,
    config,
    mode,
    defaults,
    subtotal,
    onOpenCard
  }) {
    const { add, qtyOf, setQty } = useBuybackCart();
    const [text, setText] = reactExports.useState("");
    const [batchExpansion, setBatchExpansion] = reactExports.useState([]);
    const [batchVariant, setBatchVariant] = reactExports.useState(defaults);
    const [matches, setMatches] = reactExports.useState([]);
    const [feedback, setFeedback] = reactExports.useState(null);
    const index = reactExports.useMemo(() => buildCardIndex(catalog), [catalog]);
    const expansionOpts = reactExports.useMemo(() => expansionOptions(catalog), [catalog]);
    reactExports.useEffect(() => setBatchVariant(defaults), [defaults]);
    reactExports.useEffect(() => {
      setMatches(matchBuylist(parseBuylist(text), index, batchVariant, batchExpansion[0]));
      setFeedback(null);
    }, [text, index, batchVariant, batchExpansion]);
    const found = matches.filter((m2) => m2.selected !== null);
    const missing = matches.filter((m2) => m2.selected === null);
    const quoted = found.map((m2) => {
      const card = m2.selected;
      const quote = quoteUnit(card, m2.variant.language, m2.variant.foil, m2.variant.condition, mode, config);
      return { match: m2, card, quote, lineOffer: quote.eligible ? quote.unit * m2.line.qty : 0 };
    });
    const eligible = quoted.filter((q2) => q2.quote.eligible);
    const toBulk = quoted.filter((q2) => !q2.quote.eligible);
    const ambiguous = quoted.filter((q2) => q2.match.candidates.length > 1);
    const totalCards = eligible.reduce((s, q2) => s + q2.match.line.qty, 0);
    const totalOffer = eligible.reduce((s, q2) => s + q2.lineOffer, 0);
    const update = (target, patch) => {
      setMatches((prev) => prev.map((m2) => m2 === target ? { ...m2, ...patch } : m2));
      setFeedback(null);
    };
    const addAll = () => {
      let running = subtotal;
      let addedCards = 0;
      let skippedCards = 0;
      for (const { match, card, quote } of eligible) {
        const key = { cardId: card.id, ...match.variant };
        const room = maxAddable(quote.unit, running, config);
        const take = Math.min(match.line.qty, room);
        if (take > 0) {
          add(key, take, { origin: "LIST" });
          running += take * quote.unit;
          addedCards += take;
        }
        skippedCards += match.line.qty - take;
      }
      setFeedback(
        skippedCards > 0 ? `${addedCards} carte${addedCards > 1 ? "s" : ""} ajoutée${addedCards > 1 ? "s" : ""} — ${skippedCards} laissée${skippedCards > 1 ? "s" : ""} de côté, plafond de ${formatEur(config.maxCartTotalEur)} atteint.` : `✓ ${addedCards} carte${addedCards > 1 ? "s" : ""} ajoutée${addedCards > 1 ? "s" : ""} au panier de reprise.`
      );
    };
    const copyMissing = () => {
      var _a;
      void ((_a = navigator.clipboard) == null ? void 0 : _a.writeText(missing.map((m2) => `${m2.line.qty} ${m2.line.name}`).join("\n")));
      setFeedback(t("list.copied"));
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "space-y-3", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rounded-xl border border-neutral-200 bg-white p-3", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-xs text-neutral-500", children: [
          t("list.batchIntro"),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("code", { children: t("list.example") }),
          "."
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-3 flex flex-wrap items-center gap-2 rounded-lg bg-neutral-50 px-3 py-2", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-xs font-medium text-neutral-600", children: t("list.batchIs") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            ExpansionPicker,
            {
              options: expansionOpts,
              selected: batchExpansion,
              onChange: setBatchExpansion,
              single: true,
              emptyLabel: t("list.allEditions")
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(VariantPicker, { value: batchVariant, onChange: setBatchVariant }),
          (batchExpansion.length > 0 || batchVariant !== defaults) && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: () => {
                setBatchExpansion([]);
                setBatchVariant(defaults);
              },
              className: "text-xs text-neutral-500 underline hover:text-neutral-800",
              children: t("list.reset")
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "textarea",
          {
            value: text,
            onChange: (e) => setText(e.target.value),
            placeholder: PLACEHOLDER,
            rows: 7,
            className: "mt-3 w-full resize-y rounded-lg border border-neutral-300 p-3 font-mono text-sm outline-none placeholder:text-neutral-300 focus:border-indigo-500"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "mt-1 text-xs text-neutral-500", children: [
          t("list.oneCardPerLine"),
          /* @__PURE__ */ jsxRuntimeExports.jsx("code", { children: t("list.format") }),
          ". La quantité et le nom suffisent."
        ] })
      ] }),
      matches.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "rounded-xl border border-dashed border-neutral-300 bg-white py-12 text-center text-sm text-neutral-400", children: t("list.emptyResult") }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        (ambiguous.length > 0 || toBulk.length > 0) && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "space-y-1 rounded-xl bg-amber-50 px-3 py-2 text-xs text-amber-900", children: [
          ambiguous.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
            ambiguous.length,
            " ligne",
            ambiguous.length > 1 ? "s" : "",
            " existe",
            ambiguous.length > 1 ? "nt" : "",
            " en plusieurs éditions — l'édition la moins chère est retenue par défaut, corrigez-la si besoin."
          ] }),
          toBulk.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
            toBulk.length,
            " ligne",
            toBulk.length > 1 ? "s" : "",
            " sous ",
            formatEur(config.minCardPriceEur),
            " ",
            "dans l'état indiqué — à envoyer avec le lot bulk."
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "space-y-2", children: quoted.map(({ match, card, quote, lineOffer }) => {
          const key = { cardId: card.id, ...match.variant };
          const inCart = qtyOf(key);
          const room = maxAddable(quote.unit, subtotal, config);
          return /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "li",
            {
              className: "flex gap-3 rounded-xl border border-neutral-200 bg-white p-2.5",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: () => onOpenCard(card.id), className: "shrink-0", title: t("list.detail"), children: card.imageUrl ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: card.imageUrl, alt: "", loading: "lazy", className: "h-20 w-14 rounded-md object-cover object-top" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "h-20 w-14 rounded-md bg-neutral-200" }) }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex min-w-0 flex-1 flex-col gap-1", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-baseline gap-2", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-sm font-semibold text-neutral-900", children: [
                      match.line.qty,
                      "×"
                    ] }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "button",
                      {
                        onClick: () => onOpenCard(card.id),
                        className: "truncate text-left text-sm font-medium text-neutral-900 hover:text-indigo-700",
                        title: card.name,
                        children: card.name
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-auto shrink-0 text-sm font-bold text-neutral-900", children: quote.eligible ? formatEur(lineOffer) : "→ bulk" })
                  ] }),
                  match.candidates.length > 1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "select",
                    {
                      value: card.id,
                      onChange: (e) => update(match, {
                        selected: match.candidates.find((c) => c.id === Number(e.target.value)) ?? card
                      }),
                      className: "w-full rounded-md border border-neutral-300 px-2 py-1 text-xs text-neutral-700 outline-none focus:border-indigo-500",
                      title: t("list.editionOwned"),
                      children: match.candidates.map((c) => /* @__PURE__ */ jsxRuntimeExports.jsxs("option", { value: c.id, children: [
                        c.expansion,
                        " · #",
                        c.collectorNumber,
                        " — cote ",
                        formatEur(c.cmEur)
                      ] }, c.id))
                    }
                  ) : /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-xs text-neutral-500", children: [
                    card.expansion,
                    " · #",
                    card.collectorNumber,
                    " — cote ",
                    formatEur(quote.ref)
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      VariantPicker,
                      {
                        value: match.variant,
                        onChange: (variant) => update(match, { variant }),
                        size: "compact"
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-xs text-neutral-500", title: t("offer.wePayHint"), children: quote.eligible ? (
                      // Même raison que sur la vignette : un « 1,25 €/u »
                      // nu, dans une liste, se lit comme un tarif de vente.
                      `${t("offer.wePay")} ${formatEur(quote.unit)}/u`
                    ) : /* @__PURE__ */ jsxRuntimeExports.jsx("span", { title: t("list.belowThreshold"), children: t("list.joinBulk") }) }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ml-auto", children: inCart > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex h-8 items-center rounded-lg border border-neutral-300 bg-white", children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        "button",
                        {
                          onClick: () => setQty(key, inCart - 1),
                          className: "px-2 text-neutral-600 hover:text-red-600",
                          title: inCart === 1 ? t("offer.removeAll") : t("offer.removeOne"),
                          children: "−"
                        }
                      ),
                      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-6 text-center text-sm font-semibold", children: inCart }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        "button",
                        {
                          onClick: () => add(key, 1, { origin: "LIST" }),
                          disabled: room === 0,
                          className: "px-2 text-neutral-600 hover:text-indigo-600 disabled:opacity-30",
                          title: room === 0 ? t("offer.capReached") : t("offer.addOne"),
                          children: "+"
                        }
                      )
                    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(
                      "button",
                      {
                        onClick: () => add(key, Math.min(match.line.qty, room), { origin: "LIST" }),
                        disabled: !quote.eligible || room === 0,
                        className: "h-8 rounded-lg bg-neutral-900 px-3 text-xs font-semibold text-white transition hover:bg-indigo-600 disabled:cursor-not-allowed disabled:bg-neutral-200 disabled:text-neutral-400",
                        children: [
                          "Ajouter ",
                          match.line.qty
                        ]
                      }
                    ) })
                  ] })
                ] })
              ]
            },
            match.line.raw + card.id
          );
        }) }),
        missing.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rounded-xl border border-dashed border-neutral-300 bg-neutral-50 p-3", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between gap-2", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("h3", { className: "text-sm font-semibold text-neutral-700", children: [
              missing.length,
              " ligne",
              missing.length > 1 ? "s" : "",
              " introuvable",
              missing.length > 1 ? "s" : ""
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "button",
              {
                onClick: copyMissing,
                className: "rounded-lg border border-neutral-300 px-2.5 py-1 text-xs text-neutral-600 hover:border-neutral-500",
                children: t("list.copy")
              }
            )
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "mt-1 space-y-0.5 text-xs text-neutral-500", children: missing.map((m2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
            m2.line.qty,
            "× ",
            m2.line.name,
            m2.line.expansionCode ? ` (${m2.line.expansionCode})` : "",
            m2.line.expansionCode && index.has(normalize(m2.line.name)) && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-neutral-400", children: [
              " ",
              "— extension non reprise en ligne"
            ] })
          ] }, m2.line.raw)) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "sticky bottom-14 space-y-2 rounded-xl border border-neutral-200 bg-white p-3 shadow-lg lg:bottom-0", children: [
          feedback && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "rounded-lg bg-neutral-100 px-3 py-1.5 text-xs text-neutral-700", children: feedback }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-wrap items-center gap-x-4 gap-y-1 text-sm", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-neutral-600", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { className: "text-neutral-900", children: totalCards }),
              " carte",
              totalCards > 1 ? "s" : "",
              " reprise",
              totalCards > 1 ? "s" : "",
              " à l'unité",
              toBulk.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-neutral-400", children: [
                " · ",
                toBulk.length,
                " vers le bulk"
              ] }),
              missing.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-red-500", children: [
                " · ",
                missing.length,
                " introuvable",
                missing.length > 1 ? "s" : ""
              ] })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-auto text-lg font-bold text-neutral-900", children: formatEur(totalOffer) })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "button",
            {
              onClick: addAll,
              disabled: totalCards === 0,
              className: "w-full rounded-lg bg-neutral-900 py-2.5 text-sm font-semibold text-white transition hover:bg-indigo-600 disabled:cursor-not-allowed disabled:bg-neutral-200 disabled:text-neutral-400",
              children: [
                "Ajouter tout le résultat au panier (",
                totalCards,
                " carte",
                totalCards > 1 ? "s" : "",
                ")"
              ]
            }
          )
        ] })
      ] })
    ] });
  }
  function useIsCompact(query = "(max-width: 639px)") {
    const [compact, setCompact] = reactExports.useState(
      () => typeof window !== "undefined" && window.matchMedia(query).matches
    );
    reactExports.useEffect(() => {
      const mq = window.matchMedia(query);
      const onChange = () => setCompact(mq.matches);
      onChange();
      mq.addEventListener("change", onChange);
      return () => mq.removeEventListener("change", onChange);
    }, [query]);
    return compact;
  }
  function PayoutToggle({ config, delta }) {
    const { state, setPayoutMode } = useBuybackCart();
    const options = [
      { value: "cash", title: "Cash", rate: formatRate("cash", config), hint: t("payout.cash") },
      {
        value: "credit",
        title: t("payout.credit"),
        rate: formatRate("credit", config),
        hint: t("payout.creditSub")
      }
    ];
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mb-0 grid grid-cols-2 gap-2", children: options.map((o) => {
        const active = state.payoutMode === o.value;
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "button",
          {
            onClick: () => setPayoutMode(o.value),
            className: `rounded-xl border px-3 py-1.5 text-left transition ${active ? "border-indigo-600 bg-indigo-50 ring-1 ring-indigo-600" : "border-neutral-200 hover:border-neutral-300 hover:bg-neutral-50"}`,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "flex items-baseline justify-between gap-1", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-sm font-semibold text-neutral-900", children: o.title }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "span",
                  {
                    className: `whitespace-nowrap text-sm font-bold ${active ? "text-indigo-700" : "text-neutral-500"}`,
                    children: o.rate
                  }
                )
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "hidden text-xs text-neutral-500 sm:block", children: o.hint })
            ]
          },
          o.value
        );
      }) }),
      delta > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "button",
        {
          onClick: () => setPayoutMode(state.payoutMode === "cash" ? "credit" : "cash"),
          className: "mt-1 w-full rounded-lg bg-emerald-50 px-3 py-1 text-left text-xs text-emerald-800 hover:bg-emerald-100",
          children: [
            "💡 En ",
            state.payoutMode === "cash" ? "avoir boutique" : "cash",
            ", vous toucheriez",
            " ",
            /* @__PURE__ */ jsxRuntimeExports.jsxs("strong", { children: [
              formatEur(delta),
              " de plus"
            ] }),
            "."
          ]
        }
      )
    ] });
  }
  function BulkEditor({ config }) {
    const { state, setBulkKg } = useBuybackCart();
    const [showHelp, setShowHelp] = reactExports.useState(false);
    if (!config.bulkEnabled) return null;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: "relative",
        onMouseEnter: () => setShowHelp(true),
        onMouseLeave: () => setShowHelp(false),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-2 rounded-xl border border-neutral-200 bg-neutral-50 px-3 py-2", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-sm text-neutral-700", children: [
              "Cartes en vrac",
              " ",
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-xs text-neutral-400", children: t("bulk.estimate") })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "input",
              {
                type: "number",
                min: 0,
                max: config.bulkMaxKg,
                step: 0.5,
                value: state.bulkKg || "",
                placeholder: "0",
                "aria-label": t("bulk.title"),
                onFocus: () => setShowHelp(true),
                onBlur: () => setShowHelp(false),
                onChange: (e) => setBulkKg(Math.min(config.bulkMaxKg, Number(e.target.value) || 0)),
                className: "ml-auto w-16 rounded-lg border border-neutral-300 px-2 py-1 text-right text-sm"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-sm text-neutral-600", children: "kg" })
          ] }),
          showHelp && // En surimpression plutôt qu'en flux : ouvrir l'explication ne doit pas
          // décaler le panier sous les doigts du client.
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "absolute bottom-full left-0 z-10 mb-1 w-full rounded-xl border border-neutral-200 bg-white p-3 text-xs leading-relaxed text-neutral-600 shadow-lg", children: [
            t("bulk.intro"),
            /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: t("bulk.noBasicLands") }),
            ". Nous les pesons à réception et les reprenons ",
            formatEur(config.bulkPricePerKgEur),
            " le kilo — ce montant s’ajoutera à votre reprise.",
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mt-1 block text-neutral-400", children: t("bulk.noCommitment") })
          ] })
        ]
      }
    );
  }
  function BuybackCartPanel({
    quote,
    config,
    otherModeDelta,
    customerState,
    canSubmit,
    onSubmit,
    onReview
  }) {
    const { state, setQty, setVariant, remove, clear } = useBuybackCart();
    const empty = quote.lines.length === 0 && quote.bulkValue === 0;
    const compact = useIsCompact();
    return (
      // Seule la LISTE des cartes défile : le mode de règlement, le bulk, le
      // total et le bouton de validation restent visibles en permanence, quel
      // que soit le nombre de lignes.
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex min-h-0 flex-1 flex-col", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "shrink-0 border-b border-neutral-200 py-2 pl-4 pr-11 sm:py-2.5", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { className: "flex items-center gap-2 font-semibold text-neutral-900", children: [
          "Panier de reprise",
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-sm font-normal text-neutral-500", children: [
            "(",
            quote.cardCount,
            " carte",
            quote.cardCount > 1 ? "s" : "",
            ")"
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-auto hidden rounded bg-indigo-100 px-1.5 py-0.5 text-[11px] font-bold tracking-wide text-indigo-700 sm:inline", children: t("beta.badge") })
        ] }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "shrink-0 px-4 pt-2", children: config.cashEnabled !== false && /* @__PURE__ */ jsxRuntimeExports.jsx(PayoutToggle, { config, delta: otherModeDelta }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "min-h-0 flex-1 overflow-y-auto overscroll-contain px-4 py-2 sm:py-3", children: quote.lines.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "py-6 text-center text-sm text-neutral-500", children: t("cart.empty") }) : /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "divide-y divide-neutral-200", children: quote.lines.map((line) => (
          // ⚠️ **Trois lignes, pas quatre.** Le prix unitaire a rejoint la
          // ligne d'identité et la quantité celle de la déclinaison : une
          // ligne de moins par carte, c'est une carte de plus à l'écran.
          /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { className: "flex gap-3 py-2 sm:py-3", children: [
            line.card.imageUrl ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: line.card.imageUrl, alt: "", className: "h-16 w-11 shrink-0 rounded-md object-cover object-top" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "h-16 w-11 shrink-0 rounded-md bg-neutral-200" }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex min-w-0 flex-1 flex-col", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-1.5", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "span",
                  {
                    className: "truncate text-sm font-medium text-neutral-900",
                    title: displayName(line.card, line.language),
                    children: displayName(line.card, line.language)
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(LangBadge, { language: line.language })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "truncate text-xs text-neutral-500", children: [
                line.card.expansionCode,
                line.foil ? " · ✦ Foil" : "",
                " · cote ",
                formatEur(line.quote.ref),
                line.quote.eligible ? ` · ${formatEur(line.quote.unit)}/u` : " · sous le seuil"
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-1 flex items-center gap-1.5", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  VariantPicker,
                  {
                    value: line,
                    onChange: (variant) => setVariant(line, { cardId: line.cardId, ...variant }),
                    size: "compact",
                    hideLanguage: true
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ml-auto flex shrink-0 items-center rounded-md border border-neutral-300 text-sm", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "button",
                    {
                      onClick: () => setQty(line, line.quantity - 1),
                      className: "px-2 py-0.5 text-neutral-600 hover:bg-neutral-100",
                      children: "−"
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-6 text-center font-medium", children: line.quantity }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "button",
                    {
                      onClick: () => setQty(line, line.quantity + 1),
                      className: "px-2 py-0.5 text-neutral-600 hover:bg-neutral-100",
                      children: "+"
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "shrink-0 text-sm font-semibold text-neutral-900", children: formatEur(line.lineOffer) }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "button",
                  {
                    onClick: () => remove(line),
                    title: t("cart.remove"),
                    className: "shrink-0 rounded p-1 text-neutral-400 hover:bg-neutral-100 hover:text-red-600",
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M4 7h16M9 7V4h6v3m-8 0 1 13h8l1-13", strokeLinecap: "round", strokeLinejoin: "round" }) })
                  }
                )
              ] }),
              !line.quote.eligible && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "mt-1 text-xs text-amber-700", children: [
                "En ",
                line.condition,
                ", cette carte passe sous ",
                formatEur(config.minCardPriceEur),
                " : envoyez-la avec le bulk."
              ] }),
              line.quote.capped && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "mt-1 text-xs text-amber-700", children: [
                "Plafonnée à ",
                formatEur(config.maxPerCardEur),
                "/carte."
              ] })
            ] })
          ] }, line.key)
        )) }) }),
        config.bulkEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "shrink-0 px-4 pb-2 sm:pb-3", children: /* @__PURE__ */ jsxRuntimeExports.jsx(BulkEditor, { config }) }),
        quote.lines.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "hidden shrink-0 px-4 pb-2 sm:block", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "button",
          {
            onClick: onReview,
            title: t("review.openHint"),
            className: "flex w-full items-center justify-center gap-2 rounded-lg border border-neutral-300 bg-white py-2 text-sm font-medium text-neutral-700 transition hover:border-indigo-400 hover:text-indigo-700",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "15", height: "15", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z", strokeLinejoin: "round" }) }),
              t("review.open")
            ]
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "shrink-0 space-y-1.5 border-t border-neutral-200 bg-white px-4 pb-2 pt-2 sm:space-y-2 sm:pb-3 sm:pt-2.5", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ShippingProgress, { quote, config }),
          quote.subtotal > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("details", { open: !compact, className: "group", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("summary", { className: "flex cursor-pointer list-none items-center gap-1 text-xs text-neutral-500 sm:hidden", children: [
              t("cart.detail"),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "transition group-open:rotate-180", "aria-hidden": true, children: "▾" })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-1 space-y-0.5 text-sm sm:mt-0 sm:space-y-1", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Row, { label: t("cart.singles"), value: formatEur(quote.itemsValue) }),
              state.bulkKg > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(Row, { label: `Vrac (≈ ${state.bulkKg} kg)`, value: t("cart.weighedOnArrival"), muted: true }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Row,
                {
                  label: t("cart.shippingFee"),
                  value: quote.shippingFee > 0 ? `− ${formatEur(quote.shippingFee)}` : "offerts",
                  muted: quote.shippingFee === 0
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "pt-1 text-[11px] leading-snug text-neutral-500 sm:text-xs", children: t("beta.estimateCart") })
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-baseline justify-between gap-2 border-t border-neutral-200 pt-1.5 sm:pt-2", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-xs font-medium text-neutral-700 sm:text-sm", children: [
              t("beta.estimateShort"),
              " — vous recevez",
              " ",
              state.payoutMode === "credit" ? "en avoir" : "en cash"
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-xl font-bold text-indigo-700 sm:text-2xl", children: formatEur(quote.total) })
          ] }),
          state.bulkKg > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-xs text-neutral-500", children: t("cart.bulkExcluded") }),
          quote.overCartCap && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "rounded-lg bg-red-50 px-3 py-2 text-xs text-red-700", children: [
            "Plafond de ",
            formatEur(config.maxCartTotalEur),
            " dépassé de ",
            formatEur(quote.overCartCapBy),
            ". Retirez des cartes ou faites une seconde reprise."
          ] }),
          !empty && /* @__PURE__ */ jsxRuntimeExports.jsx(AccessNotice, { state: customerState, variant: "cart" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              disabled: !canSubmit || empty || quote.overCartCap || quote.total <= 0,
              onClick: onSubmit,
              className: "w-full rounded-lg bg-neutral-900 py-2 text-sm font-semibold text-white transition hover:bg-indigo-600 disabled:cursor-not-allowed disabled:bg-neutral-300 sm:py-2.5",
              children: t("cart.submit")
            }
          ),
          !empty && /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: clear, className: "w-full text-center text-xs text-neutral-400 hover:text-red-600", children: t("cart.clear") })
        ] })
      ] })
    );
  }
  function ShippingProgress({ quote, config }) {
    if (quote.subtotal <= 0 || quote.shippingFee === 0) return null;
    const pct = Math.min(100, quote.subtotal / config.shippingFreeThresholdEur * 100);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rounded-lg bg-amber-50 px-3 py-1", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-[11px] leading-snug text-amber-900 sm:text-xs", children: [
        t("cart.missing"),
        /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: formatEur(quote.missingForFreeShipping) }),
        " pour éviter les",
        " ",
        formatEur(config.shippingFeeEur),
        " de frais de port."
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mt-1 h-1 overflow-hidden rounded-full bg-amber-200", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "h-full rounded-full bg-amber-500 transition-all", style: { width: `${pct}%` } }) })
    ] });
  }
  function Row({ label, value, muted }) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex justify-between", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-neutral-500", children: label }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: muted ? "font-medium text-emerald-700" : "font-medium text-neutral-900", children: value })
    ] });
  }
  const EMPTY_FORM = {
    name: "",
    email: "",
    phone: "",
    address1: "",
    address2: "",
    zip: "",
    city: "",
    iban: "",
    terms: false
  };
  function SubmitModal({ quote, config, simulate, onClose, onSubmitted }) {
    const { state, setBulkNoBasics } = useBuybackCart();
    const [form, setForm] = reactExports.useState(EMPTY_FORM);
    const [submitting, setSubmitting] = reactExports.useState(false);
    const [failure, setFailure] = reactExports.useState(null);
    const [touched, setTouched] = reactExports.useState(false);
    const [prefilled, setPrefilled] = reactExports.useState(false);
    reactExports.useEffect(() => {
      let cancelled = false;
      void fetchPrefill().then((p2) => {
        if (!p2 || cancelled) return;
        setForm((f2) => ({
          ...f2,
          name: f2.name || (p2.customerName ?? ""),
          email: f2.email || (p2.customerEmail ?? ""),
          phone: f2.phone || (p2.customerPhone ?? ""),
          address1: f2.address1 || (p2.address1 ?? ""),
          address2: f2.address2 || (p2.address2 ?? ""),
          zip: f2.zip || (p2.zip ?? ""),
          city: f2.city || (p2.city ?? "")
        }));
        setPrefilled(Boolean(p2.customerName || p2.address1));
      });
      return () => {
        cancelled = true;
      };
    }, []);
    reactExports.useEffect(() => {
      const handler = (e) => {
        if (e.key === "Escape" && !submitting) onClose();
      };
      window.addEventListener("keydown", handler);
      return () => window.removeEventListener("keydown", handler);
    }, [onClose, submitting]);
    const set = (k2, v2) => setForm((f2) => ({ ...f2, [k2]: v2 }));
    const errors = {};
    if (!form.name.trim()) errors.name = t("submit.errName");
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email)) errors.email = t("submit.errEmail");
    if (!form.address1.trim()) errors.address1 = t("submit.errAddress");
    if (!/^\d{5}$/.test(form.zip)) errors.zip = t("submit.errZip");
    if (!form.city.trim()) errors.city = t("submit.errCity");
    if (state.payoutMode === "cash" && !/^FR\d{2}[0-9A-Z]{10,25}$/i.test(form.iban.replace(/\s/g, "")))
      errors.iban = t("submit.errIban");
    if (!form.terms) errors.terms = t("submit.errAccept");
    if (state.bulkKg > 0 && !state.bulkNoBasics)
      errors.bulk = t("submit.errBulk");
    const valid = Object.keys(errors).length === 0;
    const submit = () => {
      setTouched(true);
      setFailure(null);
      if (!valid) return;
      setSubmitting(true);
      if (simulate) {
        window.setTimeout(() => {
          const n2 = String(Math.floor(Math.random() * 9e3) + 1e3);
          onSubmitted({ reference: `RP-${(/* @__PURE__ */ new Date()).getFullYear()}-${n2}`, total: quote.total }, form.email);
        }, 700);
        return;
      }
      void submitBuyback({
        lines: state.lines.map((l2) => ({
          cardId: l2.cardId,
          language: l2.language,
          foil: l2.foil,
          condition: l2.condition,
          quantity: l2.quantity,
          // Sans elles, le dépôt réécrirait les lignes du brouillon sans dire
          // d'où elles viennent, et les photos perdraient leur ligne.
          origins: l2.origins,
          photoIds: l2.photoIds
        })),
        payoutMode: state.payoutMode,
        bulkKg: state.bulkKg,
        bulkNoBasics: state.bulkNoBasics || void 0,
        customerName: form.name.trim(),
        customerEmail: form.email.trim(),
        customerPhone: form.phone.trim() || void 0,
        address1: form.address1.trim(),
        address2: form.address2.trim() || void 0,
        zip: form.zip.trim(),
        city: form.city.trim(),
        iban: state.payoutMode === "cash" ? form.iban.replace(/\s/g, "") : void 0
      }).then((result) => onSubmitted({ reference: result.reference, total: result.total }, form.email)).catch((error) => {
        setFailure(error.message || t("error.submit"));
        setSubmitting(false);
      });
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: "fixed inset-0 z-50 flex items-center justify-center p-4",
        onMouseDown: (e) => {
          if (e.target === e.currentTarget && !submitting) onClose();
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute inset-0 bg-neutral-900/60", onClick: () => !submitting && onClose() }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative flex max-h-[92vh] w-full max-w-2xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between border-b border-neutral-200 px-5 py-3", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "text-lg font-semibold text-neutral-900", children: t("submit.title") }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  onClick: onClose,
                  disabled: submitting,
                  className: "rounded p-1 text-neutral-400 hover:bg-neutral-100",
                  children: "✕"
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex-1 space-y-4 overflow-y-auto p-5", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rounded-xl bg-neutral-50 p-3 text-sm", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex justify-between text-neutral-600", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
                    quote.cardCount,
                    " carte",
                    quote.cardCount > 1 ? "s" : "",
                    " à l'unité"
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "font-medium text-neutral-900", children: formatEur(quote.itemsValue) })
                ] }),
                quote.bulkValue > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex justify-between text-neutral-600", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
                    "Vrac ≈ ",
                    state.bulkKg,
                    " kg — pesé à réception"
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "font-medium text-neutral-900", children: formatEur(quote.bulkValue) })
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex justify-between text-neutral-600", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: t("submit.shipping") }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "font-medium text-neutral-900", children: quote.shippingFee > 0 ? `− ${formatEur(quote.shippingFee)}` : "offerts" })
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-2 flex items-baseline justify-between border-t border-neutral-200 pt-2", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "font-medium text-neutral-700", children: [
                    "Total ",
                    state.payoutMode === "credit" ? "en avoir boutique" : "en cash"
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-xl font-bold text-indigo-700", children: formatEur(quote.total) })
                ] })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-xs text-neutral-500", children: [
                t("beta.estimateCart"),
                " ",
                t("beta.estimateWhy")
              ] }),
              failure && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700", children: failure }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "grid gap-3 sm:grid-cols-2", children: [
                prefilled && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "sm:col-span-2 rounded-lg bg-neutral-100 px-3 py-2 text-xs text-neutral-600", children: t("submit.addressIntro") }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { label: t("submit.name"), value: form.name, onChange: (v2) => set("name", v2), error: touched ? errors.name : void 0 }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { label: "Email", type: "email", value: form.email, onChange: (v2) => set("email", v2), error: touched ? errors.email : void 0 }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { label: t("submit.phone"), value: form.phone, onChange: (v2) => set("phone", v2) }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "sm:col-span-2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { label: "Adresse", value: form.address1, onChange: (v2) => set("address1", v2), error: touched ? errors.address1 : void 0 }) }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "sm:col-span-2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { label: t("submit.extra"), value: form.address2, onChange: (v2) => set("address2", v2) }) }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { label: t("submit.zip"), value: form.zip, onChange: (v2) => set("zip", v2), error: touched ? errors.zip : void 0 }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { label: "Ville", value: form.city, onChange: (v2) => set("city", v2), error: touched ? errors.city : void 0 })
              ] }),
              state.payoutMode === "cash" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                Input,
                {
                  label: t("submit.iban"),
                  value: form.iban,
                  onChange: (v2) => set("iban", v2),
                  error: touched ? errors.iban : void 0,
                  hint: t("submit.ibanNote")
                }
              ) : /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "rounded-lg bg-indigo-50 px-3 py-2 text-sm text-indigo-900", children: [
                t("submit.yourCredit"),
                /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: formatEur(quote.total) }),
                " vous sera envoyé sous forme de carte cadeau Nevermint, sans date d'expiration et utilisable en plusieurs fois."
              ] }),
              state.bulkKg > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(
                "label",
                {
                  className: `flex cursor-pointer items-start gap-2 rounded-lg px-3 py-2 text-xs ${touched && errors.bulk ? "bg-red-50 text-red-800" : "bg-neutral-50 text-neutral-700"}`,
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "input",
                      {
                        type: "checkbox",
                        checked: state.bulkNoBasics,
                        onChange: (e) => setBulkNoBasics(e.target.checked),
                        className: "mt-0.5"
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
                      t("submit.bulkCertify"),
                      " ",
                      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: t("submit.noBasicLands") }),
                      " ",
                      t("submit.basicLandsList")
                    ] })
                  ]
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "flex cursor-pointer items-start gap-2 text-xs text-neutral-700", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "checkbox", checked: form.terms, onChange: (e) => set("terms", e.target.checked), className: "mt-0.5" }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
                  "J'accepte les conditions de reprise : offre valable 30 jours, cartes envoyées avec l'étiquette fournie, frais de port de ",
                  formatEur(config.shippingFeeEur),
                  " déduits en dessous de",
                  " ",
                  formatEur(config.shippingFreeThresholdEur),
                  ", offre révisée si l'état constaté diffère de l'état déclaré."
                ] })
              ] }),
              touched && errors.terms && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-xs text-red-600", children: errors.terms })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "border-t border-neutral-200 p-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "button",
              {
                onClick: submit,
                disabled: submitting,
                className: "w-full rounded-lg bg-neutral-900 py-2.5 text-sm font-semibold text-white transition hover:bg-indigo-600 disabled:bg-neutral-400",
                children: submitting ? "Envoi…" : `Envoyer ma demande de reprise (${formatEur(quote.total)})`
              }
            ) })
          ] })
        ]
      }
    );
  }
  function Input({
    label,
    value,
    onChange,
    type = "text",
    error,
    hint
  }) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "block", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mb-1 block text-xs font-medium text-neutral-600", children: label }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type,
          value,
          onChange: (e) => onChange(e.target.value),
          className: `w-full rounded-lg border px-3 py-2 text-sm ${error ? "border-red-400 bg-red-50" : "border-neutral-300"}`
        }
      ),
      error ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mt-0.5 block text-xs text-red-600", children: error }) : hint ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mt-0.5 block text-xs text-neutral-400", children: hint }) : null
    ] });
  }
  function ConfirmationScreen({
    reference,
    total,
    payoutMode,
    email,
    config,
    onRestart
  }) {
    const steps2 = [
      {
        title: t("done.step1.title"),
        body: t("done.step1.body", { hours: config.reviewDelayHours ?? 24 })
      },
      {
        title: t("done.step2.title"),
        body: `Imprimez l'étiquette et le bordereau, glissez le bordereau dans le colis (il porte la référence ${reference}), déposez le colis en point relais.`
      },
      {
        title: t("done.step3.title"),
        body: t("done.step3.body")
      },
      {
        title: t("done.step4.title"),
        body: payoutMode === "credit" ? t("done.step4.credit", { hours: config.receptionDelayHours ?? 48 }) : t("done.step4.cash", { hours: config.receptionDelayHours ?? 48 })
      }
    ];
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mx-auto max-w-2xl px-4 py-12", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rounded-2xl border border-emerald-200 bg-emerald-50 p-6 text-center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-4xl", children: "📦" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "mt-2 text-2xl font-semibold text-neutral-900", children: t("done.title") }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "mt-1 text-sm text-neutral-600", children: [
          t("done.reference"),
          /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { className: "font-mono", children: reference }),
          " — un récapitulatif vient d'être envoyé à",
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: email }),
          "."
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-3 text-3xl font-bold text-emerald-700", children: formatEur(total) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-xs text-neutral-500", children: [
          t("beta.estimateShort").toLowerCase(),
          " ",
          payoutMode === "credit" ? t("done.inCredit") : t("done.inCash")
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mx-auto mt-2 max-w-lg text-xs text-neutral-500", children: t("beta.estimateWhy") })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("ol", { className: "mt-6 space-y-3", children: steps2.map((s, i) => /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { className: "flex gap-3 rounded-xl border border-neutral-200 bg-white p-4", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-neutral-900 text-sm font-bold text-white", children: i + 1 }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm font-semibold text-neutral-900", children: s.title }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-0.5 text-sm text-neutral-600", children: s.body })
        ] })
      ] }, s.title)) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "mt-4 rounded-xl bg-neutral-100 px-4 py-3 text-xs text-neutral-500", children: [
        "Prototype : aucune donnée n'a été transmise et aucun email n'a été envoyé. En production, cette soumission crée une reprise dans ShopAlyse (statut ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("code", { children: "SUBMITTED" }),
        ") et déclenche le mail d'accusé."
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          onClick: onRestart,
          className: "mt-6 w-full rounded-lg border border-neutral-300 py-2.5 text-sm font-semibold text-neutral-700 hover:bg-neutral-50",
          children: t("done.again")
        }
      )
    ] });
  }
  function ConfigPanel({ config, onChange, onReset, onClose, session, onSession }) {
    const [draft, setDraft] = reactExports.useState(config);
    const num = (k2, label, step = 0.01, suffix = "€") => /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "flex items-center justify-between gap-3 py-1.5", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-sm text-neutral-700", children: label }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "number",
            step,
            value: draft[k2],
            onChange: (e) => setDraft({ ...draft, [k2]: Number(e.target.value) }),
            className: "w-24 rounded-lg border border-neutral-300 px-2 py-1 text-right text-sm"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-8 text-xs text-neutral-400", children: suffix })
      ] })
    ] });
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fixed inset-0 z-[60] flex justify-end", onMouseDown: (e) => e.target === e.currentTarget && onClose(), children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute inset-0 bg-neutral-900/40", onClick: onClose }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("aside", { className: "relative flex w-[26rem] max-w-[94vw] flex-col bg-white shadow-2xl", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between border-b border-neutral-200 px-4 py-3", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "font-semibold text-neutral-900", children: "⚙ Réglages de la reprise" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: onClose, className: "rounded p-1 text-neutral-400 hover:bg-neutral-100", children: "✕" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex-1 overflow-y-auto px-4 py-3", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "mb-3 rounded-lg bg-amber-50 px-3 py-2 text-xs text-amber-800", children: [
            "Prototype : ces valeurs vivent en localStorage. En production elles viennent de la table",
            /* @__PURE__ */ jsxRuntimeExports.jsx("code", { className: "mx-1", children: "BuybackConfig" }),
            " via ",
            /* @__PURE__ */ jsxRuntimeExports.jsx("code", { children: "GET /public/buyback/config" }),
            "."
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Section, { title: "Accès au service", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "flex items-start justify-between gap-3 py-1.5", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-sm text-neutral-700", children: [
                "Réservé aux clients ayant déjà commandé",
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "block text-xs text-neutral-400", children: "au moins une commande non annulée" })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "input",
                {
                  type: "checkbox",
                  className: "mt-1",
                  checked: draft.requirePriorPurchase,
                  onChange: (e) => setDraft({ ...draft, requirePriorPurchase: e.target.checked })
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "py-1.5", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "mb-1 block text-sm text-neutral-700", children: [
                "Client simulé",
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "block text-xs text-neutral-400", children: "appliqué immédiatement, hors « Appliquer »" })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid gap-1", children: [
                { value: "eligible", label: "Connecté, commande terminée" },
                { value: "order-pending", label: "Connecté, commande en cours" },
                { value: "no-purchase", label: "Connecté, aucune commande" },
                { value: "anonymous", label: "Visiteur non connecté" }
              ].map((o) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  onClick: () => onSession({ ...session, state: o.value }),
                  className: `rounded-lg border px-2.5 py-1.5 text-left text-sm transition ${session.state === o.value ? "border-indigo-600 bg-indigo-50 font-medium text-indigo-900" : "border-neutral-200 text-neutral-600 hover:border-neutral-300"}`,
                  children: o.label
                },
                o.value
              )) })
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Section, { title: "Éligibilité et taux", children: [
            num("minCardPriceEur", "Prix minimum à l’unité"),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "flex items-center justify-between gap-3 py-1.5", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-sm text-neutral-700", children: "Taux cash" }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "flex items-center gap-1", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "input",
                  {
                    type: "number",
                    step: 1,
                    value: Math.round(draft.cashRate * 100),
                    onChange: (e) => setDraft({ ...draft, cashRate: Number(e.target.value) / 100 }),
                    className: "w-24 rounded-lg border border-neutral-300 px-2 py-1 text-right text-sm"
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-8 text-xs text-neutral-400", children: "%" })
              ] })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "flex items-center justify-between gap-3 py-1.5", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-sm text-neutral-700", children: "Taux avoir boutique" }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "flex items-center gap-1", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "input",
                  {
                    type: "number",
                    step: 1,
                    value: Math.round(draft.creditRate * 100),
                    onChange: (e) => setDraft({ ...draft, creditRate: Number(e.target.value) / 100 }),
                    className: "w-24 rounded-lg border border-neutral-300 px-2 py-1 text-right text-sm"
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-8 text-xs text-neutral-400", children: "%" })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Section, { title: "Plafonds", children: [
            num("maxPerCardEur", "Plafond par carte", 1),
            num("maxCartTotalEur", "Plafond du panier", 10)
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Section, { title: "Frais d'envoi des cartes", children: [
            num("shippingFeeEur", "Frais déduits", 0.1),
            num("shippingFreeThresholdEur", "Franchise à partir de", 5)
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Section, { title: "Bulk au poids", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "flex items-center justify-between gap-3 py-1.5", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-sm text-neutral-700", children: "Reprise du bulk activée" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "input",
                {
                  type: "checkbox",
                  checked: draft.bulkEnabled,
                  onChange: (e) => setDraft({ ...draft, bulkEnabled: e.target.checked })
                }
              )
            ] }),
            num("bulkPricePerKgEur", "Tarif au kilo", 0.5),
            num("bulkMaxKg", "Poids maximum", 1, "kg")
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Section, { title: "Multiplicateurs d’état", children: CONDITIONS.map((c) => /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "flex items-center justify-between gap-3 py-1.5", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-sm text-neutral-700", children: [
              c.code,
              " ",
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-xs text-neutral-400", children: c.label })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "flex items-center gap-1", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "input",
                {
                  type: "number",
                  step: 1,
                  value: Math.round((draft.conditionMultipliers[c.code] ?? 1) * 100),
                  onChange: (e) => setDraft({
                    ...draft,
                    conditionMultipliers: {
                      ...draft.conditionMultipliers,
                      [c.code]: Number(e.target.value) / 100
                    }
                  }),
                  className: "w-24 rounded-lg border border-neutral-300 px-2 py-1 text-right text-sm"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "w-8 text-xs text-neutral-400", children: "%" })
            ] })
          ] }, c.code)) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex gap-2 border-t border-neutral-200 p-4", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: () => {
                setDraft(DEFAULT_CONFIG);
                onReset();
              },
              className: "rounded-lg border border-neutral-300 px-3 py-2 text-sm text-neutral-600 hover:bg-neutral-50",
              children: "Défauts"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: () => {
                onChange(draft);
                onClose();
              },
              className: "flex-1 rounded-lg bg-neutral-900 py-2 text-sm font-semibold text-white hover:bg-indigo-600",
              children: "Appliquer"
            }
          )
        ] })
      ] })
    ] });
  }
  function Section({ title, children }) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mb-4", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "mb-1 text-xs font-semibold uppercase tracking-wide text-neutral-400", children: title }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "divide-y divide-neutral-100", children })
    ] });
  }
  const stroke = {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  };
  function Art({ children }) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { viewBox: "0 0 64 64", className: "h-14 w-14 shrink-0", "aria-hidden": true, children: /* @__PURE__ */ jsxRuntimeExports.jsx("g", { ...stroke, children }) });
  }
  const ArtCart = /* @__PURE__ */ jsxRuntimeExports.jsxs(Art, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M8 14h6l6 27h27l6-19H18" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "25", cy: "50", r: "3" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "44", cy: "50", r: "3" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "26", y: "8", width: "12", height: "17", rx: "2" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "34", y: "12", width: "12", height: "17", rx: "2" })
  ] });
  const ArtLabel = /* @__PURE__ */ jsxRuntimeExports.jsxs(Art, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "6", y: "14", width: "38", height: "26", rx: "3" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M6 18l19 13 19-13" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "34", y: "34", width: "24", height: "20", rx: "2" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M38 39v10M42 39v10M46 39v6M50 39v10M54 39v6" })
  ] });
  const ArtPack = /* @__PURE__ */ jsxRuntimeExports.jsxs(Art, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M8 22l24-10 24 10v24L32 56 8 46z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M8 22l24 10 24-10M32 32v24" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "25", y: "6", width: "14", height: "12", rx: "2" })
  ] });
  const ArtReceived = /* @__PURE__ */ jsxRuntimeExports.jsxs(Art, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M8 24l18-8 18 8v20l-18 8-18-8z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M8 24l18 8 18-8M26 32v20" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "50", cy: "46", r: "10" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M45.5 46l3 3 6-6.5" })
  ] });
  const ArtInspect = /* @__PURE__ */ jsxRuntimeExports.jsxs(Art, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "10", y: "8", width: "26", height: "36", rx: "3" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M15 15h16M15 21h10" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "38", cy: "38", r: "12" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M47 47l8 8" })
  ] });
  const ArtPayout = /* @__PURE__ */ jsxRuntimeExports.jsxs(Art, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "6", y: "16", width: "34", height: "22", rx: "3" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "23", cy: "27", r: "5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "24", y: "30", width: "34", height: "22", rx: "3" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M24 38h34M41 30v-4M37 26h8" })
  ] });
  const ArtFork = /* @__PURE__ */ jsxRuntimeExports.jsxs(Art, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M10 32h12l10-14h22M22 32l10 14h22" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "50", cy: "18", r: "6" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M47.5 18l2 2 3-3.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "50", cy: "46", r: "6" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M47.5 43.5l5 5M52.5 43.5l-5 5" })
  ] });
  const ArtReturn = /* @__PURE__ */ jsxRuntimeExports.jsxs(Art, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M16 26l16-8 16 8v18l-16 8-16-8z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M16 26l16 8 16-8M32 34v18" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M52 12H20M26 6l-6 6 6 6" })
  ] });
  function steps(config) {
    return [
      {
        n: 1,
        art: ArtCart,
        title: t("how.s1.title"),
        body: config.cashEnabled === false ? "Je cherche mes cartes ou je colle ma liste, je déclare pour chacune sa langue, sa finition et son état, puis je renseigne mes coordonnées et je valide ma demande." : "Je cherche mes cartes ou je colle ma liste, je déclare pour chacune sa langue, sa finition et son état. Je choisis mon mode d'encaissement — cash ou avoir boutique — puis je renseigne mes coordonnées et je valide ma demande.",
        note: config.cashEnabled === false ? `La reprise est réglée en avoir boutique, à ${formatRate("credit", config)} de la cote selon la valeur de la carte. Sous ${formatEur(config.shippingFreeThresholdEur)} de reprise, ${formatEur(config.shippingFeeEur)} de frais de port sont déduits.` : `L'avoir boutique rapporte ${formatRate("credit", config)} de la cote contre ${formatRate("cash", config)} en cash, selon la valeur de la carte. Sous ${formatEur(config.shippingFreeThresholdEur)} de reprise, ${formatEur(config.shippingFeeEur)} de frais de port sont déduits. ${t("beta.estimateCart")}`
      },
      {
        n: 2,
        art: ArtLabel,
        title: t("how.s2.title"),
        body: "Nevermint analyse ma demande. Si tout est en ordre, je reçois par email mon étiquette d'envoi prépayée au format PDF, accompagnée du bordereau récapitulatif de ma reprise. Si une cote a bougé ou qu'une carte ne peut pas être reprise, une nouvelle offre m'est proposée — je l'accepte ou je renonce, et rien n'est expédié tant que je n'ai pas tranché.",
        note: `Sous ${config.reviewDelayHours ?? 24} h ouvrées. L’envoi est à la charge de Nevermint — je n’avance rien. L’étiquette reste valable ${config.shipmentValidityDays ?? 7} jours.`
      },
      {
        n: 3,
        art: ArtPack,
        title: t("how.s3.title"),
        body: "J'imprime l'étiquette et le bordereau, je glisse le bordereau dans le colis, puis je le dépose dans un bureau de poste ou un point relais Pickup. Le suivi est attaché à mon étiquette.",
        note: "Je protège bien mes cartes : pochettes individuelles pour les pièces de valeur, le tout serré entre deux cartons rigides. Une carte abîmée pendant le transport est une carte déclassée à la réception."
      },
      {
        n: 4,
        art: ArtReceived,
        title: t("how.s4.title"),
        body: "Dès l'ouverture du colis, je reçois un email confirmant que mes cartes sont bien arrivées."
      },
      {
        n: 5,
        art: ArtInspect,
        title: t("how.s5.title"),
        body: "Chaque carte est contrôlée : version, extension, langue et état réel. Le lot bulk est pesé. Deux issues possibles — soit tout correspond à ma déclaration et mon panier est validé tel quel, soit des modifications me sont proposées.",
        note: "C’est l’état constaté qui fait foi. Une carte annoncée NM et reçue en Light Played est repayée au tarif Light Played."
      },
      {
        n: 6,
        art: ArtPayout,
        title: t("how.s6.title"),
        body: `Si aucune modification n'est nécessaire, je reçois mon virement bancaire ou mon avoir sur mon compte Nevermint, sous ${config.receptionDelayHours ?? 48} h.`,
        branch: "ok"
      },
      {
        n: 7,
        art: ArtFork,
        title: t("how.s7.title"),
        body: `Si l'état constaté diffère, je reçois le détail ligne par ligne avec le nouveau montant. J'accepte et je suis payé sous ${config.receptionDelayHours ?? 48} h, ou je refuse — les cartes me sont alors renvoyées aux frais de Nevermint.`,
        note: `L’offre reste valable ${config.offerValidityHours ?? 48} h. Sans réponse de ma part, une relance m’est envoyée avant toute clôture.`,
        branch: "choice"
      },
      {
        n: 8,
        art: ArtReturn,
        title: t("how.s8.title"),
        body: "Nevermint me réexpédie l'intégralité de mon lot, dans l'état où il a été reçu. Rien n'est conservé sans mon accord.",
        branch: "choice"
      }
    ];
  }
  function HowItWorksModal({ config, onClose }) {
    reactExports.useEffect(() => {
      const handler = (e) => {
        if (e.key === "Escape") onClose();
      };
      window.addEventListener("keydown", handler);
      return () => window.removeEventListener("keydown", handler);
    }, [onClose]);
    const all = steps(config);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: "fixed inset-0 z-[55] flex items-center justify-center p-0 sm:p-4",
        onMouseDown: (e) => {
          if (e.target === e.currentTarget) onClose();
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute inset-0 bg-neutral-900/60", onClick: onClose }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative flex h-full max-h-full w-full max-w-3xl flex-col overflow-hidden bg-white shadow-2xl sm:h-auto sm:max-h-[92vh] sm:rounded-2xl", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex shrink-0 items-center justify-between border-b border-neutral-200 px-5 py-3", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "text-lg font-semibold text-neutral-900", children: t("how.title") }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-xs text-neutral-500", children: t("how.subtitle") })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: onClose, className: "rounded p-1 text-neutral-400 hover:bg-neutral-100", "aria-label": t("how.close"), children: "✕" })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "min-h-0 flex-1 overflow-y-auto px-5 py-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx("ol", { className: "space-y-1", children: all.map((step, i) => /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
              step.branch === "ok" && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "py-2 text-center text-xs font-semibold uppercase tracking-wide text-neutral-400", children: t("how.fork") }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(
                "div",
                {
                  className: `flex gap-4 rounded-xl p-3 ${step.branch === "ok" ? "bg-emerald-50" : step.branch === "choice" ? "bg-amber-50" : "bg-neutral-50"}`,
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col items-center gap-1", children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        "span",
                        {
                          className: `flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-bold text-white ${step.branch === "ok" ? "bg-emerald-600" : step.branch === "choice" ? "bg-amber-600" : "bg-neutral-900"}`,
                          children: step.n
                        }
                      ),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        "span",
                        {
                          className: step.branch === "ok" ? "text-emerald-700" : step.branch === "choice" ? "text-amber-700" : "text-indigo-600",
                          children: step.art
                        }
                      )
                    ] }),
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "min-w-0 flex-1 pt-0.5", children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "text-sm font-semibold text-neutral-900", children: step.title }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-1 text-sm text-neutral-600", children: step.body }),
                      step.note && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "mt-1.5 rounded-lg bg-white/70 px-2.5 py-1.5 text-xs text-neutral-500", children: [
                        "💡 ",
                        step.note
                      ] })
                    ] })
                  ]
                }
              ),
              i < all.length - 1 && step.branch !== "ok" && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ml-[1.6rem] h-3 w-px bg-neutral-200" })
            ] }, step.n)) }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "shrink-0 border-t border-neutral-200 p-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "button",
              {
                onClick: onClose,
                className: "w-full rounded-lg bg-neutral-900 py-2.5 text-sm font-semibold text-white transition hover:bg-indigo-600",
                children: t("how.cta")
              }
            ) })
          ] })
        ]
      }
    );
  }
  function DoorCard({ name, promise, bullets, cta, featured, onChoose }) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: "relative flex flex-col rounded-2xl border bg-white p-6 transition " + (featured ? "border-indigo-300 shadow-lg ring-1 ring-indigo-100 md:-mt-3 md:p-7" : "border-neutral-200 shadow-sm hover:border-neutral-300"),
        children: [
          featured && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "absolute -top-3 left-6 rounded-full bg-indigo-600 px-3 py-1 text-xs font-semibold text-white", children: t("door.badge") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "font-semibold text-neutral-900 " + (featured ? "text-xl" : "text-lg"), children: name }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-1 text-sm text-neutral-600", children: promise }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "mt-4 flex-1 space-y-2 text-sm text-neutral-700", children: bullets.map((b) => /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { className: "flex gap-2", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": true, className: featured ? "text-indigo-600" : "text-neutral-400", children: "✓" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: b })
          ] }, b)) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              type: "button",
              onClick: onChoose,
              className: "mt-6 w-full rounded-lg px-4 py-3 text-sm font-semibold transition " + (featured ? "bg-indigo-600 text-white hover:bg-indigo-700" : "border border-neutral-300 bg-white text-neutral-800 hover:bg-neutral-50"),
              children: cta
            }
          )
        ]
      }
    );
  }
  function ModeChooser({ config, remoteConfig, onChoose }) {
    const fullServiceOn = remoteConfig ? remoteConfig.fullServiceEnabled : true;
    const threshold = (remoteConfig == null ? void 0 : remoteConfig.fullServiceDetailThresholdEur) ?? 0.2;
    const maxCards = (remoteConfig == null ? void 0 : remoteConfig.fullServiceMaxCards) ?? 2e3;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: "mx-auto max-w-screen-xl px-4 py-10", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mx-auto max-w-2xl text-center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "text-2xl font-semibold text-neutral-900 sm:text-3xl", children: t("door.title") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-3 text-sm text-neutral-600", children: t("door.subtitle") })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-10 grid gap-5 md:grid-cols-3 md:items-start", children: [
        fullServiceOn && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "md:order-2", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            DoorCard,
            {
              featured: true,
              name: t("door.full.name"),
              promise: t("door.full.promise"),
              bullets: [
                t("door.full.b1"),
                t("door.full.b2", { threshold: formatEur(threshold) }),
                // ⚠️ **Ce que devient le RESTE se dit ici.** Sans cette ligne, le
                // seuil se lit comme un tri entre « repris » et « écarté » : le
                // client imagine qu'on lui rendra le fond de sa boîte, ou pire
                // qu'on le gardera sans le payer. Tout est acheté — le détail
                // au-dessus du seuil, le reste au poids.
                t("door.full.b3bulk"),
                t("door.full.b3")
              ],
              cta: t("door.full.cta"),
              onChoose: () => onChoose("FULL_SERVICE")
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-2 text-center text-xs text-neutral-500", children: t("simple.cards.max", { max: maxCards }) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "md:order-1", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          DoorCard,
          {
            name: t("door.list.name"),
            promise: t("door.list.promise"),
            bullets: [
              t("door.list.b1"),
              t("door.list.b2"),
              t("door.list.b3", { rate: formatRate("credit", config) }),
              // ⚠️ **Le minimum se dit AVANT de composer.** Il n'était annoncé
              // nulle part : le client cotait ses trois cartes une par une et
              // se faisait refuser au moment de valider, après tout le travail.
              t("door.list.min", { min: (remoteConfig == null ? void 0 : remoteConfig.minCardsPerCart) ?? 1 })
            ],
            cta: t("door.list.cta"),
            onChoose: () => onChoose("A_LA_CARTE")
          }
        ) }),
        config.bulkEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "md:order-3", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          DoorCard,
          {
            name: t("door.bulk.name"),
            promise: t("door.bulk.promise"),
            bullets: [
              t("door.bulk.b1"),
              t("door.bulk.b2", {
                price: formatEur(config.bulkPricePerKgEur),
                max: config.bulkMaxKg
              }),
              t("door.bulk.b3")
            ],
            cta: t("door.bulk.cta"),
            onChoose: () => onChoose("BULK")
          }
        ) })
      ] })
    ] });
  }
  const EMPTY = {
    cards: "",
    kg: "",
    note: "",
    name: "",
    email: "",
    phone: "",
    address1: "",
    address2: "",
    zip: "",
    city: "",
    iban: "",
    noBasics: false,
    terms: false
  };
  function Field({
    label,
    value,
    onChange,
    type = "text",
    error,
    hint,
    placeholder
  }) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "block", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mb-1 block text-xs font-medium text-neutral-600", children: label }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type,
          value,
          placeholder,
          onChange: (e) => onChange(e.target.value),
          className: `w-full rounded-lg border px-3 py-2 text-sm ${error ? "border-red-400 bg-red-50" : "border-neutral-300"}`
        }
      ),
      error ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mt-0.5 block text-xs text-red-600", children: error }) : hint ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mt-0.5 block text-xs text-neutral-500", children: hint }) : null
    ] });
  }
  function SimpleSubmitForm({
    mode,
    config,
    remoteConfig,
    simulate,
    onBack,
    onSubmitted
  }) {
    const [form, setForm] = reactExports.useState(EMPTY);
    const [payoutMode, setPayoutMode] = reactExports.useState("credit");
    const [submitting, setSubmitting] = reactExports.useState(false);
    const [touched, setTouched] = reactExports.useState(false);
    const [failure, setFailure] = reactExports.useState(null);
    const full = mode === "FULL_SERVICE";
    const maxCards = (remoteConfig == null ? void 0 : remoteConfig.fullServiceMaxCards) ?? 2e3;
    const threshold = (remoteConfig == null ? void 0 : remoteConfig.fullServiceDetailThresholdEur) ?? 0.2;
    reactExports.useEffect(() => {
      let cancelled = false;
      void fetchPrefill().then((p2) => {
        if (!p2 || cancelled) return;
        setForm((f2) => ({
          ...f2,
          name: f2.name || (p2.customerName ?? ""),
          email: f2.email || (p2.customerEmail ?? ""),
          phone: f2.phone || (p2.customerPhone ?? ""),
          address1: f2.address1 || (p2.address1 ?? ""),
          address2: f2.address2 || (p2.address2 ?? ""),
          zip: f2.zip || (p2.zip ?? ""),
          city: f2.city || (p2.city ?? "")
        }));
      });
      return () => {
        cancelled = true;
      };
    }, []);
    const set = (k2, v2) => setForm((f2) => ({ ...f2, [k2]: v2 }));
    const cards = Number(form.cards.replace(/\s/g, "")) || 0;
    const kg2 = Number(form.kg.replace(",", ".")) || 0;
    const errors = {};
    if (full) {
      if (cards <= 0) errors.lot = t("simple.needCards");
      else if (cards > maxCards) errors.lot = t("simple.cards.max", { max: maxCards });
    } else if (kg2 <= 0 && cards <= 0) {
      errors.lot = t("simple.needSomething");
    }
    if (!form.name.trim()) errors.name = t("submit.errName");
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email)) errors.email = t("submit.errEmail");
    if (!form.address1.trim()) errors.address1 = t("submit.errAddress");
    if (!/^\d{4,5}$/.test(form.zip)) errors.zip = t("submit.errZip");
    if (!form.city.trim()) errors.city = t("submit.errCity");
    if (payoutMode === "cash" && !/^FR\d{2}[0-9A-Z]{10,25}$/i.test(form.iban.replace(/\s/g, "")))
      errors.iban = t("submit.errIban");
    if (!full && !form.noBasics) errors.noBasics = t("submit.errBulk");
    if (!form.terms) errors.terms = t("submit.errAccept");
    const valid = Object.keys(errors).length === 0;
    const submit = () => {
      setTouched(true);
      setFailure(null);
      if (!valid) return;
      setSubmitting(true);
      if (simulate) {
        window.setTimeout(() => {
          const n2 = String(Math.floor(Math.random() * 9e3) + 1e3);
          onSubmitted(`RP-${(/* @__PURE__ */ new Date()).getFullYear()}-${n2}`, form.email);
        }, 700);
        return;
      }
      void submitSimpleBuyback({
        mode,
        payoutMode,
        estimatedCards: full ? cards : void 0,
        bulkKg: !full && kg2 > 0 ? kg2 : void 0,
        bulkCards: !full && cards > 0 ? cards : void 0,
        customerNote: form.note.trim() || void 0,
        customerName: form.name.trim(),
        customerEmail: form.email.trim(),
        customerPhone: form.phone.trim() || void 0,
        address1: form.address1.trim(),
        address2: form.address2.trim() || void 0,
        zip: form.zip.trim(),
        city: form.city.trim(),
        iban: payoutMode === "cash" ? form.iban.replace(/\s/g, "") : void 0
      }).then((result) => onSubmitted(result.reference, form.email)).catch((error) => {
        setFailure(error.message || t("error.submit"));
        setSubmitting(false);
      });
    };
    const review = config.reviewDelayHours ?? 24;
    const reception = config.receptionDelayHours ?? 48;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: "mx-auto max-w-3xl px-4 py-10", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          type: "button",
          onClick: onBack,
          className: "text-sm text-neutral-500 hover:text-neutral-800",
          children: t("door.back")
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "mt-4 text-2xl font-semibold text-neutral-900", children: full ? t("simple.full.title") : t("simple.bulk.title") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-2 text-sm text-neutral-600", children: full ? t("simple.full.intro") : t("simple.bulk.intro") }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("ol", { className: "mt-6 space-y-2 rounded-xl bg-neutral-50 p-4 text-sm text-neutral-700", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "font-medium text-neutral-900", children: t("simple.steps.title") }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
          "1. ",
          t("simple.steps.1", { hours: review })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
          "2. ",
          t("simple.steps.2")
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
          "3. ",
          t("simple.steps.3", { reception })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
          "4. ",
          t("simple.steps.4")
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-8 space-y-5", children: [
        full ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          Field,
          {
            label: t("simple.cards.label"),
            type: "number",
            value: form.cards,
            onChange: (v2) => set("cards", v2),
            hint: `${t("simple.cards.help")} ${t("simple.cards.max", { max: maxCards })}`,
            error: touched ? errors.lot : void 0
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "grid gap-3 sm:grid-cols-2", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Field,
            {
              label: t("simple.kg.label"),
              value: form.kg,
              onChange: (v2) => set("kg", v2),
              hint: t("simple.kg.help")
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Field,
            {
              label: t("simple.cards.label"),
              type: "number",
              value: form.cards,
              onChange: (v2) => set("cards", v2),
              error: touched ? errors.lot : void 0
            }
          )
        ] }),
        full && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "rounded-lg border border-indigo-100 bg-indigo-50 px-3 py-3 text-xs leading-relaxed text-indigo-900", children: t("simple.full.detail", {
          threshold: formatEur(threshold),
          bulk: formatEur(config.bulkPricePerKgEur)
        }).split("**").map(
          (part, i) => i % 2 === 1 ? /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: part }, i) : /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: part }, i)
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "block", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mb-1 block text-xs font-medium text-neutral-600", children: t("simple.note.label") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "textarea",
            {
              value: form.note,
              rows: 4,
              placeholder: t("simple.note.placeholder"),
              onChange: (e) => set("note", e.target.value),
              className: "w-full rounded-lg border border-neutral-300 px-3 py-2 text-sm"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mt-0.5 block text-xs text-neutral-500", children: t("simple.note.help") })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "grid gap-3 sm:grid-cols-2", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Field,
            {
              label: t("submit.name"),
              value: form.name,
              onChange: (v2) => set("name", v2),
              error: touched ? errors.name : void 0
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Field,
            {
              label: "Email",
              type: "email",
              value: form.email,
              onChange: (v2) => set("email", v2),
              error: touched ? errors.email : void 0
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Field, { label: t("submit.phone"), value: form.phone, onChange: (v2) => set("phone", v2) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "sm:col-span-2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Field,
            {
              label: "Adresse",
              value: form.address1,
              onChange: (v2) => set("address1", v2),
              error: touched ? errors.address1 : void 0
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "sm:col-span-2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Field,
            {
              label: t("submit.extra"),
              value: form.address2,
              onChange: (v2) => set("address2", v2)
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Field,
            {
              label: t("submit.zip"),
              value: form.zip,
              onChange: (v2) => set("zip", v2),
              error: touched ? errors.zip : void 0
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Field,
            {
              label: "Ville",
              value: form.city,
              onChange: (v2) => set("city", v2),
              error: touched ? errors.city : void 0
            }
          )
        ] }),
        config.cashEnabled !== false && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mb-1 block text-xs font-medium text-neutral-600", children: t("simple.payout") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid grid-cols-2 gap-2", children: ["credit", "cash"].map((m2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              type: "button",
              onClick: () => setPayoutMode(m2),
              className: "rounded-lg border px-3 py-2 text-sm transition " + (payoutMode === m2 ? "border-indigo-500 bg-indigo-50 font-medium text-indigo-800" : "border-neutral-300 bg-white text-neutral-700 hover:bg-neutral-50"),
              children: m2 === "cash" ? "Cash" : t("payout.credit")
            },
            m2
          )) })
        ] }),
        payoutMode === "cash" && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Field,
          {
            label: t("submit.iban"),
            value: form.iban,
            onChange: (v2) => set("iban", v2),
            error: touched ? errors.iban : void 0
          }
        ),
        !full && /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "flex gap-2 text-sm text-neutral-700", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "input",
            {
              type: "checkbox",
              checked: form.noBasics,
              onChange: (e) => set("noBasics", e.target.checked),
              className: "mt-0.5"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
            t("simple.noBasics"),
            touched && errors.noBasics && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mt-0.5 block text-xs text-red-600", children: errors.noBasics })
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "flex gap-2 text-sm text-neutral-700", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "input",
            {
              type: "checkbox",
              checked: form.terms,
              onChange: (e) => set("terms", e.target.checked),
              className: "mt-0.5"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
            t("simple.terms"),
            touched && errors.terms && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mt-0.5 block text-xs text-red-600", children: errors.terms })
          ] })
        ] }),
        failure && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700", children: failure }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            type: "button",
            onClick: submit,
            disabled: submitting,
            className: "w-full rounded-lg bg-indigo-600 px-4 py-3 text-sm font-semibold text-white hover:bg-indigo-700 disabled:opacity-60",
            children: submitting ? t("simple.sending") : full ? t("simple.submit.full") : t("simple.submit.bulk")
          }
        )
      ] })
    ] });
  }
  const STORAGE_KEY = "buyback-session";
  const DEFAULT_SESSION = { state: "eligible", email: "client@example.com" };
  function loadSession() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return DEFAULT_SESSION;
      const parsed = JSON.parse(raw);
      const state = parsed.state === "anonymous" || parsed.state === "no-purchase" || parsed.state === "order-pending" ? parsed.state : "eligible";
      return { state, email: typeof parsed.email === "string" ? parsed.email : DEFAULT_SESSION.email };
    } catch {
      return DEFAULT_SESSION;
    }
  }
  function saveSession(session) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    } catch {
    }
  }
  function canSubmitBuyback(session, requirePriorPurchase) {
    if (!requirePriorPurchase) return session.state !== "anonymous";
    return session.state === "eligible";
  }
  function BoutiqueChrome({ onOpenConfig }) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-indigo-700 py-2 text-center text-xs text-white", children: t("app.tagline") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "border-b border-neutral-200 bg-white", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mx-auto flex max-w-screen-2xl items-center gap-10 px-4 py-4", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-2xl font-semibold tracking-wide text-neutral-900", children: "Nevermint" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("nav", { className: "hidden items-center gap-7 text-sm text-neutral-600 md:flex", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Infos" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Magic the Gathering" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "font-medium text-neutral-900 underline decoration-2 underline-offset-8", children: t("app.title") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Classements" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Contact" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            onClick: onOpenConfig,
            title: "Réglages du prototype",
            className: "ml-auto rounded-lg border border-neutral-300 px-2.5 py-1.5 text-sm text-neutral-500 hover:bg-neutral-50",
            children: "⚙"
          }
        )
      ] }) })
    ] });
  }
  function Hero({ config, onOpenGuide }) {
    const chips = [
      // ⚠️ **Une fourchette, pas un pourcentage unique.** Dès qu'un barème par
      // palier existe, annoncer « 85 % » serait faux pour toutes les petites
      // cartes — et le client le découvrirait au moment de composer son panier.
      config.cashEnabled === false ? `💶 ${formatRate("credit", config)} de la cote en avoir boutique` : `💶 ${formatRate("cash", config)} en cash · ${formatRate("credit", config)} en avoir`,
      `📦 Retour offert dès ${formatEur(config.shippingFreeThresholdEur)}`,
      `⚖️ Bulk à ${formatEur(config.bulkPricePerKgEur)}/kg`,
      `≈ ${t("beta.estimateShort")} — révisable en cours de reprise`
    ];
    const chip = (c) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      "span",
      {
        className: "shrink-0 whitespace-nowrap rounded-full border border-neutral-200 bg-white px-2.5 py-1 text-xs text-neutral-600",
        children: c
      },
      c
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "border-b border-neutral-200 bg-gradient-to-b from-indigo-50 to-white", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mx-auto max-w-screen-2xl px-4 py-2 md:py-2.5", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-wrap items-center gap-x-4 gap-y-2", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("h1", { className: "flex min-w-0 items-center gap-2 text-base font-semibold text-neutral-900 md:text-lg", children: [
          t("app.title"),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "span",
            {
              title: t("beta.hint"),
              className: "rounded bg-indigo-100 px-1.5 py-0.5 text-[11px] font-bold tracking-wide text-indigo-700",
              children: t("beta.badge")
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "hidden flex-wrap items-center gap-1.5 md:flex", children: chips.map(chip) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            onClick: onOpenGuide,
            className: "ml-auto hidden shrink-0 rounded-lg border border-indigo-200 bg-white px-3 py-1.5 text-sm font-medium text-indigo-700 transition hover:border-indigo-400 hover:bg-indigo-50 md:block",
            children: t("app.howItWorks")
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "-mx-4 mt-1.5 flex gap-1.5 overflow-x-auto px-4 pb-0.5 md:hidden", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            onClick: onOpenGuide,
            className: "shrink-0 whitespace-nowrap rounded-full border border-indigo-300 bg-white px-2.5 py-1 text-xs font-semibold text-indigo-700",
            children: t("app.howItWorks")
          }
        ),
        chips.map(chip)
      ] })
    ] }) });
  }
  function Buyback({
    catalog,
    config,
    session,
    embedded,
    photoDailyLimit,
    onBack,
    onOpenConfig
  }) {
    const { state, clear, setPayoutMode, replaceAll, localUpdatedAt } = useBuybackCart();
    const [draftLoaded, setDraftLoaded] = reactExports.useState(false);
    const [tab, setTab] = reactExports.useState("search");
    const [defaultVariant, setDefaultVariant] = reactExports.useState(DEFAULT_VARIANT);
    const [modalCardId, setModalCardId] = reactExports.useState(null);
    const [cartOpen, setCartOpen] = reactExports.useState(false);
    const [reviewOpen, setReviewOpen] = reactExports.useState(false);
    const [submitOpen, setSubmitOpen] = reactExports.useState(false);
    const [guideOpen, setGuideOpen] = reactExports.useState(false);
    const [confirmation, setConfirmation] = reactExports.useState(
      null
    );
    const cardsById = reactExports.useMemo(() => {
      const m2 = new Map(catalog.map((c) => [c.id, c]));
      for (const c of Object.values(state.extraCards ?? {})) if (!m2.has(c.id)) m2.set(c.id, c);
      return m2;
    }, [catalog, state.extraCards]);
    const quote = reactExports.useMemo(() => quoteCart(state, cardsById, config), [state, cardsById, config]);
    const delta = reactExports.useMemo(() => payoutDelta(state, cardsById, config), [state, cardsById, config]);
    reactExports.useEffect(() => {
      if (config.cashEnabled === false && state.payoutMode === "cash") setPayoutMode("credit");
    }, [config.cashEnabled, state.payoutMode, setPayoutMode]);
    const canSubmit = canSubmitBuyback(session, config.requirePriorPurchase);
    reactExports.useEffect(() => {
      if (!embedded || !canSubmit || draftLoaded) return;
      let cancelled = false;
      void fetchDraft().then((draft) => {
        if (cancelled) {
          return;
        }
        setDraftLoaded(true);
        if (!draft || draft.lines.length === 0) return;
        const local = localUpdatedAt();
        if (local && new Date(local) >= new Date(draft.updatedAt)) return;
        replaceAll({
          lines: draft.lines.map((l2) => ({
            cardId: l2.cardId,
            language: l2.language,
            foil: l2.foil,
            condition: l2.condition,
            quantity: l2.quantity,
            key: `${l2.cardId}|${l2.language}|${l2.foil ? "F" : "N"}|${l2.condition}`,
            origins: (l2.origin ?? "").split(",").filter(Boolean),
            photoIds: l2.photoIds ?? []
          })),
          payoutMode: draft.payoutMode === "STORE_CREDIT" ? "credit" : "cash",
          bulkKg: draft.bulkKg ?? 0,
          bulkNoBasics: false,
          // Les cartes hors catalogue du brouillon : l'index ne les connaît pas,
          // le serveur les décrit.
          extraCards: Object.fromEntries(
            draft.lines.filter((l2) => l2.floorPriced && l2.name && l2.expansionCode && l2.collectorNumber).map((l2) => [
              l2.cardId,
              floorCard({
                cardId: l2.cardId,
                name: l2.name,
                expansionCode: l2.expansionCode,
                collectorNumber: l2.collectorNumber,
                scryfallId: l2.scryfallId
              })
            ])
          )
        });
      });
      return () => {
        cancelled = true;
      };
    }, [embedded, canSubmit, draftLoaded, replaceAll, localUpdatedAt]);
    reactExports.useEffect(() => {
      if (!embedded || !canSubmit || !draftLoaded) return;
      const timer = setTimeout(() => {
        void saveDraft({
          lines: state.lines.map((l2) => ({
            cardId: l2.cardId,
            language: l2.language,
            foil: l2.foil,
            condition: l2.condition,
            quantity: l2.quantity,
            origins: l2.origins,
            photoIds: l2.photoIds
          })),
          payoutMode: state.payoutMode,
          bulkKg: state.bulkKg
        }).catch(() => {
        });
      }, 2e3);
      return () => clearTimeout(timer);
    }, [embedded, canSubmit, draftLoaded, state]);
    const overlayOpen = cartOpen || reviewOpen || submitOpen || guideOpen || modalCardId !== null;
    reactExports.useEffect(() => {
      if (!overlayOpen) return;
      const previous = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = previous;
      };
    }, [overlayOpen]);
    if (confirmation) {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "min-h-screen bg-neutral-50", children: [
        !embedded && /* @__PURE__ */ jsxRuntimeExports.jsx(BoutiqueChrome, { onOpenConfig }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          ConfirmationScreen,
          {
            reference: confirmation.reference,
            total: confirmation.total,
            payoutMode: state.payoutMode,
            email: confirmation.email,
            config,
            onRestart: () => {
              clear();
              setConfirmation(null);
            }
          }
        )
      ] });
    }
    const modalCard = modalCardId !== null ? cardsById.get(modalCardId) ?? null : null;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "min-h-screen bg-neutral-50", children: [
      !embedded && /* @__PURE__ */ jsxRuntimeExports.jsx(BoutiqueChrome, { onOpenConfig }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mx-auto max-w-screen-2xl px-4 pt-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", onClick: onBack, className: "text-sm text-neutral-500 hover:text-neutral-800", children: t("door.back") }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Hero, { config, onOpenGuide: () => setGuideOpen(true) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(AccessNotice, { state: session.state, variant: "banner" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mx-auto flex max-w-screen-2xl gap-6 px-4 pb-24 pt-4 lg:pb-6", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("main", { className: "min-w-0 flex-1", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "text-lg font-semibold text-neutral-900", children: t("list.title") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-0.5 text-sm text-neutral-600", children: t("list.subtitle") }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-3 flex flex-wrap items-center gap-2 text-sm", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-neutral-600", children: t("list.myCardsAre") }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(VariantPicker, { value: defaultVariant, onChange: setDefaultVariant })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mt-4 flex gap-1 border-b border-neutral-200", role: "tablist", children: ["search", "photo", "paste"].map((k2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              type: "button",
              role: "tab",
              "aria-selected": tab === k2,
              onClick: () => setTab(k2),
              className: "-mb-px flex-1 whitespace-nowrap border-b-2 px-1.5 py-2 text-[13px] font-medium transition sm:flex-none sm:px-3 sm:text-sm " + (tab === k2 ? "border-indigo-600 text-indigo-700" : "border-transparent text-neutral-500 hover:text-neutral-800"),
              children: t(`list.tab.${k2}`)
            },
            k2
          )) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "pt-4", children: [
            tab === "search" && /* @__PURE__ */ jsxRuntimeExports.jsx(CardSearchBox, { catalog, config, mode: state.payoutMode, defaults: defaultVariant }),
            tab === "photo" && /* @__PURE__ */ jsxRuntimeExports.jsx(
              PhotoCapture,
              {
                cardsById,
                config,
                mode: state.payoutMode,
                defaults: defaultVariant,
                dailyLimit: photoDailyLimit,
                onSearchInstead: () => setTab("search"),
                loggedIn: !embedded || session.state !== "anonymous"
              }
            ),
            tab === "paste" && /* @__PURE__ */ jsxRuntimeExports.jsx(
              BuylistPanel,
              {
                catalog,
                config,
                mode: state.payoutMode,
                defaults: defaultVariant,
                subtotal: quote.subtotal,
                onOpenCard: setModalCardId
              }
            )
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "p",
            {
              className: "mt-6 rounded-lg bg-indigo-50 px-3 py-2 text-xs text-indigo-900",
              dangerouslySetInnerHTML: { __html: t("grid.priceNotice") }
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("aside", { className: "sticky top-4 hidden h-[calc(100vh-2rem)] w-96 shrink-0 flex-col overflow-hidden rounded-xl border border-neutral-200 bg-white lg:flex", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          BuybackCartPanel,
          {
            quote,
            config,
            otherModeDelta: delta,
            customerState: session.state,
            canSubmit,
            onSubmit: () => setSubmitOpen(true),
            onReview: () => setReviewOpen(true)
          }
        ) })
      ] }),
      (quote.cardCount > 0 || state.bulkKg > 0) && /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "button",
        {
          onClick: () => setCartOpen(true),
          "aria-label": t("app.openCart"),
          className: "fixed bottom-[16px] left-[12px] z-30 lg:hidden inline-flex items-center gap-[9px] rounded-full bg-[#0c1222] px-[16px] py-[11px] text-[14px] font-bold leading-none text-white shadow-[0_10px_26px_rgba(12,18,34,0.35)] transition hover:-translate-y-0.5 hover:bg-[#16203a] min-[750px]:bottom-[20px] min-[750px]:left-[20px] min-[750px]:px-[19px] min-[750px]:py-[12px]",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": true, className: "text-[18px] leading-none", children: "♻️" }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "inline-flex h-[22px] min-w-[22px] items-center justify-center rounded-full bg-white/15 px-[5px] text-[12px]", children: [
              quote.cardCount,
              state.bulkKg > 0 ? " + vrac" : ""
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: formatEur(quote.subtotal) })
          ]
        }
      ),
      cartOpen && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fixed inset-0 z-50", onMouseDown: (e) => e.target === e.currentTarget && setCartOpen(false), children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute inset-0 bg-neutral-900/50", onClick: () => setCartOpen(false) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("aside", { className: "absolute right-0 top-0 flex h-[100dvh] w-96 max-w-[94vw] flex-col overscroll-contain bg-white shadow-2xl", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: () => setCartOpen(false),
              className: "absolute right-3 top-3 z-10 rounded p-1 text-neutral-400 hover:bg-neutral-100",
              children: "✕"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            BuybackCartPanel,
            {
              quote,
              config,
              otherModeDelta: delta,
              customerState: session.state,
              canSubmit,
              onSubmit: () => {
                setCartOpen(false);
                setSubmitOpen(true);
              },
              onReview: () => {
                setCartOpen(false);
                setReviewOpen(true);
              }
            }
          )
        ] })
      ] }),
      reviewOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
        CartReviewModal,
        {
          quote,
          config,
          customerState: session.state,
          canSubmit,
          onClose: () => setReviewOpen(false),
          onSubmit: () => {
            setReviewOpen(false);
            setSubmitOpen(true);
          }
        }
      ),
      modalCard && /* @__PURE__ */ jsxRuntimeExports.jsx(
        CardOfferModal,
        {
          card: modalCard,
          config,
          mode: state.payoutMode,
          initialVariant: clampVariant(modalCard, defaultVariant),
          subtotal: quote.subtotal,
          onClose: () => setModalCardId(null)
        }
      ),
      guideOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(HowItWorksModal, { config, onClose: () => setGuideOpen(false) }),
      submitOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
        SubmitModal,
        {
          quote,
          config,
          simulate: !embedded,
          onClose: () => setSubmitOpen(false),
          onSubmitted: (result, email) => {
            setSubmitOpen(false);
            setConfirmation({ reference: result.reference, total: result.total, email });
          }
        }
      )
    ] });
  }
  function BuybackApp({
    catalog,
    remoteConfig,
    remoteSession,
    embedded = false
  }) {
    const [config, setConfig] = reactExports.useState(() => remoteConfig ?? loadConfig());
    const [session, setSession] = reactExports.useState(
      () => remoteSession ? { state: remoteSession, email: null } : loadSession()
    );
    const [configOpen, setConfigOpen] = reactExports.useState(false);
    const [door, setDoor] = reactExports.useState(null);
    const [simpleDone, setSimpleDone] = reactExports.useState(null);
    if (door === null || door !== "A_LA_CARTE") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BuybackCartProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "min-h-screen bg-neutral-50", children: door === null ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        ModeChooser,
        {
          config,
          remoteConfig,
          onChoose: (d) => {
            setSimpleDone(null);
            setDoor(d);
          }
        }
      ) : simpleDone ? /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: "mx-auto max-w-2xl px-4 py-16 text-center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-green-100 text-2xl", children: "✓" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "mt-5 text-2xl font-semibold text-neutral-900", children: t("simple.done.title") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-3 text-sm text-neutral-600", children: t("simple.done.body", {
          reference: simpleDone.reference,
          hours: config.reviewDelayHours ?? 24
        }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            type: "button",
            onClick: () => {
              setSimpleDone(null);
              setDoor(null);
            },
            className: "mt-6 text-sm text-indigo-700 hover:underline",
            children: t("door.back")
          }
        )
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
        SimpleSubmitForm,
        {
          mode: door,
          config,
          remoteConfig,
          simulate: !embedded,
          onBack: () => setDoor(null),
          onSubmitted: (reference, email) => setSimpleDone({ reference, email })
        }
      ) }) });
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(BuybackCartProvider, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Buyback,
        {
          catalog,
          config,
          session,
          embedded,
          photoDailyLimit: (remoteConfig == null ? void 0 : remoteConfig.photoDailyLimit) ?? (embedded ? 0 : 50),
          onBack: () => setDoor(null),
          onOpenConfig: () => setConfigOpen(true)
        }
      ),
      configOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
        ConfigPanel,
        {
          config,
          onChange: (c) => {
            saveConfig(c);
            setConfig(c);
          },
          onReset: () => {
            resetConfig();
            setConfig(loadConfig());
          },
          onClose: () => setConfigOpen(false),
          session,
          onSession: (s) => {
            saveSession(s);
            setSession(s);
          }
        }
      )
    ] });
  }
  const container = document.getElementById("buyback-root");
  async function boot(root) {
    root.innerHTML = `<p class="nm-buyback-loading">${t("boot.loading")}</p>`;
    try {
      const [catalog, config, session] = await Promise.all([
        fetchCatalog(),
        fetchConfig(),
        fetchEligibility()
      ]);
      if (!config.enabled) {
        root.innerHTML = `<p class="nm-buyback-loading">${t("boot.closed")}</p>`;
        return;
      }
      root.innerHTML = "";
      client.createRoot(root).render(
        /* @__PURE__ */ jsxRuntimeExports.jsx(React.StrictMode, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          BuybackApp,
          {
            catalog: catalog.cards,
            remoteConfig: config,
            remoteSession: session,
            embedded: true
          }
        ) })
      );
    } catch {
      root.innerHTML = `<p class="nm-buyback-loading">${t("boot.unavailable")}</p>`;
    }
  }
  if (container) void boot(container);
})();
